//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

// @ts-nocheck
/* eslint-disable */
// ReSharper disable InconsistentNaming

// Serializes a local Date as yyyy-MM-dd for OpenAPI `format: date` (server DateOnly) parameters —
// toISOString() would emit a datetime string DateOnly binding rejects and can shift the date across midnight UTC.
function formatDate_(d: Date): string {
    return d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate();
}

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IApiClient {
    get( cancelToken?: CancelToken): Promise<string>;
}

export class ApiClient implements IApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IApiConnectionApiClient {
    list( cancelToken?: CancelToken): Promise<ApiConnectionDto[]>;
    create(request: CreateApiConnectionRequest,  cancelToken?: CancelToken): Promise<ApiConnectionDto>;
    get(id: string,  cancelToken?: CancelToken): Promise<ApiConnectionDto>;
    update(id: string, request: UpdateApiConnectionRequest,  cancelToken?: CancelToken): Promise<ApiConnectionDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class ApiConnectionApiClient implements IApiConnectionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list( cancelToken?: CancelToken): Promise<ApiConnectionDto[]> {
        let url_ = this.baseUrl + "/api-connections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ApiConnectionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiConnectionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiConnectionDto[]>(null as any);
    }

    create(request: CreateApiConnectionRequest, cancelToken?: CancelToken): Promise<ApiConnectionDto> {
        let url_ = this.baseUrl + "/api-connections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiConnectionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiConnectionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiConnectionDto>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<ApiConnectionDto> {
        let url_ = this.baseUrl + "/api-connections/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiConnectionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiConnectionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiConnectionDto>(null as any);
    }

    update(id: string, request: UpdateApiConnectionRequest, cancelToken?: CancelToken): Promise<ApiConnectionDto> {
        let url_ = this.baseUrl + "/api-connections/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ApiConnectionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiConnectionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiConnectionDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api-connections/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IApplogsApiClient {
    /**
     * @param windowMinutes (optional) Length of the window ending at the server's current time; the client clock never shapes the query.
     * @param minLevel (optional) 
     * @param search (optional) Case-insensitive substring match against message, exception type and exception details.
     * @param limit (optional) 
     */
    queryApplogs(windowMinutes: number | undefined, minLevel: ApplogLevel | undefined, search: string | null | undefined, limit: number | undefined,  cancelToken?: CancelToken): Promise<ApplogsResultDto>;
}

export class ApplogsApiClient implements IApplogsApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param windowMinutes (optional) Length of the window ending at the server's current time; the client clock never shapes the query.
     * @param minLevel (optional) 
     * @param search (optional) Case-insensitive substring match against message, exception type and exception details.
     * @param limit (optional) 
     */
    queryApplogs(windowMinutes: number | undefined, minLevel: ApplogLevel | undefined, search: string | null | undefined, limit: number | undefined, cancelToken?: CancelToken): Promise<ApplogsResultDto> {
        let url_ = this.baseUrl + "/Applogs?";
        if (windowMinutes === null)
            throw new globalThis.Error("The parameter 'windowMinutes' cannot be null.");
        else if (windowMinutes !== undefined)
            url_ += "WindowMinutes=" + encodeURIComponent("" + windowMinutes) + "&";
        if (minLevel === null)
            throw new globalThis.Error("The parameter 'minLevel' cannot be null.");
        else if (minLevel !== undefined)
            url_ += "MinLevel=" + encodeURIComponent("" + minLevel) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryApplogs(_response);
        });
    }

    protected processQueryApplogs(response: AxiosResponse): Promise<ApplogsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApplogsResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplogsResultDto>(null as any);
    }
}

export interface IAttachmentApiClient {
    /**
     * Get a signed download URL for an attachment.
     */
    download(id: string,  cancelToken?: CancelToken): Promise<AttachmentDownloadResponse>;
    /**
     * Update the comment on an attachment.
     */
    updateComment(id: string, request: UpdateCommentRequest,  cancelToken?: CancelToken): Promise<AttachmentDto>;
    /**
     * Upload a file to temporary storage.
     * @param file (optional) 
     */
    uploadTempFile(typeId: string, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<AttachmentDto>;
    /**
     * Download a public product PDF (RFI, Transmittal, Change) without authentication.
     * @param token (optional) 
     */
    downloadPublicProduct(productType: string, productId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Download a single Change attachment via the Change's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or attachment mismatch.
     * @param token (optional) 
     */
    downloadChangeAttachment(changeId: string, attachmentId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Download a single Transmittal document via the Transmittal's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or document mismatch.
     * @param token (optional) 
     */
    downloadTransmittalAttachment(transmittalId: string, documentId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Download a single RFI attachment via the RFI's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or attachment mismatch.
     * @param token (optional) 
     */
    downloadRfiAttachment(rfiId: string, attachmentId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Download a single Submittal attachment via the Submittal's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or attachment mismatch.
     * @param token (optional) 
     */
    downloadSubmittalAttachment(submittalId: string, attachmentId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Download a single Drawing attachment via the Drawing's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or attachment mismatch.
     * @param token (optional) 
     */
    downloadDrawingAttachment(drawingId: string, attachmentId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class AttachmentApiClient implements IAttachmentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get a signed download URL for an attachment.
     */
    download(id: string, cancelToken?: CancelToken): Promise<AttachmentDownloadResponse> {
        let url_ = this.baseUrl + "/Attachment/download/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<AttachmentDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AttachmentDownloadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentDownloadResponse>(null as any);
    }

    /**
     * Update the comment on an attachment.
     */
    updateComment(id: string, request: UpdateCommentRequest, cancelToken?: CancelToken): Promise<AttachmentDto> {
        let url_ = this.baseUrl + "/Attachment/{id}/comment";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: AxiosResponse): Promise<AttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentDto>(null as any);
    }

    /**
     * Upload a file to temporary storage.
     * @param file (optional) 
     */
    uploadTempFile(typeId: string, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<AttachmentDto> {
        let url_ = this.baseUrl + "/Attachment/upload/tmp/{typeId}";
        if (typeId === undefined || typeId === null)
            throw new globalThis.Error("The parameter 'typeId' must be defined.");
        url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTempFile(_response);
        });
    }

    protected processUploadTempFile(response: AxiosResponse): Promise<AttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentDto>(null as any);
    }

    /**
     * Download a public product PDF (RFI, Transmittal, Change) without authentication.
     * @param token (optional) 
     */
    downloadPublicProduct(productType: string, productId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/external/{productType}/{productId}/attachment?";
        if (productType === undefined || productType === null)
            throw new globalThis.Error("The parameter 'productType' must be defined.");
        url_ = url_.replace("{productType}", encodeURIComponent("" + productType));
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadPublicProduct(_response);
        });
    }

    protected processDownloadPublicProduct(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Download a single Change attachment via the Change's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or attachment mismatch.
     * @param token (optional) 
     */
    downloadChangeAttachment(changeId: string, attachmentId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/external/change/{changeId}/attachment/{attachmentId}?";
        if (changeId === undefined || changeId === null)
            throw new globalThis.Error("The parameter 'changeId' must be defined.");
        url_ = url_.replace("{changeId}", encodeURIComponent("" + changeId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadChangeAttachment(_response);
        });
    }

    protected processDownloadChangeAttachment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Download a single Transmittal document via the Transmittal's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or document mismatch.
     * @param token (optional) 
     */
    downloadTransmittalAttachment(transmittalId: string, documentId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/external/transmittal/{transmittalId}/attachment/{documentId}?";
        if (transmittalId === undefined || transmittalId === null)
            throw new globalThis.Error("The parameter 'transmittalId' must be defined.");
        url_ = url_.replace("{transmittalId}", encodeURIComponent("" + transmittalId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadTransmittalAttachment(_response);
        });
    }

    protected processDownloadTransmittalAttachment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Download a single RFI attachment via the RFI's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or attachment mismatch.
     * @param token (optional) 
     */
    downloadRfiAttachment(rfiId: string, attachmentId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/external/rfi/{rfiId}/attachment/{attachmentId}?";
        if (rfiId === undefined || rfiId === null)
            throw new globalThis.Error("The parameter 'rfiId' must be defined.");
        url_ = url_.replace("{rfiId}", encodeURIComponent("" + rfiId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadRfiAttachment(_response);
        });
    }

    protected processDownloadRfiAttachment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Download a single Submittal attachment via the Submittal's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or attachment mismatch.
     * @param token (optional) 
     */
    downloadSubmittalAttachment(submittalId: string, attachmentId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/external/submittal/{submittalId}/attachment/{attachmentId}?";
        if (submittalId === undefined || submittalId === null)
            throw new globalThis.Error("The parameter 'submittalId' must be defined.");
        url_ = url_.replace("{submittalId}", encodeURIComponent("" + submittalId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSubmittalAttachment(_response);
        });
    }

    protected processDownloadSubmittalAttachment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Download a single Drawing attachment via the Drawing's external access token.
    Redirects (302) to a short-lived SAS. Returns 404 on invalid token or attachment mismatch.
     * @param token (optional) 
     */
    downloadDrawingAttachment(drawingId: string, attachmentId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/external/drawing/{drawingId}/attachment/{attachmentId}?";
        if (drawingId === undefined || drawingId === null)
            throw new globalThis.Error("The parameter 'drawingId' must be defined.");
        url_ = url_.replace("{drawingId}", encodeURIComponent("" + drawingId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDrawingAttachment(_response);
        });
    }

    protected processDownloadDrawingAttachment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IAzureGroupSyncApiClient {
    getStatus( cancelToken?: CancelToken): Promise<AzureGroupSyncStatusDto>;
    testConnection( cancelToken?: CancelToken): Promise<AzureGroupSyncTestResult>;
    fullSync( cancelToken?: CancelToken): Promise<FileResponse | null>;
    listMappings( cancelToken?: CancelToken): Promise<AzureGroupScopeMappingDto[]>;
    createMapping(request: CreateAzureGroupScopeMappingRequest,  cancelToken?: CancelToken): Promise<AzureGroupScopeMappingDto>;
    updateMapping(id: string, request: UpdateAzureGroupScopeMappingRequest,  cancelToken?: CancelToken): Promise<AzureGroupScopeMappingDto>;
    deleteMapping(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    listMemberships( cancelToken?: CancelToken): Promise<AzureGroupUserMembershipDto[]>;
    getLogs(page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<AzureGroupSyncLogResponse>;
}

export class AzureGroupSyncApiClient implements IAzureGroupSyncApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStatus( cancelToken?: CancelToken): Promise<AzureGroupSyncStatusDto> {
        let url_ = this.baseUrl + "/azure-group-sync/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<AzureGroupSyncStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AzureGroupSyncStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureGroupSyncStatusDto>(null as any);
    }

    testConnection( cancelToken?: CancelToken): Promise<AzureGroupSyncTestResult> {
        let url_ = this.baseUrl + "/azure-group-sync/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestConnection(_response);
        });
    }

    protected processTestConnection(response: AxiosResponse): Promise<AzureGroupSyncTestResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AzureGroupSyncTestResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureGroupSyncTestResult>(null as any);
    }

    fullSync( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/azure-group-sync/full-sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFullSync(_response);
        });
    }

    protected processFullSync(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listMappings( cancelToken?: CancelToken): Promise<AzureGroupScopeMappingDto[]> {
        let url_ = this.baseUrl + "/azure-group-sync/mappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMappings(_response);
        });
    }

    protected processListMappings(response: AxiosResponse): Promise<AzureGroupScopeMappingDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AzureGroupScopeMappingDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureGroupScopeMappingDto[]>(null as any);
    }

    createMapping(request: CreateAzureGroupScopeMappingRequest, cancelToken?: CancelToken): Promise<AzureGroupScopeMappingDto> {
        let url_ = this.baseUrl + "/azure-group-sync/mappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMapping(_response);
        });
    }

    protected processCreateMapping(response: AxiosResponse): Promise<AzureGroupScopeMappingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AzureGroupScopeMappingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureGroupScopeMappingDto>(null as any);
    }

    updateMapping(id: string, request: UpdateAzureGroupScopeMappingRequest, cancelToken?: CancelToken): Promise<AzureGroupScopeMappingDto> {
        let url_ = this.baseUrl + "/azure-group-sync/mappings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMapping(_response);
        });
    }

    protected processUpdateMapping(response: AxiosResponse): Promise<AzureGroupScopeMappingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AzureGroupScopeMappingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureGroupScopeMappingDto>(null as any);
    }

    deleteMapping(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/azure-group-sync/mappings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMapping(_response);
        });
    }

    protected processDeleteMapping(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listMemberships( cancelToken?: CancelToken): Promise<AzureGroupUserMembershipDto[]> {
        let url_ = this.baseUrl + "/azure-group-sync/memberships";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMemberships(_response);
        });
    }

    protected processListMemberships(response: AxiosResponse): Promise<AzureGroupUserMembershipDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AzureGroupUserMembershipDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureGroupUserMembershipDto[]>(null as any);
    }

    getLogs(page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<AzureGroupSyncLogResponse> {
        let url_ = this.baseUrl + "/azure-group-sync/logs?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogs(_response);
        });
    }

    protected processGetLogs(response: AxiosResponse): Promise<AzureGroupSyncLogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AzureGroupSyncLogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureGroupSyncLogResponse>(null as any);
    }
}

export interface IBackgroundJobsApiClient {
    getOverview( cancelToken?: CancelToken): Promise<BackgroundJobOverviewDto>;
    getServers( cancelToken?: CancelToken): Promise<BackgroundJobServerDto[]>;
    getJobs(state: BackgroundJobStateFilter | undefined, page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<BackgroundJobPageDto>;
    getJob(id: string,  cancelToken?: CancelToken): Promise<BackgroundJobDetailDto>;
    deleteJob(id: string,  cancelToken?: CancelToken): Promise<void>;
    getRecurringJobs( cancelToken?: CancelToken): Promise<RecurringBackgroundJobDto[]>;
    requeueJob(id: string,  cancelToken?: CancelToken): Promise<void>;
    triggerRecurringJob(id: string,  cancelToken?: CancelToken): Promise<void>;
}

export class BackgroundJobsApiClient implements IBackgroundJobsApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOverview( cancelToken?: CancelToken): Promise<BackgroundJobOverviewDto> {
        let url_ = this.baseUrl + "/background-jobs/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOverview(_response);
        });
    }

    protected processGetOverview(response: AxiosResponse): Promise<BackgroundJobOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BackgroundJobOverviewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackgroundJobOverviewDto>(null as any);
    }

    getServers( cancelToken?: CancelToken): Promise<BackgroundJobServerDto[]> {
        let url_ = this.baseUrl + "/background-jobs/servers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServers(_response);
        });
    }

    protected processGetServers(response: AxiosResponse): Promise<BackgroundJobServerDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BackgroundJobServerDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackgroundJobServerDto[]>(null as any);
    }

    getJobs(state: BackgroundJobStateFilter | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<BackgroundJobPageDto> {
        let url_ = this.baseUrl + "/background-jobs/jobs?";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobs(_response);
        });
    }

    protected processGetJobs(response: AxiosResponse): Promise<BackgroundJobPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BackgroundJobPageDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackgroundJobPageDto>(null as any);
    }

    getJob(id: string, cancelToken?: CancelToken): Promise<BackgroundJobDetailDto> {
        let url_ = this.baseUrl + "/background-jobs/jobs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJob(_response);
        });
    }

    protected processGetJob(response: AxiosResponse): Promise<BackgroundJobDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BackgroundJobDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackgroundJobDetailDto>(null as any);
    }

    deleteJob(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/background-jobs/jobs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteJob(_response);
        });
    }

    protected processDeleteJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRecurringJobs( cancelToken?: CancelToken): Promise<RecurringBackgroundJobDto[]> {
        let url_ = this.baseUrl + "/background-jobs/recurring";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecurringJobs(_response);
        });
    }

    protected processGetRecurringJobs(response: AxiosResponse): Promise<RecurringBackgroundJobDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecurringBackgroundJobDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecurringBackgroundJobDto[]>(null as any);
    }

    requeueJob(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/background-jobs/jobs/{id}/requeue";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequeueJob(_response);
        });
    }

    protected processRequeueJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    triggerRecurringJob(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/background-jobs/recurring/{id}/trigger";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerRecurringJob(_response);
        });
    }

    protected processTriggerRecurringJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IChangeApiClient {
    /**
     * Get all Changes for a job
     */
    getChangesByJob(jobId: number,  cancelToken?: CancelToken): Promise<ChangeDto[]>;
    /**
     * Create or update a Change
     */
    createOrUpdateChange(jobId: number, request: ChangeRequestDto,  cancelToken?: CancelToken): Promise<ChangeDto>;
    /**
     * Get a specific Change by ID
     */
    getChangeById(jobId: number, changeId: string,  cancelToken?: CancelToken): Promise<ChangeDto>;
    /**
     * Rotate the Change's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, changeId: string,  cancelToken?: CancelToken): Promise<ChangeDto>;
    /**
     * Get Change by ID for external users (no auth required)
     * @param token (optional) 
     */
    getExternalChange(changeId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<ChangeDto>;
    /**
     * Update Change from external user
     * @param token (optional) 
     */
    updateExternalChange(changeId: string, token: string | null | undefined, request: ChangeExternalUpdateDto,  cancelToken?: CancelToken): Promise<ChangeDto>;
    /**
     * Upload a temporary attachment file
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Get job documents that can be attached to a Change: non-folder, non-archived documents,
    excluding the generated "Change Orders" folder.
     */
    getDocumentOptions(jobId: number,  cancelToken?: CancelToken): Promise<ChangeDocumentOptionDto[]>;
    /**
     * Clone an existing job document into a temporary Change attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: AttachFromDocumentRequest,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Get all Change Order PDF links for a job
     */
    getAllChangePdfLinks(jobId: number,  cancelToken?: CancelToken): Promise<ChangePdfLinkDto[]>;
    /**
     * Generate PDF for a Change Order
     */
    generateChangePdf(jobId: number, changeId: string,  cancelToken?: CancelToken): Promise<PdfResult>;
    /**
     * Render a Change Order PDF for preview without storing a document version.
     */
    previewChangePdf(jobId: number, changeId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Render the printable Change Order Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getChangeOrderLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class ChangeApiClient implements IChangeApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all Changes for a job
     */
    getChangesByJob(jobId: number, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/Change/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangesByJob(_response);
        });
    }

    protected processGetChangesByJob(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }

    /**
     * Create or update a Change
     */
    createOrUpdateChange(jobId: number, request: ChangeRequestDto, cancelToken?: CancelToken): Promise<ChangeDto> {
        let url_ = this.baseUrl + "/Change/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateChange(_response);
        });
    }

    protected processCreateOrUpdateChange(response: AxiosResponse): Promise<ChangeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto>(null as any);
    }

    /**
     * Get a specific Change by ID
     */
    getChangeById(jobId: number, changeId: string, cancelToken?: CancelToken): Promise<ChangeDto> {
        let url_ = this.baseUrl + "/Change/job/{jobId}/{changeId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (changeId === undefined || changeId === null)
            throw new globalThis.Error("The parameter 'changeId' must be defined.");
        url_ = url_.replace("{changeId}", encodeURIComponent("" + changeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangeById(_response);
        });
    }

    protected processGetChangeById(response: AxiosResponse): Promise<ChangeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto>(null as any);
    }

    /**
     * Rotate the Change's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, changeId: string, cancelToken?: CancelToken): Promise<ChangeDto> {
        let url_ = this.baseUrl + "/Change/job/{jobId}/{changeId}/external-access/rotate";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (changeId === undefined || changeId === null)
            throw new globalThis.Error("The parameter 'changeId' must be defined.");
        url_ = url_.replace("{changeId}", encodeURIComponent("" + changeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRotateExternalAccess(_response);
        });
    }

    protected processRotateExternalAccess(response: AxiosResponse): Promise<ChangeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto>(null as any);
    }

    /**
     * Get Change by ID for external users (no auth required)
     * @param token (optional) 
     */
    getExternalChange(changeId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<ChangeDto> {
        let url_ = this.baseUrl + "/Change/external/{changeId}?";
        if (changeId === undefined || changeId === null)
            throw new globalThis.Error("The parameter 'changeId' must be defined.");
        url_ = url_.replace("{changeId}", encodeURIComponent("" + changeId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalChange(_response);
        });
    }

    protected processGetExternalChange(response: AxiosResponse): Promise<ChangeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto>(null as any);
    }

    /**
     * Update Change from external user
     * @param token (optional) 
     */
    updateExternalChange(changeId: string, token: string | null | undefined, request: ChangeExternalUpdateDto, cancelToken?: CancelToken): Promise<ChangeDto> {
        let url_ = this.baseUrl + "/Change/external/{changeId}?";
        if (changeId === undefined || changeId === null)
            throw new globalThis.Error("The parameter 'changeId' must be defined.");
        url_ = url_.replace("{changeId}", encodeURIComponent("" + changeId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExternalChange(_response);
        });
    }

    protected processUpdateExternalChange(response: AxiosResponse): Promise<ChangeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto>(null as any);
    }

    /**
     * Upload a temporary attachment file
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Change/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (category !== null && category !== undefined)
            content_.append("category", category.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTempFile(_response);
        });
    }

    protected processUploadTempFile(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Get job documents that can be attached to a Change: non-folder, non-archived documents,
    excluding the generated "Change Orders" folder.
     */
    getDocumentOptions(jobId: number, cancelToken?: CancelToken): Promise<ChangeDocumentOptionDto[]> {
        let url_ = this.baseUrl + "/Change/job/{jobId}/document-options";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentOptions(_response);
        });
    }

    protected processGetDocumentOptions(response: AxiosResponse): Promise<ChangeDocumentOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeDocumentOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDocumentOptionDto[]>(null as any);
    }

    /**
     * Clone an existing job document into a temporary Change attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: AttachFromDocumentRequest, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Change/job/{jobId}/attach-from-document";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAttachFromDocument(_response);
        });
    }

    protected processAttachFromDocument(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Get all Change Order PDF links for a job
     */
    getAllChangePdfLinks(jobId: number, cancelToken?: CancelToken): Promise<ChangePdfLinkDto[]> {
        let url_ = this.baseUrl + "/Change/job/{jobId}/pdf-links";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllChangePdfLinks(_response);
        });
    }

    protected processGetAllChangePdfLinks(response: AxiosResponse): Promise<ChangePdfLinkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangePdfLinkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangePdfLinkDto[]>(null as any);
    }

    /**
     * Generate PDF for a Change Order
     */
    generateChangePdf(jobId: number, changeId: string, cancelToken?: CancelToken): Promise<PdfResult> {
        let url_ = this.baseUrl + "/Change/job/{jobId}/{changeId}/pdf";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (changeId === undefined || changeId === null)
            throw new globalThis.Error("The parameter 'changeId' must be defined.");
        url_ = url_.replace("{changeId}", encodeURIComponent("" + changeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateChangePdf(_response);
        });
    }

    protected processGenerateChangePdf(response: AxiosResponse): Promise<PdfResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PdfResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PdfResult>(null as any);
    }

    /**
     * Render a Change Order PDF for preview without storing a document version.
     */
    previewChangePdf(jobId: number, changeId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Change/job/{jobId}/{changeId}/pdf/preview";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (changeId === undefined || changeId === null)
            throw new globalThis.Error("The parameter 'changeId' must be defined.");
        url_ = url_.replace("{changeId}", encodeURIComponent("" + changeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewChangePdf(_response);
        });
    }

    protected processPreviewChangePdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Render the printable Change Order Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getChangeOrderLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Change/job/{jobId}/log/pdf?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (submittedToContactId !== undefined && submittedToContactId !== null)
            url_ += "submittedToContactId=" + encodeURIComponent("" + submittedToContactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangeOrderLogPdf(_response);
        });
    }

    protected processGetChangeOrderLogPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IChangesOverviewApiClient {
    /**
     * Get all Changes across every job the caller can see, for the cross-job overview page.
     */
    getChanges( cancelToken?: CancelToken): Promise<ChangeOverviewDto[]>;
}

export class ChangesOverviewApiClient implements IChangesOverviewApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all Changes across every job the caller can see, for the cross-job overview page.
     */
    getChanges( cancelToken?: CancelToken): Promise<ChangeOverviewDto[]> {
        let url_ = this.baseUrl + "/changes/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChanges(_response);
        });
    }

    protected processGetChanges(response: AxiosResponse): Promise<ChangeOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeOverviewDto[]>(null as any);
    }
}

export interface IChangeTemplateApiClient {
    /**
     * List all change templates, filtered by office for non-admin users
     */
    index( cancelToken?: CancelToken): Promise<ChangeTemplateDto[]>;
    /**
     * Create a new change template
     */
    create(request: ChangeTemplateRequestDto,  cancelToken?: CancelToken): Promise<ChangeTemplateDto>;
    /**
     * Get a single change template by ID
     */
    getById(id: string,  cancelToken?: CancelToken): Promise<ChangeTemplateDto>;
    /**
     * Update an existing change template
     */
    update(id: string, request: ChangeTemplateRequestDto,  cancelToken?: CancelToken): Promise<ChangeTemplateDto>;
    /**
     * Delete a change template. Templates still attached to a job are archived instead so the
    job keeps its rate sheets; archived templates are excluded from the list.
     */
    delete(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class ChangeTemplateApiClient implements IChangeTemplateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all change templates, filtered by office for non-admin users
     */
    index( cancelToken?: CancelToken): Promise<ChangeTemplateDto[]> {
        let url_ = this.baseUrl + "/ChangeTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<ChangeTemplateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeTemplateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTemplateDto[]>(null as any);
    }

    /**
     * Create a new change template
     */
    create(request: ChangeTemplateRequestDto, cancelToken?: CancelToken): Promise<ChangeTemplateDto> {
        let url_ = this.baseUrl + "/ChangeTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ChangeTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTemplateDto>(null as any);
    }

    /**
     * Get a single change template by ID
     */
    getById(id: string, cancelToken?: CancelToken): Promise<ChangeTemplateDto> {
        let url_ = this.baseUrl + "/ChangeTemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ChangeTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTemplateDto>(null as any);
    }

    /**
     * Update an existing change template
     */
    update(id: string, request: ChangeTemplateRequestDto, cancelToken?: CancelToken): Promise<ChangeTemplateDto> {
        let url_ = this.baseUrl + "/ChangeTemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ChangeTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTemplateDto>(null as any);
    }

    /**
     * Delete a change template. Templates still attached to a job are archived instead so the
    job keeps its rate sheets; archived templates are excluded from the list.
     */
    delete(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ChangeTemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IChangeTypeApiClient {
    list(req: ChangeTypeListRequest,  cancelToken?: CancelToken): Promise<ChangeTypeDto[]>;
    get(id: string,  cancelToken?: CancelToken): Promise<ChangeTypeDto>;
    update(id: string, request: ChangeTypeRequestDto,  cancelToken?: CancelToken): Promise<ChangeTypeDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    create(request: ChangeTypeRequestDto,  cancelToken?: CancelToken): Promise<ChangeTypeDto>;
}

export class ChangeTypeApiClient implements IChangeTypeApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(req: ChangeTypeListRequest, cancelToken?: CancelToken): Promise<ChangeTypeDto[]> {
        let url_ = this.baseUrl + "/ChangeType/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ChangeTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTypeDto[]>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<ChangeTypeDto> {
        let url_ = this.baseUrl + "/ChangeType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ChangeTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTypeDto>(null as any);
    }

    update(id: string, request: ChangeTypeRequestDto, cancelToken?: CancelToken): Promise<ChangeTypeDto> {
        let url_ = this.baseUrl + "/ChangeType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ChangeTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTypeDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ChangeType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(request: ChangeTypeRequestDto, cancelToken?: CancelToken): Promise<ChangeTypeDto> {
        let url_ = this.baseUrl + "/ChangeType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ChangeTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChangeTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTypeDto>(null as any);
    }
}

export interface IChatbotApiClient {
    createConversation(request: CreateConversationRequestDto,  cancelToken?: CancelToken): Promise<ChatConversationSummaryDto>;
    listConversations(page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<PagedResultOfChatConversationSummaryDto>;
    getConversation(id: string,  cancelToken?: CancelToken): Promise<ChatConversationDto>;
    deleteConversation(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Starts a new conversation from the active messages before user message MessageId.
    404 when the conversation or message is not found, 400 when the message is not a user message.
     */
    forkConversation(id: string, request: ForkConversationRequestDto,  cancelToken?: CancelToken): Promise<ChatConversationDto>;
    renameConversation(id: string, request: UpdateConversationTitleRequestDto,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Runs a reply's query again under the caller's current access and returns the rows as a CSV file, capped at
    ExportMaxRows rows. When the cap cut rows off, X-Row-Limit-Reached holds the cap.
     */
    exportQueryCsv(id: string, auditId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    setMessageFeedback(id: string, request: SetMessageFeedbackRequestDto,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    deleteMessageFeedback(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    getUsage( cancelToken?: CancelToken): Promise<ChatUsageDto>;
    /**
     * The frontend does not call this at runtime; it exists so the generated client includes
    ChatEntityKind.
     */
    getEntityKinds( cancelToken?: CancelToken): Promise<ChatEntityKind[]>;
    /**
     * The frontend does not call this at runtime; it exists so the generated client includes
    ChatStreamEvent, the events StreamMessage sends.
     */
    getStreamEventSchema( cancelToken?: CancelToken): Promise<ChatStreamEvent>;
    /**
     * @param userId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param search (optional) Case-insensitive match against conversation title, owning user's name, and the context's page value.
     * @param hasNegativeFeedback (optional) true = only conversations with at least one "down" vote, false = only conversations with none, null = all.
     * @param page (optional) 
     * @param pageSize (optional) 
     */
    listAllConversations(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, search: string | null | undefined, hasNegativeFeedback: boolean | null | undefined, page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<PagedResultOfAdminConversationDto>;
    getAnyConversation(id: string,  cancelToken?: CancelToken): Promise<AdminConversationDetailDto>;
    /**
     * @param userId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param accepted (optional) true = only accepted queries, false = only rejected, null = all.
     * @param page (optional) 
     * @param pageSize (optional) 
     */
    getSqlAudit(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, accepted: boolean | null | undefined, page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<PagedResultOfSqlToolAuditDto>;
    getUsageSummary(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<PagedResultOfAdminUsageDto>;
    getStatsOverview(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined,  cancelToken?: CancelToken): Promise<AdminStatsOverviewDto>;
    getStatsDaily(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined,  cancelToken?: CancelToken): Promise<AdminStatsDailyPointDto[]>;
    getStatsByUser(from: Date | null | undefined, to: Date | null | undefined,  cancelToken?: CancelToken): Promise<AdminUserStatsDto[]>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param userId (optional) Conversation owner.
     * @param from (optional) Earliest vote date (updated_at, UTC), not the message date.
     * @param to (optional) Latest vote date (updated_at, UTC), inclusive of the whole day.
     * @param search (optional) Case-insensitive match against the comment, the question that preceded the rated reply, and the owning user's name.
     * @param rating (optional) "up", "down", or null for both.
     * @param reasons (optional) When non-empty, only "down" votes with one of these reasons match.
     */
    listFeedback(page: number | undefined, pageSize: number | undefined, userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, search: string | null | undefined, rating: string | null | undefined, reasons: string[] | null | undefined,  cancelToken?: CancelToken): Promise<AdminFeedbackPageDto>;
    /**
     * The filtered votes as a CSV file, newest first, capped at MaxExportRows rows.
     * @param userId (optional) Conversation owner.
     * @param from (optional) Earliest vote date (updated_at, UTC), not the message date.
     * @param to (optional) Latest vote date (updated_at, UTC), inclusive of the whole day.
     * @param search (optional) Case-insensitive match against the comment, the question that preceded the rated reply, and the owning user's name.
     * @param rating (optional) "up", "down", or null for both.
     * @param reasons (optional) When non-empty, only "down" votes with one of these reasons match.
     */
    exportFeedback(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, search: string | null | undefined, rating: string | null | undefined, reasons: string[] | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class ChatbotApiClient implements IChatbotApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createConversation(request: CreateConversationRequestDto, cancelToken?: CancelToken): Promise<ChatConversationSummaryDto> {
        let url_ = this.baseUrl + "/Chatbot/conversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateConversation(_response);
        });
    }

    protected processCreateConversation(response: AxiosResponse): Promise<ChatConversationSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatConversationSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatConversationSummaryDto>(null as any);
    }

    listConversations(page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResultOfChatConversationSummaryDto> {
        let url_ = this.baseUrl + "/Chatbot/conversations?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListConversations(_response);
        });
    }

    protected processListConversations(response: AxiosResponse): Promise<PagedResultOfChatConversationSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedResultOfChatConversationSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultOfChatConversationSummaryDto>(null as any);
    }

    getConversation(id: string, cancelToken?: CancelToken): Promise<ChatConversationDto> {
        let url_ = this.baseUrl + "/Chatbot/conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConversation(_response);
        });
    }

    protected processGetConversation(response: AxiosResponse): Promise<ChatConversationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatConversationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatConversationDto>(null as any);
    }

    deleteConversation(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Chatbot/conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConversation(_response);
        });
    }

    protected processDeleteConversation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Starts a new conversation from the active messages before user message MessageId.
    404 when the conversation or message is not found, 400 when the message is not a user message.
     */
    forkConversation(id: string, request: ForkConversationRequestDto, cancelToken?: CancelToken): Promise<ChatConversationDto> {
        let url_ = this.baseUrl + "/Chatbot/conversations/{id}/fork";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForkConversation(_response);
        });
    }

    protected processForkConversation(response: AxiosResponse): Promise<ChatConversationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatConversationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatConversationDto>(null as any);
    }

    renameConversation(id: string, request: UpdateConversationTitleRequestDto, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Chatbot/conversations/{id}/title";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameConversation(_response);
        });
    }

    protected processRenameConversation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Runs a reply's query again under the caller's current access and returns the rows as a CSV file, capped at
    ExportMaxRows rows. When the cap cut rows off, X-Row-Limit-Reached holds the cap.
     */
    exportQueryCsv(id: string, auditId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Chatbot/conversations/{id}/queries/{auditId}/csv";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (auditId === undefined || auditId === null)
            throw new globalThis.Error("The parameter 'auditId' must be defined.");
        url_ = url_.replace("{auditId}", encodeURIComponent("" + auditId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportQueryCsv(_response);
        });
    }

    protected processExportQueryCsv(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    setMessageFeedback(id: string, request: SetMessageFeedbackRequestDto, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Chatbot/messages/{id}/feedback";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMessageFeedback(_response);
        });
    }

    protected processSetMessageFeedback(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteMessageFeedback(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Chatbot/messages/{id}/feedback";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMessageFeedback(_response);
        });
    }

    protected processDeleteMessageFeedback(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getUsage( cancelToken?: CancelToken): Promise<ChatUsageDto> {
        let url_ = this.baseUrl + "/Chatbot/usage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsage(_response);
        });
    }

    protected processGetUsage(response: AxiosResponse): Promise<ChatUsageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatUsageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatUsageDto>(null as any);
    }

    /**
     * The frontend does not call this at runtime; it exists so the generated client includes
    ChatEntityKind.
     */
    getEntityKinds( cancelToken?: CancelToken): Promise<ChatEntityKind[]> {
        let url_ = this.baseUrl + "/Chatbot/entity-kinds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntityKinds(_response);
        });
    }

    protected processGetEntityKinds(response: AxiosResponse): Promise<ChatEntityKind[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatEntityKind[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatEntityKind[]>(null as any);
    }

    /**
     * The frontend does not call this at runtime; it exists so the generated client includes
    ChatStreamEvent, the events StreamMessage sends.
     */
    getStreamEventSchema( cancelToken?: CancelToken): Promise<ChatStreamEvent> {
        let url_ = this.baseUrl + "/Chatbot/stream-event-schema";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStreamEventSchema(_response);
        });
    }

    protected processGetStreamEventSchema(response: AxiosResponse): Promise<ChatStreamEvent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatStreamEvent>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatStreamEvent>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param search (optional) Case-insensitive match against conversation title, owning user's name, and the context's page value.
     * @param hasNegativeFeedback (optional) true = only conversations with at least one "down" vote, false = only conversations with none, null = all.
     * @param page (optional) 
     * @param pageSize (optional) 
     */
    listAllConversations(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, search: string | null | undefined, hasNegativeFeedback: boolean | null | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResultOfAdminConversationDto> {
        let url_ = this.baseUrl + "/Chatbot/admin/conversations?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (hasNegativeFeedback !== undefined && hasNegativeFeedback !== null)
            url_ += "HasNegativeFeedback=" + encodeURIComponent("" + hasNegativeFeedback) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAllConversations(_response);
        });
    }

    protected processListAllConversations(response: AxiosResponse): Promise<PagedResultOfAdminConversationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedResultOfAdminConversationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultOfAdminConversationDto>(null as any);
    }

    getAnyConversation(id: string, cancelToken?: CancelToken): Promise<AdminConversationDetailDto> {
        let url_ = this.baseUrl + "/Chatbot/admin/conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnyConversation(_response);
        });
    }

    protected processGetAnyConversation(response: AxiosResponse): Promise<AdminConversationDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AdminConversationDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminConversationDetailDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param accepted (optional) true = only accepted queries, false = only rejected, null = all.
     * @param page (optional) 
     * @param pageSize (optional) 
     */
    getSqlAudit(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, accepted: boolean | null | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResultOfSqlToolAuditDto> {
        let url_ = this.baseUrl + "/Chatbot/admin/sql-audit?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (accepted !== undefined && accepted !== null)
            url_ += "Accepted=" + encodeURIComponent("" + accepted) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSqlAudit(_response);
        });
    }

    protected processGetSqlAudit(response: AxiosResponse): Promise<PagedResultOfSqlToolAuditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedResultOfSqlToolAuditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultOfSqlToolAuditDto>(null as any);
    }

    getUsageSummary(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResultOfAdminUsageDto> {
        let url_ = this.baseUrl + "/Chatbot/admin/usage?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? formatDate_(from) : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? formatDate_(to) : "") + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsageSummary(_response);
        });
    }

    protected processGetUsageSummary(response: AxiosResponse): Promise<PagedResultOfAdminUsageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedResultOfAdminUsageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultOfAdminUsageDto>(null as any);
    }

    getStatsOverview(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, cancelToken?: CancelToken): Promise<AdminStatsOverviewDto> {
        let url_ = this.baseUrl + "/Chatbot/admin/stats/overview?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? formatDate_(from) : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? formatDate_(to) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatsOverview(_response);
        });
    }

    protected processGetStatsOverview(response: AxiosResponse): Promise<AdminStatsOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AdminStatsOverviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminStatsOverviewDto>(null as any);
    }

    getStatsDaily(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, cancelToken?: CancelToken): Promise<AdminStatsDailyPointDto[]> {
        let url_ = this.baseUrl + "/Chatbot/admin/stats/daily?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? formatDate_(from) : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? formatDate_(to) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatsDaily(_response);
        });
    }

    protected processGetStatsDaily(response: AxiosResponse): Promise<AdminStatsDailyPointDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AdminStatsDailyPointDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminStatsDailyPointDto[]>(null as any);
    }

    getStatsByUser(from: Date | null | undefined, to: Date | null | undefined, cancelToken?: CancelToken): Promise<AdminUserStatsDto[]> {
        let url_ = this.baseUrl + "/Chatbot/admin/stats/users?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? formatDate_(from) : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? formatDate_(to) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatsByUser(_response);
        });
    }

    protected processGetStatsByUser(response: AxiosResponse): Promise<AdminUserStatsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AdminUserStatsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminUserStatsDto[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param userId (optional) Conversation owner.
     * @param from (optional) Earliest vote date (updated_at, UTC), not the message date.
     * @param to (optional) Latest vote date (updated_at, UTC), inclusive of the whole day.
     * @param search (optional) Case-insensitive match against the comment, the question that preceded the rated reply, and the owning user's name.
     * @param rating (optional) "up", "down", or null for both.
     * @param reasons (optional) When non-empty, only "down" votes with one of these reasons match.
     */
    listFeedback(page: number | undefined, pageSize: number | undefined, userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, search: string | null | undefined, rating: string | null | undefined, reasons: string[] | null | undefined, cancelToken?: CancelToken): Promise<AdminFeedbackPageDto> {
        let url_ = this.baseUrl + "/Chatbot/admin/feedback?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? formatDate_(from) : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? formatDate_(to) : "") + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (rating !== undefined && rating !== null)
            url_ += "Rating=" + encodeURIComponent("" + rating) + "&";
        if (reasons !== undefined && reasons !== null)
            reasons && reasons.forEach(item => { url_ += "Reasons=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFeedback(_response);
        });
    }

    protected processListFeedback(response: AxiosResponse): Promise<AdminFeedbackPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AdminFeedbackPageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminFeedbackPageDto>(null as any);
    }

    /**
     * The filtered votes as a CSV file, newest first, capped at MaxExportRows rows.
     * @param userId (optional) Conversation owner.
     * @param from (optional) Earliest vote date (updated_at, UTC), not the message date.
     * @param to (optional) Latest vote date (updated_at, UTC), inclusive of the whole day.
     * @param search (optional) Case-insensitive match against the comment, the question that preceded the rated reply, and the owning user's name.
     * @param rating (optional) "up", "down", or null for both.
     * @param reasons (optional) When non-empty, only "down" votes with one of these reasons match.
     */
    exportFeedback(userId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined, search: string | null | undefined, rating: string | null | undefined, reasons: string[] | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Chatbot/admin/feedback/export?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? formatDate_(from) : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? formatDate_(to) : "") + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (rating !== undefined && rating !== null)
            url_ += "Rating=" + encodeURIComponent("" + rating) + "&";
        if (reasons !== undefined && reasons !== null)
            reasons && reasons.forEach(item => { url_ += "Reasons=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportFeedback(_response);
        });
    }

    protected processExportFeedback(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IChatMemoryApiClient {
    list( cancelToken?: CancelToken): Promise<ChatMemoryListDto>;
    /**
     * Saves an active note with source "manual".
     */
    create(request: ChatMemoryRequestDto,  cancelToken?: CancelToken): Promise<ChatMemoryDto>;
    deleteAll( cancelToken?: CancelToken): Promise<FileResponse | null>;
    setEnabled(request: SetChatMemoryEnabledRequestDto,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Only an active note can be edited.
     */
    update(id: number, request: ChatMemoryRequestDto,  cancelToken?: CancelToken): Promise<ChatMemoryDto>;
    delete(id: number,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Keeps a note that F.I.R.E. suggested. Only a proposed note can be accepted.
     */
    accept(id: number,  cancelToken?: CancelToken): Promise<ChatMemoryDto>;
    /**
     * Only a proposed note can be declined.
     */
    decline(id: number,  cancelToken?: CancelToken): Promise<ChatMemoryDto>;
    listForUser(userId: number,  cancelToken?: CancelToken): Promise<ChatMemoryListDto>;
    deleteForUser(userId: number, id: number,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class ChatMemoryApiClient implements IChatMemoryApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list( cancelToken?: CancelToken): Promise<ChatMemoryListDto> {
        let url_ = this.baseUrl + "/ChatMemory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ChatMemoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatMemoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatMemoryListDto>(null as any);
    }

    /**
     * Saves an active note with source "manual".
     */
    create(request: ChatMemoryRequestDto, cancelToken?: CancelToken): Promise<ChatMemoryDto> {
        let url_ = this.baseUrl + "/ChatMemory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ChatMemoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatMemoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatMemoryDto>(null as any);
    }

    deleteAll( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ChatMemory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    setEnabled(request: SetChatMemoryEnabledRequestDto, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ChatMemory/enabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetEnabled(_response);
        });
    }

    protected processSetEnabled(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Only an active note can be edited.
     */
    update(id: number, request: ChatMemoryRequestDto, cancelToken?: CancelToken): Promise<ChatMemoryDto> {
        let url_ = this.baseUrl + "/ChatMemory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ChatMemoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatMemoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatMemoryDto>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ChatMemory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Keeps a note that F.I.R.E. suggested. Only a proposed note can be accepted.
     */
    accept(id: number, cancelToken?: CancelToken): Promise<ChatMemoryDto> {
        let url_ = this.baseUrl + "/ChatMemory/{id}/accept";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: AxiosResponse): Promise<ChatMemoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatMemoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatMemoryDto>(null as any);
    }

    /**
     * Only a proposed note can be declined.
     */
    decline(id: number, cancelToken?: CancelToken): Promise<ChatMemoryDto> {
        let url_ = this.baseUrl + "/ChatMemory/{id}/decline";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDecline(_response);
        });
    }

    protected processDecline(response: AxiosResponse): Promise<ChatMemoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatMemoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatMemoryDto>(null as any);
    }

    listForUser(userId: number, cancelToken?: CancelToken): Promise<ChatMemoryListDto> {
        let url_ = this.baseUrl + "/ChatMemory/admin/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForUser(_response);
        });
    }

    protected processListForUser(response: AxiosResponse): Promise<ChatMemoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ChatMemoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatMemoryListDto>(null as any);
    }

    deleteForUser(userId: number, id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/ChatMemory/admin/users/{userId}/{id}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteForUser(_response);
        });
    }

    protected processDeleteForUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IClassificationApiClient {
    list(req: ClassificationListRequest,  cancelToken?: CancelToken): Promise<ClassificationDto[]>;
    get(id: string,  cancelToken?: CancelToken): Promise<ClassificationDto>;
    update(id: string, request: ClassificationRequestDto,  cancelToken?: CancelToken): Promise<ClassificationDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<ClassificationDto>;
    create(request: ClassificationRequestDto,  cancelToken?: CancelToken): Promise<ClassificationDto>;
}

export class ClassificationApiClient implements IClassificationApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(req: ClassificationListRequest, cancelToken?: CancelToken): Promise<ClassificationDto[]> {
        let url_ = this.baseUrl + "/Classification/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ClassificationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClassificationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassificationDto[]>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<ClassificationDto> {
        let url_ = this.baseUrl + "/Classification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ClassificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClassificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassificationDto>(null as any);
    }

    update(id: string, request: ClassificationRequestDto, cancelToken?: CancelToken): Promise<ClassificationDto> {
        let url_ = this.baseUrl + "/Classification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ClassificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClassificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassificationDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ClassificationDto> {
        let url_ = this.baseUrl + "/Classification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ClassificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClassificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassificationDto>(null as any);
    }

    create(request: ClassificationRequestDto, cancelToken?: CancelToken): Promise<ClassificationDto> {
        let url_ = this.baseUrl + "/Classification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ClassificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClassificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassificationDto>(null as any);
    }
}

export interface IClientApiClient {
    /**
     * Get all customers from GreatPlains (MSSQL) with optional search
     * @param query (optional) 
     */
    getClients(query: string | null | undefined,  cancelToken?: CancelToken): Promise<ClientGpDto[]>;
    /**
     * Search customers from GreatPlains (MSSQL) with limit of 100
     * @param query (optional) 
     */
    searchClients(query: string | null | undefined,  cancelToken?: CancelToken): Promise<ClientGpDto[]>;
    /**
     * Get a customer by CustNumber from GreatPlains (MSSQL)
     */
    getClientById(id: string,  cancelToken?: CancelToken): Promise<ClientGpDto>;
    /**
     * Create a client in Firetrol (PostgreSQL)
     */
    create(request: ClientRequestDto,  cancelToken?: CancelToken): Promise<ClientDto>;
}

export class ClientApiClient implements IClientApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all customers from GreatPlains (MSSQL) with optional search
     * @param query (optional) 
     */
    getClients(query: string | null | undefined, cancelToken?: CancelToken): Promise<ClientGpDto[]> {
        let url_ = this.baseUrl + "/Client/customers?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClients(_response);
        });
    }

    protected processGetClients(response: AxiosResponse): Promise<ClientGpDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientGpDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientGpDto[]>(null as any);
    }

    /**
     * Search customers from GreatPlains (MSSQL) with limit of 100
     * @param query (optional) 
     */
    searchClients(query: string | null | undefined, cancelToken?: CancelToken): Promise<ClientGpDto[]> {
        let url_ = this.baseUrl + "/Client/customers/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchClients(_response);
        });
    }

    protected processSearchClients(response: AxiosResponse): Promise<ClientGpDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientGpDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientGpDto[]>(null as any);
    }

    /**
     * Get a customer by CustNumber from GreatPlains (MSSQL)
     */
    getClientById(id: string, cancelToken?: CancelToken): Promise<ClientGpDto> {
        let url_ = this.baseUrl + "/Client/customers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientById(_response);
        });
    }

    protected processGetClientById(response: AxiosResponse): Promise<ClientGpDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientGpDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientGpDto>(null as any);
    }

    /**
     * Create a client in Firetrol (PostgreSQL)
     */
    create(request: ClientRequestDto, cancelToken?: CancelToken): Promise<ClientDto> {
        let url_ = this.baseUrl + "/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientDto>(null as any);
    }
}

export interface IContactApiClient {
    list(req: ContactListRequest,  cancelToken?: CancelToken): Promise<ContactDto[]>;
    get(id: string,  cancelToken?: CancelToken): Promise<ContactDto>;
    update(id: string, request: ContactRequestDto,  cancelToken?: CancelToken): Promise<ContactDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<ContactDto>;
    create(request: ContactRequestDto,  cancelToken?: CancelToken): Promise<ContactDto>;
}

export class ContactApiClient implements IContactApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(req: ContactListRequest, cancelToken?: CancelToken): Promise<ContactDto[]> {
        let url_ = this.baseUrl + "/Contact/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ContactDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContactDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto[]>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<ContactDto> {
        let url_ = this.baseUrl + "/Contact/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContactDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto>(null as any);
    }

    update(id: string, request: ContactRequestDto, cancelToken?: CancelToken): Promise<ContactDto> {
        let url_ = this.baseUrl + "/Contact/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContactDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<ContactDto> {
        let url_ = this.baseUrl + "/Contact/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContactDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto>(null as any);
    }

    create(request: ContactRequestDto, cancelToken?: CancelToken): Promise<ContactDto> {
        let url_ = this.baseUrl + "/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContactDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto>(null as any);
    }
}

export interface ICTCAdjustmentApiClient {
    getAdjustments(jobNumber: string,  cancelToken?: CancelToken): Promise<CcAdjustmentDto>;
    createCostCodeAdjustment(jobNumber: string, request: CreateCostCodeAdjustmentRequest,  cancelToken?: CancelToken): Promise<CcAdjustmentDto>;
    getAdjustmentHistory(jobNumber: string,  cancelToken?: CancelToken): Promise<CcAdjustmentHistoryDto[]>;
}

export class CTCAdjustmentApiClient implements ICTCAdjustmentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAdjustments(jobNumber: string, cancelToken?: CancelToken): Promise<CcAdjustmentDto> {
        let url_ = this.baseUrl + "/CTCAdjustment/{jobNumber}/adjustments";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdjustments(_response);
        });
    }

    protected processGetAdjustments(response: AxiosResponse): Promise<CcAdjustmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CcAdjustmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CcAdjustmentDto>(null as any);
    }

    createCostCodeAdjustment(jobNumber: string, request: CreateCostCodeAdjustmentRequest, cancelToken?: CancelToken): Promise<CcAdjustmentDto> {
        let url_ = this.baseUrl + "/CTCAdjustment/{jobNumber}/adjustments";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCostCodeAdjustment(_response);
        });
    }

    protected processCreateCostCodeAdjustment(response: AxiosResponse): Promise<CcAdjustmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CcAdjustmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CcAdjustmentDto>(null as any);
    }

    getAdjustmentHistory(jobNumber: string, cancelToken?: CancelToken): Promise<CcAdjustmentHistoryDto[]> {
        let url_ = this.baseUrl + "/CTCAdjustment/{jobNumber}/adjustment-history";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdjustmentHistory(_response);
        });
    }

    protected processGetAdjustmentHistory(response: AxiosResponse): Promise<CcAdjustmentHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CcAdjustmentHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CcAdjustmentHistoryDto[]>(null as any);
    }
}

export interface ICTCApiClient {
    getCurrentMonthDetails( cancelToken?: CancelToken): Promise<IntegrationStatusDto>;
    listClosedCTC( cancelToken?: CancelToken): Promise<JobSummaryDto[]>;
    nextCTC(jobNumber: string, filters: CtcNextPreviousRequest,  cancelToken?: CancelToken): Promise<NextPreviousJobResponse>;
    listCTCWithFilters(filters: CtcListFiltersRequest,  cancelToken?: CancelToken): Promise<CtcListResponse>;
    listCTCDivisions( cancelToken?: CancelToken): Promise<DivisionDto[]>;
    getOrCreateCTCDivision(division: string,  cancelToken?: CancelToken): Promise<DivisionDto>;
    loadLinkedJobs( cancelToken?: CancelToken): Promise<string[]>;
    getInvoiceData(jobNumber: string,  cancelToken?: CancelToken): Promise<JobPoDataDto[]>;
    getChangeOrderData(jobNumber: string,  cancelToken?: CancelToken): Promise<JobChangeOrderDto[]>;
    getJobMaterialsWithCostCode(jobNumber: string, costCode: string,  cancelToken?: CancelToken): Promise<{ [key: string]: JobPoDataDto[]; }>;
    getJobMaterialsByCostCode(jobNumber: string,  cancelToken?: CancelToken): Promise<{ [key: string]: JobPoDataDto[]; }>;
    getJobMaterialsTotal(jobNumber: string,  cancelToken?: CancelToken): Promise<JobMaterialsTotalResponse>;
    getJobBreakdown(jobNumber: string, costCode: string,  cancelToken?: CancelToken): Promise<{ [key: string]: JobCostDetailDto[]; }>;
    syncCTCJobMetadata(jobNumber: string,  cancelToken?: CancelToken): Promise<JobDto>;
    getCTCJobById(jobNumber: string,  cancelToken?: CancelToken): Promise<CtcJobDetailResponse>;
}

export class CTCApiClient implements ICTCApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCurrentMonthDetails( cancelToken?: CancelToken): Promise<IntegrationStatusDto> {
        let url_ = this.baseUrl + "/CTC/current-month-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentMonthDetails(_response);
        });
    }

    protected processGetCurrentMonthDetails(response: AxiosResponse): Promise<IntegrationStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IntegrationStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationStatusDto>(null as any);
    }

    listClosedCTC( cancelToken?: CancelToken): Promise<JobSummaryDto[]> {
        let url_ = this.baseUrl + "/CTC/closed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListClosedCTC(_response);
        });
    }

    protected processListClosedCTC(response: AxiosResponse): Promise<JobSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobSummaryDto[]>(null as any);
    }

    nextCTC(jobNumber: string, filters: CtcNextPreviousRequest, cancelToken?: CancelToken): Promise<NextPreviousJobResponse> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}/next";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNextCTC(_response);
        });
    }

    protected processNextCTC(response: AxiosResponse): Promise<NextPreviousJobResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NextPreviousJobResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NextPreviousJobResponse>(null as any);
    }

    listCTCWithFilters(filters: CtcListFiltersRequest, cancelToken?: CancelToken): Promise<CtcListResponse> {
        let url_ = this.baseUrl + "/CTC/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCTCWithFilters(_response);
        });
    }

    protected processListCTCWithFilters(response: AxiosResponse): Promise<CtcListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CtcListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CtcListResponse>(null as any);
    }

    listCTCDivisions( cancelToken?: CancelToken): Promise<DivisionDto[]> {
        let url_ = this.baseUrl + "/CTC/divisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCTCDivisions(_response);
        });
    }

    protected processListCTCDivisions(response: AxiosResponse): Promise<DivisionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DivisionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DivisionDto[]>(null as any);
    }

    getOrCreateCTCDivision(division: string, cancelToken?: CancelToken): Promise<DivisionDto> {
        let url_ = this.baseUrl + "/CTC/division/{division}";
        if (division === undefined || division === null)
            throw new globalThis.Error("The parameter 'division' must be defined.");
        url_ = url_.replace("{division}", encodeURIComponent("" + division));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrCreateCTCDivision(_response);
        });
    }

    protected processGetOrCreateCTCDivision(response: AxiosResponse): Promise<DivisionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DivisionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DivisionDto>(null as any);
    }

    loadLinkedJobs( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/CTC/linked-jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadLinkedJobs(_response);
        });
    }

    protected processLoadLinkedJobs(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getInvoiceData(jobNumber: string, cancelToken?: CancelToken): Promise<JobPoDataDto[]> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}/invoice-data";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceData(_response);
        });
    }

    protected processGetInvoiceData(response: AxiosResponse): Promise<JobPoDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobPoDataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobPoDataDto[]>(null as any);
    }

    getChangeOrderData(jobNumber: string, cancelToken?: CancelToken): Promise<JobChangeOrderDto[]> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}/change-orders";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangeOrderData(_response);
        });
    }

    protected processGetChangeOrderData(response: AxiosResponse): Promise<JobChangeOrderDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobChangeOrderDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobChangeOrderDto[]>(null as any);
    }

    getJobMaterialsWithCostCode(jobNumber: string, costCode: string, cancelToken?: CancelToken): Promise<{ [key: string]: JobPoDataDto[]; }> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}/materials/{costCode}";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        if (costCode === undefined || costCode === null)
            throw new globalThis.Error("The parameter 'costCode' must be defined.");
        url_ = url_.replace("{costCode}", encodeURIComponent("" + costCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobMaterialsWithCostCode(_response);
        });
    }

    protected processGetJobMaterialsWithCostCode(response: AxiosResponse): Promise<{ [key: string]: JobPoDataDto[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: JobPoDataDto[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: JobPoDataDto[]; }>(null as any);
    }

    getJobMaterialsByCostCode(jobNumber: string, cancelToken?: CancelToken): Promise<{ [key: string]: JobPoDataDto[]; }> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}/materials-by-costcode";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobMaterialsByCostCode(_response);
        });
    }

    protected processGetJobMaterialsByCostCode(response: AxiosResponse): Promise<{ [key: string]: JobPoDataDto[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: JobPoDataDto[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: JobPoDataDto[]; }>(null as any);
    }

    getJobMaterialsTotal(jobNumber: string, cancelToken?: CancelToken): Promise<JobMaterialsTotalResponse> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}/materials-total";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobMaterialsTotal(_response);
        });
    }

    protected processGetJobMaterialsTotal(response: AxiosResponse): Promise<JobMaterialsTotalResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobMaterialsTotalResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobMaterialsTotalResponse>(null as any);
    }

    getJobBreakdown(jobNumber: string, costCode: string, cancelToken?: CancelToken): Promise<{ [key: string]: JobCostDetailDto[]; }> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}/breakdown/{costCode}";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        if (costCode === undefined || costCode === null)
            throw new globalThis.Error("The parameter 'costCode' must be defined.");
        url_ = url_.replace("{costCode}", encodeURIComponent("" + costCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobBreakdown(_response);
        });
    }

    protected processGetJobBreakdown(response: AxiosResponse): Promise<{ [key: string]: JobCostDetailDto[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: JobCostDetailDto[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: JobCostDetailDto[]; }>(null as any);
    }

    syncCTCJobMetadata(jobNumber: string, cancelToken?: CancelToken): Promise<JobDto> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}/sync-metadata";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncCTCJobMetadata(_response);
        });
    }

    protected processSyncCTCJobMetadata(response: AxiosResponse): Promise<JobDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto>(null as any);
    }

    getCTCJobById(jobNumber: string, cancelToken?: CancelToken): Promise<CtcJobDetailResponse> {
        let url_ = this.baseUrl + "/CTC/{jobNumber}";
        if (jobNumber === undefined || jobNumber === null)
            throw new globalThis.Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCTCJobById(_response);
        });
    }

    protected processGetCTCJobById(response: AxiosResponse): Promise<CtcJobDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CtcJobDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CtcJobDetailResponse>(null as any);
    }
}

export interface IDailyApiClient {
    list(request: ListDailiesRequest,  cancelToken?: CancelToken): Promise<DailyDto[]>;
    get(id: string,  cancelToken?: CancelToken): Promise<DailyDto>;
    update(id: string, request: DailyRequestDto,  cancelToken?: CancelToken): Promise<DailyDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<boolean>;
    create(request: DailyRequestDto,  cancelToken?: CancelToken): Promise<DailyDto>;
    summarizeDesignProgress(request: DailyDesignProgressSummaryRequestDto,  cancelToken?: CancelToken): Promise<DailyDesignProgressSummaryDto[]>;
    listUserAudit(request: UserDailiesAuditRequest,  cancelToken?: CancelToken): Promise<UserDailiesAuditResponse[]>;
}

export class DailyApiClient implements IDailyApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: ListDailiesRequest, cancelToken?: CancelToken): Promise<DailyDto[]> {
        let url_ = this.baseUrl + "/Daily/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<DailyDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyDto[]>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<DailyDto> {
        let url_ = this.baseUrl + "/Daily/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DailyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyDto>(null as any);
    }

    update(id: string, request: DailyRequestDto, cancelToken?: CancelToken): Promise<DailyDto> {
        let url_ = this.baseUrl + "/Daily/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<DailyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Daily/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    create(request: DailyRequestDto, cancelToken?: CancelToken): Promise<DailyDto> {
        let url_ = this.baseUrl + "/Daily";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DailyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyDto>(null as any);
    }

    summarizeDesignProgress(request: DailyDesignProgressSummaryRequestDto, cancelToken?: CancelToken): Promise<DailyDesignProgressSummaryDto[]> {
        let url_ = this.baseUrl + "/Daily/design-progress-summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummarizeDesignProgress(_response);
        });
    }

    protected processSummarizeDesignProgress(response: AxiosResponse): Promise<DailyDesignProgressSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyDesignProgressSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyDesignProgressSummaryDto[]>(null as any);
    }

    listUserAudit(request: UserDailiesAuditRequest, cancelToken?: CancelToken): Promise<UserDailiesAuditResponse[]> {
        let url_ = this.baseUrl + "/Daily/list/user-audit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUserAudit(_response);
        });
    }

    protected processListUserAudit(response: AxiosResponse): Promise<UserDailiesAuditResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDailiesAuditResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDailiesAuditResponse[]>(null as any);
    }
}

export interface IDailyProgressApiClient {
    /**
     * Get all daily progress items for a job
     */
    getProgressItems(jobId: number,  cancelToken?: CancelToken): Promise<DailyProgressHistoryDto[]>;
    /**
     * Create daily progress items for a job
     */
    createProgressItems(jobId: number, request: DailyProgressItemsRequestDto,  cancelToken?: CancelToken): Promise<DailyProgressHistoryDto[]>;
}

export class DailyProgressApiClient implements IDailyProgressApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all daily progress items for a job
     */
    getProgressItems(jobId: number, cancelToken?: CancelToken): Promise<DailyProgressHistoryDto[]> {
        let url_ = this.baseUrl + "/jobs/{jobId}/daily-progress";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProgressItems(_response);
        });
    }

    protected processGetProgressItems(response: AxiosResponse): Promise<DailyProgressHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyProgressHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyProgressHistoryDto[]>(null as any);
    }

    /**
     * Create daily progress items for a job
     */
    createProgressItems(jobId: number, request: DailyProgressItemsRequestDto, cancelToken?: CancelToken): Promise<DailyProgressHistoryDto[]> {
        let url_ = this.baseUrl + "/jobs/{jobId}/daily-progress";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProgressItems(_response);
        });
    }

    protected processCreateProgressItems(response: AxiosResponse): Promise<DailyProgressHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyProgressHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyProgressHistoryDto[]>(null as any);
    }
}

export interface IDailyQuestionApiClient {
    list(req: ListQuestionsRequest,  cancelToken?: CancelToken): Promise<DailyQuestionDto[]>;
    get(id: number,  cancelToken?: CancelToken): Promise<DailyQuestionDto>;
    update(id: number, request: DailyQuestionRequestDto,  cancelToken?: CancelToken): Promise<DailyQuestionDto>;
    delete(id: number,  cancelToken?: CancelToken): Promise<boolean>;
    create(request: DailyQuestionRequestDto,  cancelToken?: CancelToken): Promise<DailyQuestionDto>;
}

export class DailyQuestionApiClient implements IDailyQuestionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(req: ListQuestionsRequest, cancelToken?: CancelToken): Promise<DailyQuestionDto[]> {
        let url_ = this.baseUrl + "/DailyQuestion/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<DailyQuestionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyQuestionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyQuestionDto[]>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<DailyQuestionDto> {
        let url_ = this.baseUrl + "/DailyQuestion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DailyQuestionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyQuestionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyQuestionDto>(null as any);
    }

    update(id: number, request: DailyQuestionRequestDto, cancelToken?: CancelToken): Promise<DailyQuestionDto> {
        let url_ = this.baseUrl + "/DailyQuestion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<DailyQuestionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyQuestionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyQuestionDto>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/DailyQuestion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    create(request: DailyQuestionRequestDto, cancelToken?: CancelToken): Promise<DailyQuestionDto> {
        let url_ = this.baseUrl + "/DailyQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DailyQuestionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyQuestionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyQuestionDto>(null as any);
    }
}

export interface IDailySettingApiClient {
    get( cancelToken?: CancelToken): Promise<DailySettingDto>;
    update(request: DailySettingRequestDto,  cancelToken?: CancelToken): Promise<DailySettingDto>;
}

export class DailySettingApiClient implements IDailySettingApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get( cancelToken?: CancelToken): Promise<DailySettingDto> {
        let url_ = this.baseUrl + "/DailySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DailySettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailySettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailySettingDto>(null as any);
    }

    update(request: DailySettingRequestDto, cancelToken?: CancelToken): Promise<DailySettingDto> {
        let url_ = this.baseUrl + "/DailySetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<DailySettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailySettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailySettingDto>(null as any);
    }
}

export interface IDefaultFolderApiClient {
    createTemplate( cancelToken?: CancelToken): Promise<FolderTemplateDto>;
    updateTemplate(templateId: string, request: FolderTemplateRequestDto,  cancelToken?: CancelToken): Promise<FolderTemplateDto>;
    removeTemplate(templateId: string,  cancelToken?: CancelToken): Promise<FolderTemplateDto>;
    getTemplateById(templateId: string,  cancelToken?: CancelToken): Promise<FolderTemplateWithFoldersDto>;
    getTemplates( cancelToken?: CancelToken): Promise<FolderTemplateDto[]>;
    createTemplateFolder(templateId: string, request: DefaultFolderRequestDto,  cancelToken?: CancelToken): Promise<DefaultFolderDto>;
    createFolder(request: DefaultFolderRequestDto,  cancelToken?: CancelToken): Promise<DefaultFolderDto>;
    updateFolder(folderId: string, request: DefaultFolderRequestDto,  cancelToken?: CancelToken): Promise<DefaultFolderDto>;
    removeFolder(folderId: string,  cancelToken?: CancelToken): Promise<DefaultFolderDto>;
}

export class DefaultFolderApiClient implements IDefaultFolderApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createTemplate( cancelToken?: CancelToken): Promise<FolderTemplateDto> {
        let url_ = this.baseUrl + "/DefaultFolder/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTemplate(_response);
        });
    }

    protected processCreateTemplate(response: AxiosResponse): Promise<FolderTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FolderTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderTemplateDto>(null as any);
    }

    updateTemplate(templateId: string, request: FolderTemplateRequestDto, cancelToken?: CancelToken): Promise<FolderTemplateDto> {
        let url_ = this.baseUrl + "/DefaultFolder/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTemplate(_response);
        });
    }

    protected processUpdateTemplate(response: AxiosResponse): Promise<FolderTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FolderTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderTemplateDto>(null as any);
    }

    removeTemplate(templateId: string, cancelToken?: CancelToken): Promise<FolderTemplateDto> {
        let url_ = this.baseUrl + "/DefaultFolder/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveTemplate(_response);
        });
    }

    protected processRemoveTemplate(response: AxiosResponse): Promise<FolderTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FolderTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderTemplateDto>(null as any);
    }

    getTemplateById(templateId: string, cancelToken?: CancelToken): Promise<FolderTemplateWithFoldersDto> {
        let url_ = this.baseUrl + "/DefaultFolder/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateById(_response);
        });
    }

    protected processGetTemplateById(response: AxiosResponse): Promise<FolderTemplateWithFoldersDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FolderTemplateWithFoldersDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderTemplateWithFoldersDto>(null as any);
    }

    getTemplates( cancelToken?: CancelToken): Promise<FolderTemplateDto[]> {
        let url_ = this.baseUrl + "/DefaultFolder/templates/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplates(_response);
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<FolderTemplateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FolderTemplateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderTemplateDto[]>(null as any);
    }

    createTemplateFolder(templateId: string, request: DefaultFolderRequestDto, cancelToken?: CancelToken): Promise<DefaultFolderDto> {
        let url_ = this.baseUrl + "/DefaultFolder/templates/{templateId}/folders";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTemplateFolder(_response);
        });
    }

    protected processCreateTemplateFolder(response: AxiosResponse): Promise<DefaultFolderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DefaultFolderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultFolderDto>(null as any);
    }

    createFolder(request: DefaultFolderRequestDto, cancelToken?: CancelToken): Promise<DefaultFolderDto> {
        let url_ = this.baseUrl + "/DefaultFolder/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFolder(_response);
        });
    }

    protected processCreateFolder(response: AxiosResponse): Promise<DefaultFolderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DefaultFolderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultFolderDto>(null as any);
    }

    updateFolder(folderId: string, request: DefaultFolderRequestDto, cancelToken?: CancelToken): Promise<DefaultFolderDto> {
        let url_ = this.baseUrl + "/DefaultFolder/folders/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new globalThis.Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFolder(_response);
        });
    }

    protected processUpdateFolder(response: AxiosResponse): Promise<DefaultFolderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DefaultFolderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultFolderDto>(null as any);
    }

    removeFolder(folderId: string, cancelToken?: CancelToken): Promise<DefaultFolderDto> {
        let url_ = this.baseUrl + "/DefaultFolder/folders/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new globalThis.Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFolder(_response);
        });
    }

    protected processRemoveFolder(response: AxiosResponse): Promise<DefaultFolderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DefaultFolderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultFolderDto>(null as any);
    }
}

export interface IDesignModelApiClient {
    list(jobId: number,  cancelToken?: CancelToken): Promise<DesignModelDto[]>;
    get(id: string,  cancelToken?: CancelToken): Promise<DesignModelDto>;
    update(id: string, request: DesignModelRequestDto,  cancelToken?: CancelToken): Promise<DesignModelDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<boolean>;
    create(request: DesignModelRequestDto,  cancelToken?: CancelToken): Promise<DesignModelDto>;
    download(id: string,  cancelToken?: CancelToken): Promise<DownloadUrlDto>;
    getIfc(id: string,  cancelToken?: CancelToken): Promise<DesignModelDto>;
    getGrouping(id: string,  cancelToken?: CancelToken): Promise<LineGroupingDto>;
    applyGroupingOverrides(id: string, request: ApplyGroupingOverridesRequest,  cancelToken?: CancelToken): Promise<ProgressGroupingOverrideDto[]>;
    resetGroupingOverrides(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    reprocess(id: string,  cancelToken?: CancelToken): Promise<DesignModelDto>;
    getLaborAccounts(jobId: number,  cancelToken?: CancelToken): Promise<WbsAccountOptionDto[]>;
}

export class DesignModelApiClient implements IDesignModelApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(jobId: number, cancelToken?: CancelToken): Promise<DesignModelDto[]> {
        let url_ = this.baseUrl + "/DesignModel/list/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<DesignModelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DesignModelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DesignModelDto[]>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<DesignModelDto> {
        let url_ = this.baseUrl + "/DesignModel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DesignModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DesignModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DesignModelDto>(null as any);
    }

    update(id: string, request: DesignModelRequestDto, cancelToken?: CancelToken): Promise<DesignModelDto> {
        let url_ = this.baseUrl + "/DesignModel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<DesignModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DesignModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DesignModelDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/DesignModel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    create(request: DesignModelRequestDto, cancelToken?: CancelToken): Promise<DesignModelDto> {
        let url_ = this.baseUrl + "/DesignModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DesignModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DesignModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DesignModelDto>(null as any);
    }

    download(id: string, cancelToken?: CancelToken): Promise<DownloadUrlDto> {
        let url_ = this.baseUrl + "/DesignModel/{id}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<DownloadUrlDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DownloadUrlDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadUrlDto>(null as any);
    }

    getIfc(id: string, cancelToken?: CancelToken): Promise<DesignModelDto> {
        let url_ = this.baseUrl + "/DesignModel/{id}/ifc";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIfc(_response);
        });
    }

    protected processGetIfc(response: AxiosResponse): Promise<DesignModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DesignModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DesignModelDto>(null as any);
    }

    getGrouping(id: string, cancelToken?: CancelToken): Promise<LineGroupingDto> {
        let url_ = this.baseUrl + "/DesignModel/{id}/grouping";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGrouping(_response);
        });
    }

    protected processGetGrouping(response: AxiosResponse): Promise<LineGroupingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LineGroupingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LineGroupingDto>(null as any);
    }

    applyGroupingOverrides(id: string, request: ApplyGroupingOverridesRequest, cancelToken?: CancelToken): Promise<ProgressGroupingOverrideDto[]> {
        let url_ = this.baseUrl + "/DesignModel/{id}/grouping/overrides";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyGroupingOverrides(_response);
        });
    }

    protected processApplyGroupingOverrides(response: AxiosResponse): Promise<ProgressGroupingOverrideDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProgressGroupingOverrideDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressGroupingOverrideDto[]>(null as any);
    }

    resetGroupingOverrides(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/DesignModel/{id}/grouping/overrides";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetGroupingOverrides(_response);
        });
    }

    protected processResetGroupingOverrides(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    reprocess(id: string, cancelToken?: CancelToken): Promise<DesignModelDto> {
        let url_ = this.baseUrl + "/DesignModel/{id}/reprocess";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReprocess(_response);
        });
    }

    protected processReprocess(response: AxiosResponse): Promise<DesignModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DesignModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DesignModelDto>(null as any);
    }

    getLaborAccounts(jobId: number, cancelToken?: CancelToken): Promise<WbsAccountOptionDto[]> {
        let url_ = this.baseUrl + "/DesignModel/labor-accounts/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLaborAccounts(_response);
        });
    }

    protected processGetLaborAccounts(response: AxiosResponse): Promise<WbsAccountOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAccountOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAccountOptionDto[]>(null as any);
    }
}

export interface IDesignProgressApiClient {
    updateStatus(jobId: number, request: UpdateProgressItemRequest,  cancelToken?: CancelToken): Promise<ProgressItemDto>;
    sync(jobId: number, items: UpdateProgressItemRequest[],  cancelToken?: CancelToken): Promise<ProgressItemDto[]>;
}

export class DesignProgressApiClient implements IDesignProgressApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    updateStatus(jobId: number, request: UpdateProgressItemRequest, cancelToken?: CancelToken): Promise<ProgressItemDto> {
        let url_ = this.baseUrl + "/jobs/{jobId}/progress/status";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<ProgressItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProgressItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressItemDto>(null as any);
    }

    sync(jobId: number, items: UpdateProgressItemRequest[], cancelToken?: CancelToken): Promise<ProgressItemDto[]> {
        let url_ = this.baseUrl + "/jobs/{jobId}/progress/sync";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSync(_response);
        });
    }

    protected processSync(response: AxiosResponse): Promise<ProgressItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProgressItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressItemDto[]>(null as any);
    }
}

export interface IDocumentApiClient {
    listFolders(jobId: number,  cancelToken?: CancelToken): Promise<DocumentDto[]>;
    listFoldersInParent(jobId: number, folderId: string,  cancelToken?: CancelToken): Promise<DocumentDto[]>;
    createFolder(jobId: number, request: FolderRequestDto,  cancelToken?: CancelToken): Promise<DocumentDto>;
    updateFolder(jobId: number, folderId: string, request: FolderRequestDto,  cancelToken?: CancelToken): Promise<DocumentDto>;
    removeFolder(jobId: number, folderId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    listDocumentsInFolder(jobId: number, folderId: string,  cancelToken?: CancelToken): Promise<DocumentDto[]>;
    listDocuments(jobId: number,  cancelToken?: CancelToken): Promise<DocumentDto[]>;
    getDocumentById(jobId: number, documentId: string,  cancelToken?: CancelToken): Promise<DocumentDto>;
    updateDocument(jobId: number, documentId: string, request: DocumentUpdateRequest,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    removeDocument(jobId: number, documentId: string,  cancelToken?: CancelToken): Promise<DocumentDto>;
    uploadFile(jobId: number, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<DocumentDto>;
    uploadFileToFolder(jobId: number, parentId: string, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<DocumentDto>;
    uploadDocumentVersion(jobId: number, documentId: string, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<DocumentDto>;
    downloadDocument(jobId: number, documentId: string,  cancelToken?: CancelToken): Promise<DocumentDownloadResponse>;
    downloadVersionDocument(jobId: number, versionId: string,  cancelToken?: CancelToken): Promise<DocumentDownloadResponse>;
}

export class DocumentApiClient implements IDocumentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listFolders(jobId: number, cancelToken?: CancelToken): Promise<DocumentDto[]> {
        let url_ = this.baseUrl + "/jobs/{jobId}/folders";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFolders(_response);
        });
    }

    protected processListFolders(response: AxiosResponse): Promise<DocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto[]>(null as any);
    }

    listFoldersInParent(jobId: number, folderId: string, cancelToken?: CancelToken): Promise<DocumentDto[]> {
        let url_ = this.baseUrl + "/jobs/{jobId}/folders/{folderId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (folderId === undefined || folderId === null)
            throw new globalThis.Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFoldersInParent(_response);
        });
    }

    protected processListFoldersInParent(response: AxiosResponse): Promise<DocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto[]>(null as any);
    }

    createFolder(jobId: number, request: FolderRequestDto, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/folders";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFolder(_response);
        });
    }

    protected processCreateFolder(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    updateFolder(jobId: number, folderId: string, request: FolderRequestDto, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/folders/{folderId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (folderId === undefined || folderId === null)
            throw new globalThis.Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFolder(_response);
        });
    }

    protected processUpdateFolder(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    removeFolder(jobId: number, folderId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/folders/{folderId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (folderId === undefined || folderId === null)
            throw new globalThis.Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFolder(_response);
        });
    }

    protected processRemoveFolder(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listDocumentsInFolder(jobId: number, folderId: string, cancelToken?: CancelToken): Promise<DocumentDto[]> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/folders/{folderId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (folderId === undefined || folderId === null)
            throw new globalThis.Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListDocumentsInFolder(_response);
        });
    }

    protected processListDocumentsInFolder(response: AxiosResponse): Promise<DocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto[]>(null as any);
    }

    listDocuments(jobId: number, cancelToken?: CancelToken): Promise<DocumentDto[]> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListDocuments(_response);
        });
    }

    protected processListDocuments(response: AxiosResponse): Promise<DocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto[]>(null as any);
    }

    getDocumentById(jobId: number, documentId: string, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/{documentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentById(_response);
        });
    }

    protected processGetDocumentById(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    updateDocument(jobId: number, documentId: string, request: DocumentUpdateRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/{documentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDocument(_response);
        });
    }

    protected processUpdateDocument(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    removeDocument(jobId: number, documentId: string, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/{documentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveDocument(_response);
        });
    }

    protected processRemoveDocument(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    uploadFile(jobId: number, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/upload";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    uploadFileToFolder(jobId: number, parentId: string, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/upload/{parentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (parentId === undefined || parentId === null)
            throw new globalThis.Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFileToFolder(_response);
        });
    }

    protected processUploadFileToFolder(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    uploadDocumentVersion(jobId: number, documentId: string, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/jobs/{jobId}/versions/documents/{documentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDocumentVersion(_response);
        });
    }

    protected processUploadDocumentVersion(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    downloadDocument(jobId: number, documentId: string, cancelToken?: CancelToken): Promise<DocumentDownloadResponse> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/download/{documentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: AxiosResponse): Promise<DocumentDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDownloadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDownloadResponse>(null as any);
    }

    downloadVersionDocument(jobId: number, versionId: string, cancelToken?: CancelToken): Promise<DocumentDownloadResponse> {
        let url_ = this.baseUrl + "/jobs/{jobId}/documents/download/version/{versionId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadVersionDocument(_response);
        });
    }

    protected processDownloadVersionDocument(response: AxiosResponse): Promise<DocumentDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentDownloadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDownloadResponse>(null as any);
    }
}

export interface IDrawingApiClient {
    /**
     * Get all Drawings for a job
     */
    getDrawingsByJob(jobId: number,  cancelToken?: CancelToken): Promise<DrawingDto[]>;
    /**
     * Create or update a Drawing
     */
    createOrUpdateDrawing(jobId: number, request: DrawingRequestDto,  cancelToken?: CancelToken): Promise<DrawingDto>;
    /**
     * Get a specific Drawing by ID
     */
    getDrawingById(jobId: number, drawingId: string,  cancelToken?: CancelToken): Promise<DrawingDto>;
    /**
     * Get job documents that can be attached to a Drawing from the system: non-folder, non-archived
    documents, excluding the generated "Drawings" folder.
     */
    getDocumentOptions(jobId: number,  cancelToken?: CancelToken): Promise<DrawingDocumentOptionDto[]>;
    /**
     * Rotate the Drawing's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, drawingId: string,  cancelToken?: CancelToken): Promise<DrawingDto>;
    /**
     * Get Drawing by ID for external users (no auth required)
     * @param token (optional) 
     */
    getExternalDrawing(drawingId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<DrawingDto>;
    /**
     * Update Drawing from external user
     * @param token (optional) 
     */
    updateExternalDrawing(drawingId: string, token: string | null | undefined, request: DrawingExternalUpdateDto,  cancelToken?: CancelToken): Promise<DrawingDto>;
    /**
     * Upload a temporary attachment file
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Clone an existing job document into a temporary Drawing attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: DrawingAttachFromDocumentRequest,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Generate PDF for a Drawing
     */
    generateDrawingPdf(jobId: number, drawingId: string,  cancelToken?: CancelToken): Promise<PdfResult>;
    /**
     * Render a Drawing PDF for preview without storing a document version.
     */
    previewDrawingPdf(jobId: number, drawingId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Render the printable Drawing Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getDrawingLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class DrawingApiClient implements IDrawingApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all Drawings for a job
     */
    getDrawingsByJob(jobId: number, cancelToken?: CancelToken): Promise<DrawingDto[]> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrawingsByJob(_response);
        });
    }

    protected processGetDrawingsByJob(response: AxiosResponse): Promise<DrawingDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DrawingDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrawingDto[]>(null as any);
    }

    /**
     * Create or update a Drawing
     */
    createOrUpdateDrawing(jobId: number, request: DrawingRequestDto, cancelToken?: CancelToken): Promise<DrawingDto> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateDrawing(_response);
        });
    }

    protected processCreateOrUpdateDrawing(response: AxiosResponse): Promise<DrawingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DrawingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrawingDto>(null as any);
    }

    /**
     * Get a specific Drawing by ID
     */
    getDrawingById(jobId: number, drawingId: string, cancelToken?: CancelToken): Promise<DrawingDto> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}/{drawingId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (drawingId === undefined || drawingId === null)
            throw new globalThis.Error("The parameter 'drawingId' must be defined.");
        url_ = url_.replace("{drawingId}", encodeURIComponent("" + drawingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrawingById(_response);
        });
    }

    protected processGetDrawingById(response: AxiosResponse): Promise<DrawingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DrawingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrawingDto>(null as any);
    }

    /**
     * Get job documents that can be attached to a Drawing from the system: non-folder, non-archived
    documents, excluding the generated "Drawings" folder.
     */
    getDocumentOptions(jobId: number, cancelToken?: CancelToken): Promise<DrawingDocumentOptionDto[]> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}/document-options";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentOptions(_response);
        });
    }

    protected processGetDocumentOptions(response: AxiosResponse): Promise<DrawingDocumentOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DrawingDocumentOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrawingDocumentOptionDto[]>(null as any);
    }

    /**
     * Rotate the Drawing's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, drawingId: string, cancelToken?: CancelToken): Promise<DrawingDto> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}/{drawingId}/external-access/rotate";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (drawingId === undefined || drawingId === null)
            throw new globalThis.Error("The parameter 'drawingId' must be defined.");
        url_ = url_.replace("{drawingId}", encodeURIComponent("" + drawingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRotateExternalAccess(_response);
        });
    }

    protected processRotateExternalAccess(response: AxiosResponse): Promise<DrawingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DrawingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrawingDto>(null as any);
    }

    /**
     * Get Drawing by ID for external users (no auth required)
     * @param token (optional) 
     */
    getExternalDrawing(drawingId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<DrawingDto> {
        let url_ = this.baseUrl + "/Drawing/external/{drawingId}?";
        if (drawingId === undefined || drawingId === null)
            throw new globalThis.Error("The parameter 'drawingId' must be defined.");
        url_ = url_.replace("{drawingId}", encodeURIComponent("" + drawingId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalDrawing(_response);
        });
    }

    protected processGetExternalDrawing(response: AxiosResponse): Promise<DrawingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DrawingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrawingDto>(null as any);
    }

    /**
     * Update Drawing from external user
     * @param token (optional) 
     */
    updateExternalDrawing(drawingId: string, token: string | null | undefined, request: DrawingExternalUpdateDto, cancelToken?: CancelToken): Promise<DrawingDto> {
        let url_ = this.baseUrl + "/Drawing/external/{drawingId}?";
        if (drawingId === undefined || drawingId === null)
            throw new globalThis.Error("The parameter 'drawingId' must be defined.");
        url_ = url_.replace("{drawingId}", encodeURIComponent("" + drawingId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExternalDrawing(_response);
        });
    }

    protected processUpdateExternalDrawing(response: AxiosResponse): Promise<DrawingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DrawingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrawingDto>(null as any);
    }

    /**
     * Upload a temporary attachment file
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Drawing/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (category !== null && category !== undefined)
            content_.append("category", category.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTempFile(_response);
        });
    }

    protected processUploadTempFile(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Clone an existing job document into a temporary Drawing attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: DrawingAttachFromDocumentRequest, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}/attach-from-document";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAttachFromDocument(_response);
        });
    }

    protected processAttachFromDocument(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Generate PDF for a Drawing
     */
    generateDrawingPdf(jobId: number, drawingId: string, cancelToken?: CancelToken): Promise<PdfResult> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}/{drawingId}/pdf";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (drawingId === undefined || drawingId === null)
            throw new globalThis.Error("The parameter 'drawingId' must be defined.");
        url_ = url_.replace("{drawingId}", encodeURIComponent("" + drawingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDrawingPdf(_response);
        });
    }

    protected processGenerateDrawingPdf(response: AxiosResponse): Promise<PdfResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PdfResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PdfResult>(null as any);
    }

    /**
     * Render a Drawing PDF for preview without storing a document version.
     */
    previewDrawingPdf(jobId: number, drawingId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}/{drawingId}/pdf/preview";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (drawingId === undefined || drawingId === null)
            throw new globalThis.Error("The parameter 'drawingId' must be defined.");
        url_ = url_.replace("{drawingId}", encodeURIComponent("" + drawingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewDrawingPdf(_response);
        });
    }

    protected processPreviewDrawingPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Render the printable Drawing Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getDrawingLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Drawing/job/{jobId}/log/pdf?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (submittedToContactId !== undefined && submittedToContactId !== null)
            url_ += "submittedToContactId=" + encodeURIComponent("" + submittedToContactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrawingLogPdf(_response);
        });
    }

    protected processGetDrawingLogPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IEmailApiClient {
    list(req: EmailListRequest,  cancelToken?: CancelToken): Promise<EmailDto[]>;
    get(emailId: number,  cancelToken?: CancelToken): Promise<EmailDto>;
    downloadEmailAttachment(attachmentId: number,  cancelToken?: CancelToken): Promise<EmailAttachmentDownloadDto>;
}

export class EmailApiClient implements IEmailApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(req: EmailListRequest, cancelToken?: CancelToken): Promise<EmailDto[]> {
        let url_ = this.baseUrl + "/Email/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<EmailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmailDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailDto[]>(null as any);
    }

    get(emailId: number, cancelToken?: CancelToken): Promise<EmailDto> {
        let url_ = this.baseUrl + "/Email/{emailId}";
        if (emailId === undefined || emailId === null)
            throw new globalThis.Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<EmailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailDto>(null as any);
    }

    downloadEmailAttachment(attachmentId: number, cancelToken?: CancelToken): Promise<EmailAttachmentDownloadDto> {
        let url_ = this.baseUrl + "/Email/attachments/{attachmentId}/download";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadEmailAttachment(_response);
        });
    }

    protected processDownloadEmailAttachment(response: AxiosResponse): Promise<EmailAttachmentDownloadDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmailAttachmentDownloadDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailAttachmentDownloadDto>(null as any);
    }
}

export interface IHealthCheckApiClient {
    getDatabaseStatuses( cancelToken?: CancelToken): Promise<DatabaseStatusResponse>;
    getMe( cancelToken?: CancelToken): Promise<GetMeResponse>;
    testJob( cancelToken?: CancelToken): Promise<FileResponse | null>;
    sendTestEmail( cancelToken?: CancelToken): Promise<FileResponse | null>;
    sendTestTimesheetEmail( cancelToken?: CancelToken): Promise<FileResponse | null>;
    triggerCtcSnapshot( cancelToken?: CancelToken): Promise<void>;
    getCtcSnapshotStatus( cancelToken?: CancelToken): Promise<CtcSnapshotStatusResponse>;
}

export class HealthCheckApiClient implements IHealthCheckApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDatabaseStatuses( cancelToken?: CancelToken): Promise<DatabaseStatusResponse> {
        let url_ = this.baseUrl + "/healthcheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDatabaseStatuses(_response);
        });
    }

    protected processGetDatabaseStatuses(response: AxiosResponse): Promise<DatabaseStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DatabaseStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatabaseStatusResponse>(null as any);
    }

    getMe( cancelToken?: CancelToken): Promise<GetMeResponse> {
        let url_ = this.baseUrl + "/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMe(_response);
        });
    }

    protected processGetMe(response: AxiosResponse): Promise<GetMeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetMeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMeResponse>(null as any);
    }

    testJob( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/enqueue-job";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestJob(_response);
        });
    }

    protected processTestJob(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sendTestEmail( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/send-test-email";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sendTestTimesheetEmail( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/send-test-timesheet-email";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestTimesheetEmail(_response);
        });
    }

    protected processSendTestTimesheetEmail(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    triggerCtcSnapshot( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ctc-snapshot/trigger";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerCtcSnapshot(_response);
        });
    }

    protected processTriggerCtcSnapshot(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getCtcSnapshotStatus( cancelToken?: CancelToken): Promise<CtcSnapshotStatusResponse> {
        let url_ = this.baseUrl + "/ctc-snapshot";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCtcSnapshotStatus(_response);
        });
    }

    protected processGetCtcSnapshotStatus(response: AxiosResponse): Promise<CtcSnapshotStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CtcSnapshotStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CtcSnapshotStatusResponse>(null as any);
    }
}

export interface IHyperlinkApiClient {
    listHyperlinks(jobId: number,  cancelToken?: CancelToken): Promise<Hyperlink[]>;
    createOrUpdateHyperlink(jobId: number, body: HyperlinkRequest,  cancelToken?: CancelToken): Promise<Hyperlink>;
    removeHyperlink(jobId: number, hyperlinkId: string,  cancelToken?: CancelToken): Promise<Hyperlink>;
}

export class HyperlinkApiClient implements IHyperlinkApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listHyperlinks(jobId: number, cancelToken?: CancelToken): Promise<Hyperlink[]> {
        let url_ = this.baseUrl + "/Hyperlink/jobs/{jobId}/hyperlinks";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListHyperlinks(_response);
        });
    }

    protected processListHyperlinks(response: AxiosResponse): Promise<Hyperlink[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Hyperlink[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Hyperlink[]>(null as any);
    }

    createOrUpdateHyperlink(jobId: number, body: HyperlinkRequest, cancelToken?: CancelToken): Promise<Hyperlink> {
        let url_ = this.baseUrl + "/Hyperlink/jobs/{jobId}/hyperlinks";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateHyperlink(_response);
        });
    }

    protected processCreateOrUpdateHyperlink(response: AxiosResponse): Promise<Hyperlink> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Hyperlink>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Hyperlink>(null as any);
    }

    removeHyperlink(jobId: number, hyperlinkId: string, cancelToken?: CancelToken): Promise<Hyperlink> {
        let url_ = this.baseUrl + "/Hyperlink/jobs/{jobId}hyperlinks/{hyperlinkId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (hyperlinkId === undefined || hyperlinkId === null)
            throw new globalThis.Error("The parameter 'hyperlinkId' must be defined.");
        url_ = url_.replace("{hyperlinkId}", encodeURIComponent("" + hyperlinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveHyperlink(_response);
        });
    }

    protected processRemoveHyperlink(response: AxiosResponse): Promise<Hyperlink> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Hyperlink>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Hyperlink>(null as any);
    }
}

export interface IInboundSmsApiClient {
    inbound( cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class InboundSmsApiClient implements IInboundSmsApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    inbound( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/sms/inbound";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInbound(_response);
        });
    }

    protected processInbound(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IInspectionsOverviewApiClient {
    getInspections( cancelToken?: CancelToken): Promise<InspectionsOverviewDto>;
}

export class InspectionsOverviewApiClient implements IInspectionsOverviewApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInspections( cancelToken?: CancelToken): Promise<InspectionsOverviewDto> {
        let url_ = this.baseUrl + "/inspections/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInspections(_response);
        });
    }

    protected processGetInspections(response: AxiosResponse): Promise<InspectionsOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionsOverviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionsOverviewDto>(null as any);
    }
}

export interface IJobApiClient {
    /**
     * Get all open CTC jobs
     */
    index( cancelToken?: CancelToken): Promise<JobDto[]>;
    /**
     * Create a new job
     */
    create(data: JobRequestDto,  cancelToken?: CancelToken): Promise<JobDto>;
    /**
     * Get all closed/archived CTC jobs
     */
    getClosedJobs( cancelToken?: CancelToken): Promise<JobDto[]>;
    getActivityFeed( cancelToken?: CancelToken): Promise<ActivityJobDto[]>;
    /**
     * Get a job by ID or job number
     */
    getById(id: number,  cancelToken?: CancelToken): Promise<JobDto>;
    /**
     * Get job summary with constraints, milestones, and CTC data
     */
    getJobSummary(jobId: number,  cancelToken?: CancelToken): Promise<JobSummaryDto2>;
    /**
     * Update job details
     */
    updateJobDetails(jobId: number, data: JobRequestDto,  cancelToken?: CancelToken): Promise<JobDto>;
    /**
     * Update job workflow settings
     */
    updateWorkflows(jobId: number, data: JobWorkflowSettingsDto,  cancelToken?: CancelToken): Promise<JobDto>;
    /**
     * Update job template settings
     */
    updateJobTemplates(jobId: number, data: JobTemplateSettingsDto,  cancelToken?: CancelToken): Promise<JobDto>;
    /**
     * Search Firetrol and unsynced CTC jobs for the user picker.
    Hydration mode: when ids or ctcJobNumbers are supplied,
    returns exact matches with no limit (allows the picker to render pre-selected grants).
    Search mode: returns up to 50 Firetrol matches plus up to 50 CTC matches (admin/CTC-allowed
    users only), excluding CTC numbers that already exist as Firetrol jobs.
     * @param query (optional) 
     * @param ids (optional) 
     * @param ctcJobNumbers (optional) 
     */
    searchJobs(query: string | null | undefined, ids: number[] | null | undefined, ctcJobNumbers: string[] | null | undefined,  cancelToken?: CancelToken): Promise<JobOptionDto[]>;
    /**
     * Bulk archive jobs
     */
    bulkArchiveJobs(data: BulkArchiveJobsRequestDto,  cancelToken?: CancelToken): Promise<number[]>;
    /**
     * Get users assigned to a job
     */
    getJobUsers(id: number,  cancelToken?: CancelToken): Promise<UserDto[]>;
    /**
     * Get job team members
     */
    getTeam(id: number,  cancelToken?: CancelToken): Promise<JobUserDto[]>;
    /**
     * Add a team member to a job
     */
    addTeamMember(id: number, data: JobTeamMemberRequestDto,  cancelToken?: CancelToken): Promise<JobUserDto>;
    /**
     * Get job team members filtered by roles
     */
    getTeamByRoles(id: number, data: JobTeamByRolesRequestDto,  cancelToken?: CancelToken): Promise<JobUserDto[]>;
    /**
     * Get team members by office
     */
    getTeamByOffice(officeName: string,  cancelToken?: CancelToken): Promise<JobUserDto[]>;
    /**
     * Remove a team member from a job
     */
    removeTeamMember(id: number, userId: number,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class JobApiClient implements IJobApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all open CTC jobs
     */
    index( cancelToken?: CancelToken): Promise<JobDto[]> {
        let url_ = this.baseUrl + "/Job";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<JobDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto[]>(null as any);
    }

    /**
     * Create a new job
     */
    create(data: JobRequestDto, cancelToken?: CancelToken): Promise<JobDto> {
        let url_ = this.baseUrl + "/Job";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<JobDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto>(null as any);
    }

    /**
     * Get all closed/archived CTC jobs
     */
    getClosedJobs( cancelToken?: CancelToken): Promise<JobDto[]> {
        let url_ = this.baseUrl + "/Job/closed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClosedJobs(_response);
        });
    }

    protected processGetClosedJobs(response: AxiosResponse): Promise<JobDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto[]>(null as any);
    }

    getActivityFeed( cancelToken?: CancelToken): Promise<ActivityJobDto[]> {
        let url_ = this.baseUrl + "/Job/activity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityFeed(_response);
        });
    }

    protected processGetActivityFeed(response: AxiosResponse): Promise<ActivityJobDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ActivityJobDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityJobDto[]>(null as any);
    }

    /**
     * Get a job by ID or job number
     */
    getById(id: number, cancelToken?: CancelToken): Promise<JobDto> {
        let url_ = this.baseUrl + "/Job/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JobDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto>(null as any);
    }

    /**
     * Get job summary with constraints, milestones, and CTC data
     */
    getJobSummary(jobId: number, cancelToken?: CancelToken): Promise<JobSummaryDto2> {
        let url_ = this.baseUrl + "/Job/{jobId}/summary";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobSummary(_response);
        });
    }

    protected processGetJobSummary(response: AxiosResponse): Promise<JobSummaryDto2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobSummaryDto2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobSummaryDto2>(null as any);
    }

    /**
     * Update job details
     */
    updateJobDetails(jobId: number, data: JobRequestDto, cancelToken?: CancelToken): Promise<JobDto> {
        let url_ = this.baseUrl + "/Job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobDetails(_response);
        });
    }

    protected processUpdateJobDetails(response: AxiosResponse): Promise<JobDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto>(null as any);
    }

    /**
     * Update job workflow settings
     */
    updateWorkflows(jobId: number, data: JobWorkflowSettingsDto, cancelToken?: CancelToken): Promise<JobDto> {
        let url_ = this.baseUrl + "/Job/{jobId}/workflowSettings";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWorkflows(_response);
        });
    }

    protected processUpdateWorkflows(response: AxiosResponse): Promise<JobDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto>(null as any);
    }

    /**
     * Update job template settings
     */
    updateJobTemplates(jobId: number, data: JobTemplateSettingsDto, cancelToken?: CancelToken): Promise<JobDto> {
        let url_ = this.baseUrl + "/Job/{jobId}/templateSettings";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobTemplates(_response);
        });
    }

    protected processUpdateJobTemplates(response: AxiosResponse): Promise<JobDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto>(null as any);
    }

    /**
     * Search Firetrol and unsynced CTC jobs for the user picker.
    Hydration mode: when ids or ctcJobNumbers are supplied,
    returns exact matches with no limit (allows the picker to render pre-selected grants).
    Search mode: returns up to 50 Firetrol matches plus up to 50 CTC matches (admin/CTC-allowed
    users only), excluding CTC numbers that already exist as Firetrol jobs.
     * @param query (optional) 
     * @param ids (optional) 
     * @param ctcJobNumbers (optional) 
     */
    searchJobs(query: string | null | undefined, ids: number[] | null | undefined, ctcJobNumbers: string[] | null | undefined, cancelToken?: CancelToken): Promise<JobOptionDto[]> {
        let url_ = this.baseUrl + "/Job/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (ctcJobNumbers !== undefined && ctcJobNumbers !== null)
            ctcJobNumbers && ctcJobNumbers.forEach(item => { url_ += "ctcJobNumbers=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchJobs(_response);
        });
    }

    protected processSearchJobs(response: AxiosResponse): Promise<JobOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobOptionDto[]>(null as any);
    }

    /**
     * Bulk archive jobs
     */
    bulkArchiveJobs(data: BulkArchiveJobsRequestDto, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/Job/bulkArchive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkArchiveJobs(_response);
        });
    }

    protected processBulkArchiveJobs(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get users assigned to a job
     */
    getJobUsers(id: number, cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/Job/{id}/users";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobUsers(_response);
        });
    }

    protected processGetJobUsers(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * Get job team members
     */
    getTeam(id: number, cancelToken?: CancelToken): Promise<JobUserDto[]> {
        let url_ = this.baseUrl + "/Job/{id}/team";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeam(_response);
        });
    }

    protected processGetTeam(response: AxiosResponse): Promise<JobUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobUserDto[]>(null as any);
    }

    /**
     * Add a team member to a job
     */
    addTeamMember(id: number, data: JobTeamMemberRequestDto, cancelToken?: CancelToken): Promise<JobUserDto> {
        let url_ = this.baseUrl + "/Job/{id}/team";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTeamMember(_response);
        });
    }

    protected processAddTeamMember(response: AxiosResponse): Promise<JobUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobUserDto>(null as any);
    }

    /**
     * Get job team members filtered by roles
     */
    getTeamByRoles(id: number, data: JobTeamByRolesRequestDto, cancelToken?: CancelToken): Promise<JobUserDto[]> {
        let url_ = this.baseUrl + "/Job/{id}/teamByRoles";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeamByRoles(_response);
        });
    }

    protected processGetTeamByRoles(response: AxiosResponse): Promise<JobUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobUserDto[]>(null as any);
    }

    /**
     * Get team members by office
     */
    getTeamByOffice(officeName: string, cancelToken?: CancelToken): Promise<JobUserDto[]> {
        let url_ = this.baseUrl + "/Job/team/office/{officeName}";
        if (officeName === undefined || officeName === null)
            throw new globalThis.Error("The parameter 'officeName' must be defined.");
        url_ = url_.replace("{officeName}", encodeURIComponent("" + officeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeamByOffice(_response);
        });
    }

    protected processGetTeamByOffice(response: AxiosResponse): Promise<JobUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobUserDto[]>(null as any);
    }

    /**
     * Remove a team member from a job
     */
    removeTeamMember(id: number, userId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Job/{id}/team/{userId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveTeamMember(_response);
        });
    }

    protected processRemoveTeamMember(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IKnowledgeArticleApiClient {
    /**
     * @param search (optional) Case-insensitive match against title and summary.
     * @param officeId (optional) 
     * @param status (optional) "draft" | "published" | "archived"; null/unrecognized = all statuses.
     * @param page (optional) 
     * @param pageSize (optional) 
     */
    list(search: string | null | undefined, officeId: number | null | undefined, status: string | null | undefined, page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<PagedResultOfKnowledgeArticleListItemDto>;
    create(request: KnowledgeArticleUpsertRequestDto,  cancelToken?: CancelToken): Promise<KnowledgeArticleDto>;
    get(id: number,  cancelToken?: CancelToken): Promise<KnowledgeArticleDto>;
    update(id: number, request: KnowledgeArticleUpsertRequestDto,  cancelToken?: CancelToken): Promise<KnowledgeArticleDto>;
    archive(id: number,  cancelToken?: CancelToken): Promise<KnowledgeArticleDto>;
    restore(id: number,  cancelToken?: CancelToken): Promise<KnowledgeArticleDto>;
}

export class KnowledgeArticleApiClient implements IKnowledgeArticleApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param search (optional) Case-insensitive match against title and summary.
     * @param officeId (optional) 
     * @param status (optional) "draft" | "published" | "archived"; null/unrecognized = all statuses.
     * @param page (optional) 
     * @param pageSize (optional) 
     */
    list(search: string | null | undefined, officeId: number | null | undefined, status: string | null | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResultOfKnowledgeArticleListItemDto> {
        let url_ = this.baseUrl + "/KnowledgeArticle?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (officeId !== undefined && officeId !== null)
            url_ += "OfficeId=" + encodeURIComponent("" + officeId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<PagedResultOfKnowledgeArticleListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedResultOfKnowledgeArticleListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultOfKnowledgeArticleListItemDto>(null as any);
    }

    create(request: KnowledgeArticleUpsertRequestDto, cancelToken?: CancelToken): Promise<KnowledgeArticleDto> {
        let url_ = this.baseUrl + "/KnowledgeArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<KnowledgeArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<KnowledgeArticleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleDto>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<KnowledgeArticleDto> {
        let url_ = this.baseUrl + "/KnowledgeArticle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<KnowledgeArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<KnowledgeArticleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleDto>(null as any);
    }

    update(id: number, request: KnowledgeArticleUpsertRequestDto, cancelToken?: CancelToken): Promise<KnowledgeArticleDto> {
        let url_ = this.baseUrl + "/KnowledgeArticle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<KnowledgeArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<KnowledgeArticleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleDto>(null as any);
    }

    archive(id: number, cancelToken?: CancelToken): Promise<KnowledgeArticleDto> {
        let url_ = this.baseUrl + "/KnowledgeArticle/{id}/archive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: AxiosResponse): Promise<KnowledgeArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<KnowledgeArticleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleDto>(null as any);
    }

    restore(id: number, cancelToken?: CancelToken): Promise<KnowledgeArticleDto> {
        let url_ = this.baseUrl + "/KnowledgeArticle/{id}/restore";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<KnowledgeArticleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<KnowledgeArticleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleDto>(null as any);
    }
}

export interface IManhoursApiClient {
    listJobCostCodes( cancelToken?: CancelToken): Promise<CostCodeOptionDto[]>;
    listJobFilters( cancelToken?: CancelToken): Promise<JobManhoursFilterDto[]>;
    /**
     * The weeks start with the work week that contains today, the caller's local date.
     */
    listJobManhours(filter: ListJobManhoursRequest, today: Date,  cancelToken?: CancelToken): Promise<ListJobManhoursResponse>;
}

export class ManhoursApiClient implements IManhoursApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listJobCostCodes( cancelToken?: CancelToken): Promise<CostCodeOptionDto[]> {
        let url_ = this.baseUrl + "/Manhours/cost-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListJobCostCodes(_response);
        });
    }

    protected processListJobCostCodes(response: AxiosResponse): Promise<CostCodeOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CostCodeOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCodeOptionDto[]>(null as any);
    }

    listJobFilters( cancelToken?: CancelToken): Promise<JobManhoursFilterDto[]> {
        let url_ = this.baseUrl + "/Manhours/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListJobFilters(_response);
        });
    }

    protected processListJobFilters(response: AxiosResponse): Promise<JobManhoursFilterDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobManhoursFilterDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobManhoursFilterDto[]>(null as any);
    }

    /**
     * The weeks start with the work week that contains today, the caller's local date.
     */
    listJobManhours(filter: ListJobManhoursRequest, today: Date, cancelToken?: CancelToken): Promise<ListJobManhoursResponse> {
        let url_ = this.baseUrl + "/Manhours/summary?";
        if (today === undefined || today === null)
            throw new globalThis.Error("The parameter 'today' must be defined and cannot be null.");
        else
            url_ += "today=" + encodeURIComponent(today ? formatDate_(today) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListJobManhours(_response);
        });
    }

    protected processListJobManhours(response: AxiosResponse): Promise<ListJobManhoursResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ListJobManhoursResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListJobManhoursResponse>(null as any);
    }
}

export interface IMeetingCommentApiClient {
    createComment(jobId: number, meetingId: string, topicId: string, issueId: string, request: IssueCommentRequestDto,  cancelToken?: CancelToken): Promise<IssueCommentDto>;
    updateComment(jobId: number, meetingId: string, topicId: string, issueId: string, commentId: string, request: IssueCommentRequestDto,  cancelToken?: CancelToken): Promise<IssueCommentDto>;
    deleteComment(jobId: number, meetingId: string, topicId: string, issueId: string, commentId: string,  cancelToken?: CancelToken): Promise<IssueCommentDto>;
}

export class MeetingCommentApiClient implements IMeetingCommentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createComment(jobId: number, meetingId: string, topicId: string, issueId: string, request: IssueCommentRequestDto, cancelToken?: CancelToken): Promise<IssueCommentDto> {
        let url_ = this.baseUrl + "/MeetingComment/jobs/{jobId}/meetings/{meetingId}/topics/{topicId}/issues/{issueId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        if (issueId === undefined || issueId === null)
            throw new globalThis.Error("The parameter 'issueId' must be defined.");
        url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateComment(_response);
        });
    }

    protected processCreateComment(response: AxiosResponse): Promise<IssueCommentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IssueCommentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueCommentDto>(null as any);
    }

    updateComment(jobId: number, meetingId: string, topicId: string, issueId: string, commentId: string, request: IssueCommentRequestDto, cancelToken?: CancelToken): Promise<IssueCommentDto> {
        let url_ = this.baseUrl + "/MeetingComment/jobs/{jobId}/meetings/{meetingId}/topics/{topicId}/issues/{issueId}/{commentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        if (issueId === undefined || issueId === null)
            throw new globalThis.Error("The parameter 'issueId' must be defined.");
        url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId));
        if (commentId === undefined || commentId === null)
            throw new globalThis.Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: AxiosResponse): Promise<IssueCommentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IssueCommentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueCommentDto>(null as any);
    }

    deleteComment(jobId: number, meetingId: string, topicId: string, issueId: string, commentId: string, cancelToken?: CancelToken): Promise<IssueCommentDto> {
        let url_ = this.baseUrl + "/MeetingComment/jobs/{jobId}/meetings/{meetingId}/topics/{topicId}/issues/{issueId}/{commentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        if (issueId === undefined || issueId === null)
            throw new globalThis.Error("The parameter 'issueId' must be defined.");
        url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId));
        if (commentId === undefined || commentId === null)
            throw new globalThis.Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: AxiosResponse): Promise<IssueCommentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IssueCommentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueCommentDto>(null as any);
    }
}

export interface IMeetingApiClient {
    createMeeting(jobId: number,  cancelToken?: CancelToken): Promise<MeetingDto>;
    getMeetings(jobId: number,  cancelToken?: CancelToken): Promise<MeetingListDto[]>;
    cloneMeeting(jobId: number, meetingId: string,  cancelToken?: CancelToken): Promise<MeetingDto>;
    getMeetingById(jobId: number, meetingId: string,  cancelToken?: CancelToken): Promise<MeetingDto>;
    updateMeeting(jobId: number, meetingId: string, request: MeetingRequestDto,  cancelToken?: CancelToken): Promise<MeetingDto>;
    deleteMeeting(jobId: number, meetingId: string,  cancelToken?: CancelToken): Promise<MeetingDto>;
    /**
     * The meeting minutes as a PDF, rendered from the meeting as it is now. Not stored. Meeting
    and comment times are shown in timeZone (the viewer's IANA id), or UTC
    when it is absent or unknown.
     * @param timeZone (optional) 
     */
    getMeetingPdf(jobId: number, meetingId: string, timeZone: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Renders the meeting minutes with status Published and stores them in the meeting type's
    folder: a new Document on the first publish, a new DocumentVersion on later ones. Times are
    shown in timeZone as for GetMeetingPdf.
     * @param timeZone (optional) 
     */
    publishMeeting(jobId: number, meetingId: string, timeZone: string | null | undefined,  cancelToken?: CancelToken): Promise<DocumentPublishDto>;
}

export class MeetingApiClient implements IMeetingApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createMeeting(jobId: number, cancelToken?: CancelToken): Promise<MeetingDto> {
        let url_ = this.baseUrl + "/Meeting/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMeeting(_response);
        });
    }

    protected processCreateMeeting(response: AxiosResponse): Promise<MeetingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingDto>(null as any);
    }

    getMeetings(jobId: number, cancelToken?: CancelToken): Promise<MeetingListDto[]> {
        let url_ = this.baseUrl + "/Meeting/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMeetings(_response);
        });
    }

    protected processGetMeetings(response: AxiosResponse): Promise<MeetingListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingListDto[]>(null as any);
    }

    cloneMeeting(jobId: number, meetingId: string, cancelToken?: CancelToken): Promise<MeetingDto> {
        let url_ = this.baseUrl + "/Meeting/jobs/{jobId}/{meetingId}/clone";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneMeeting(_response);
        });
    }

    protected processCloneMeeting(response: AxiosResponse): Promise<MeetingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingDto>(null as any);
    }

    getMeetingById(jobId: number, meetingId: string, cancelToken?: CancelToken): Promise<MeetingDto> {
        let url_ = this.baseUrl + "/Meeting/jobs/{jobId}/{meetingId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMeetingById(_response);
        });
    }

    protected processGetMeetingById(response: AxiosResponse): Promise<MeetingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingDto>(null as any);
    }

    updateMeeting(jobId: number, meetingId: string, request: MeetingRequestDto, cancelToken?: CancelToken): Promise<MeetingDto> {
        let url_ = this.baseUrl + "/Meeting/jobs/{jobId}/{meetingId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMeeting(_response);
        });
    }

    protected processUpdateMeeting(response: AxiosResponse): Promise<MeetingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingDto>(null as any);
    }

    deleteMeeting(jobId: number, meetingId: string, cancelToken?: CancelToken): Promise<MeetingDto> {
        let url_ = this.baseUrl + "/Meeting/jobs/{jobId}/{meetingId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMeeting(_response);
        });
    }

    protected processDeleteMeeting(response: AxiosResponse): Promise<MeetingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingDto>(null as any);
    }

    /**
     * The meeting minutes as a PDF, rendered from the meeting as it is now. Not stored. Meeting
    and comment times are shown in timeZone (the viewer's IANA id), or UTC
    when it is absent or unknown.
     * @param timeZone (optional) 
     */
    getMeetingPdf(jobId: number, meetingId: string, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Meeting/jobs/{jobId}/{meetingId}/pdf?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMeetingPdf(_response);
        });
    }

    protected processGetMeetingPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Renders the meeting minutes with status Published and stores them in the meeting type's
    folder: a new Document on the first publish, a new DocumentVersion on later ones. Times are
    shown in timeZone as for GetMeetingPdf.
     * @param timeZone (optional) 
     */
    publishMeeting(jobId: number, meetingId: string, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<DocumentPublishDto> {
        let url_ = this.baseUrl + "/Meeting/jobs/{jobId}/{meetingId}/publish?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishMeeting(_response);
        });
    }

    protected processPublishMeeting(response: AxiosResponse): Promise<DocumentPublishDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentPublishDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentPublishDto>(null as any);
    }
}

export interface IMeetingIssueApiClient {
    getIssues(jobId: number,  cancelToken?: CancelToken): Promise<TopicIssueWithStatsDto>;
    createIssue(jobId: number, meetingId: string, topicId: string,  cancelToken?: CancelToken): Promise<TopicIssueDto>;
    updateIssue(jobId: number, meetingId: string, topicId: string, issueId: string, request: TopicIssueRequestDto,  cancelToken?: CancelToken): Promise<TopicIssueDto>;
    deleteIssue(jobId: number, meetingId: string, topicId: string, issueId: string,  cancelToken?: CancelToken): Promise<TopicIssueDto>;
}

export class MeetingIssueApiClient implements IMeetingIssueApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getIssues(jobId: number, cancelToken?: CancelToken): Promise<TopicIssueWithStatsDto> {
        let url_ = this.baseUrl + "/MeetingIssue/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssues(_response);
        });
    }

    protected processGetIssues(response: AxiosResponse): Promise<TopicIssueWithStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TopicIssueWithStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicIssueWithStatsDto>(null as any);
    }

    createIssue(jobId: number, meetingId: string, topicId: string, cancelToken?: CancelToken): Promise<TopicIssueDto> {
        let url_ = this.baseUrl + "/MeetingIssue/jobs/{jobId}/meetings/{meetingId}/topics/{topicId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIssue(_response);
        });
    }

    protected processCreateIssue(response: AxiosResponse): Promise<TopicIssueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TopicIssueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicIssueDto>(null as any);
    }

    updateIssue(jobId: number, meetingId: string, topicId: string, issueId: string, request: TopicIssueRequestDto, cancelToken?: CancelToken): Promise<TopicIssueDto> {
        let url_ = this.baseUrl + "/MeetingIssue/jobs/{jobId}/meetings/{meetingId}/topics/{topicId}/{issueId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        if (issueId === undefined || issueId === null)
            throw new globalThis.Error("The parameter 'issueId' must be defined.");
        url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIssue(_response);
        });
    }

    protected processUpdateIssue(response: AxiosResponse): Promise<TopicIssueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TopicIssueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicIssueDto>(null as any);
    }

    deleteIssue(jobId: number, meetingId: string, topicId: string, issueId: string, cancelToken?: CancelToken): Promise<TopicIssueDto> {
        let url_ = this.baseUrl + "/MeetingIssue/jobs/{jobId}/meetings/{meetingId}/topics/{topicId}/{issueId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        if (issueId === undefined || issueId === null)
            throw new globalThis.Error("The parameter 'issueId' must be defined.");
        url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIssue(_response);
        });
    }

    protected processDeleteIssue(response: AxiosResponse): Promise<TopicIssueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TopicIssueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopicIssueDto>(null as any);
    }
}

export interface IMeetingTopicApiClient {
    createTopic(jobId: number, meetingId: string, request: MeetingTopicRequestDto | undefined,  cancelToken?: CancelToken): Promise<MeetingTopicDto>;
    updateTopic(jobId: number, meetingId: string, topicId: string, request: MeetingTopicRequestDto,  cancelToken?: CancelToken): Promise<MeetingTopicDto>;
    deleteTopic(jobId: number, meetingId: string, topicId: string,  cancelToken?: CancelToken): Promise<MeetingTopicDto>;
}

export class MeetingTopicApiClient implements IMeetingTopicApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createTopic(jobId: number, meetingId: string, request: MeetingTopicRequestDto | undefined, cancelToken?: CancelToken): Promise<MeetingTopicDto> {
        let url_ = this.baseUrl + "/MeetingTopic/jobs/{jobId}/meetings/{meetingId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTopic(_response);
        });
    }

    protected processCreateTopic(response: AxiosResponse): Promise<MeetingTopicDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingTopicDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingTopicDto>(null as any);
    }

    updateTopic(jobId: number, meetingId: string, topicId: string, request: MeetingTopicRequestDto, cancelToken?: CancelToken): Promise<MeetingTopicDto> {
        let url_ = this.baseUrl + "/MeetingTopic/jobs/{jobId}/meetings/{meetingId}/{topicId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTopic(_response);
        });
    }

    protected processUpdateTopic(response: AxiosResponse): Promise<MeetingTopicDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingTopicDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingTopicDto>(null as any);
    }

    deleteTopic(jobId: number, meetingId: string, topicId: string, cancelToken?: CancelToken): Promise<MeetingTopicDto> {
        let url_ = this.baseUrl + "/MeetingTopic/jobs/{jobId}/meetings/{meetingId}/{topicId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (meetingId === undefined || meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTopic(_response);
        });
    }

    protected processDeleteTopic(response: AxiosResponse): Promise<MeetingTopicDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingTopicDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingTopicDto>(null as any);
    }
}

export interface IMeetingTypeApiClient {
    createMeetingType(jobId: number, request: MeetingTypeRequestDto,  cancelToken?: CancelToken): Promise<MeetingTypeDto>;
    listMeetingTypes(jobId: number,  cancelToken?: CancelToken): Promise<MeetingTypeDto[]>;
    listMeetingsByTypes(jobId: number,  cancelToken?: CancelToken): Promise<MeetingTypeDto[]>;
}

export class MeetingTypeApiClient implements IMeetingTypeApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createMeetingType(jobId: number, request: MeetingTypeRequestDto, cancelToken?: CancelToken): Promise<MeetingTypeDto> {
        let url_ = this.baseUrl + "/MeetingType/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMeetingType(_response);
        });
    }

    protected processCreateMeetingType(response: AxiosResponse): Promise<MeetingTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingTypeDto>(null as any);
    }

    listMeetingTypes(jobId: number, cancelToken?: CancelToken): Promise<MeetingTypeDto[]> {
        let url_ = this.baseUrl + "/MeetingType/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMeetingTypes(_response);
        });
    }

    protected processListMeetingTypes(response: AxiosResponse): Promise<MeetingTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingTypeDto[]>(null as any);
    }

    listMeetingsByTypes(jobId: number, cancelToken?: CancelToken): Promise<MeetingTypeDto[]> {
        let url_ = this.baseUrl + "/MeetingType/jobs/{jobId}/with-meetings";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMeetingsByTypes(_response);
        });
    }

    protected processListMeetingsByTypes(response: AxiosResponse): Promise<MeetingTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeetingTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeetingTypeDto[]>(null as any);
    }
}

export interface IMilestonePhaseApiClient {
    listTemplatePhases( cancelToken?: CancelToken): Promise<MilestonePhaseDto[]>;
    listJobPhases(jobId: number,  cancelToken?: CancelToken): Promise<MilestonePhaseDto[]>;
    getPhaseById(phaseId: string,  cancelToken?: CancelToken): Promise<MilestonePhaseDto>;
    deletePhase(phaseId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    createPhase(jobId: string, request: MilestonePhaseRequestDto,  cancelToken?: CancelToken): Promise<MilestonePhaseDto>;
    updatePhase(jobId: string, phaseId: string, request: MilestonePhaseRequestDto,  cancelToken?: CancelToken): Promise<MilestonePhaseDto>;
}

export class MilestonePhaseApiClient implements IMilestonePhaseApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listTemplatePhases( cancelToken?: CancelToken): Promise<MilestonePhaseDto[]> {
        let url_ = this.baseUrl + "/MilestonePhase/phases/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTemplatePhases(_response);
        });
    }

    protected processListTemplatePhases(response: AxiosResponse): Promise<MilestonePhaseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseDto[]>(null as any);
    }

    listJobPhases(jobId: number, cancelToken?: CancelToken): Promise<MilestonePhaseDto[]> {
        let url_ = this.baseUrl + "/MilestonePhase/phases/jobs/{jobId}/list";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListJobPhases(_response);
        });
    }

    protected processListJobPhases(response: AxiosResponse): Promise<MilestonePhaseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseDto[]>(null as any);
    }

    getPhaseById(phaseId: string, cancelToken?: CancelToken): Promise<MilestonePhaseDto> {
        let url_ = this.baseUrl + "/MilestonePhase/phases/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhaseById(_response);
        });
    }

    protected processGetPhaseById(response: AxiosResponse): Promise<MilestonePhaseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseDto>(null as any);
    }

    deletePhase(phaseId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/MilestonePhase/phases/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePhase(_response);
        });
    }

    protected processDeletePhase(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createPhase(jobId: string, request: MilestonePhaseRequestDto, cancelToken?: CancelToken): Promise<MilestonePhaseDto> {
        let url_ = this.baseUrl + "/MilestonePhase/phases/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePhase(_response);
        });
    }

    protected processCreatePhase(response: AxiosResponse): Promise<MilestonePhaseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseDto>(null as any);
    }

    updatePhase(jobId: string, phaseId: string, request: MilestonePhaseRequestDto, cancelToken?: CancelToken): Promise<MilestonePhaseDto> {
        let url_ = this.baseUrl + "/MilestonePhase/phases/jobs/{jobId}/phases/{phaseId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (phaseId === undefined || phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhase(_response);
        });
    }

    protected processUpdatePhase(response: AxiosResponse): Promise<MilestonePhaseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseDto>(null as any);
    }
}

export interface IMilestonePhaseItemApiClient {
    listPhaseItems(jobId: string, filters: MilestonePhaseItemListRequest | undefined,  cancelToken?: CancelToken): Promise<MilestonePhaseItemDto[]>;
    getPhaseItemById(itemId: string,  cancelToken?: CancelToken): Promise<MilestonePhaseItemDto>;
    deletePhaseItem(itemId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    createPhaseItem(jobId: string, request: MilestonePhaseItemRequestDto,  cancelToken?: CancelToken): Promise<MilestonePhaseItemDto>;
    updatePhaseItem(jobId: string, itemId: string, request: MilestonePhaseItemRequestDto,  cancelToken?: CancelToken): Promise<MilestonePhaseItemDto>;
    movePhaseItem(jobId: string, itemId: string, request: MilestonePhaseItemMoveRequestDto,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    togglePhaseItemComplete(itemId: string,  cancelToken?: CancelToken): Promise<MilestonePhaseItemDto>;
    getLinks(jobId: number, itemId: string,  cancelToken?: CancelToken): Promise<MilestoneLinkDto[]>;
}

export class MilestonePhaseItemApiClient implements IMilestonePhaseItemApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listPhaseItems(jobId: string, filters: MilestonePhaseItemListRequest | undefined, cancelToken?: CancelToken): Promise<MilestonePhaseItemDto[]> {
        let url_ = this.baseUrl + "/MilestonePhaseItem/items/jobs/{jobId}/list";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPhaseItems(_response);
        });
    }

    protected processListPhaseItems(response: AxiosResponse): Promise<MilestonePhaseItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseItemDto[]>(null as any);
    }

    getPhaseItemById(itemId: string, cancelToken?: CancelToken): Promise<MilestonePhaseItemDto> {
        let url_ = this.baseUrl + "/MilestonePhaseItem/items/{itemId}";
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhaseItemById(_response);
        });
    }

    protected processGetPhaseItemById(response: AxiosResponse): Promise<MilestonePhaseItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseItemDto>(null as any);
    }

    deletePhaseItem(itemId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/MilestonePhaseItem/items/{itemId}";
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePhaseItem(_response);
        });
    }

    protected processDeletePhaseItem(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createPhaseItem(jobId: string, request: MilestonePhaseItemRequestDto, cancelToken?: CancelToken): Promise<MilestonePhaseItemDto> {
        let url_ = this.baseUrl + "/MilestonePhaseItem/items/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePhaseItem(_response);
        });
    }

    protected processCreatePhaseItem(response: AxiosResponse): Promise<MilestonePhaseItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseItemDto>(null as any);
    }

    updatePhaseItem(jobId: string, itemId: string, request: MilestonePhaseItemRequestDto, cancelToken?: CancelToken): Promise<MilestonePhaseItemDto> {
        let url_ = this.baseUrl + "/MilestonePhaseItem/items/jobs/{jobId}/items/{itemId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhaseItem(_response);
        });
    }

    protected processUpdatePhaseItem(response: AxiosResponse): Promise<MilestonePhaseItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseItemDto>(null as any);
    }

    movePhaseItem(jobId: string, itemId: string, request: MilestonePhaseItemMoveRequestDto, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/MilestonePhaseItem/items/jobs/{jobId}/items/{itemId}/move";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMovePhaseItem(_response);
        });
    }

    protected processMovePhaseItem(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    togglePhaseItemComplete(itemId: string, cancelToken?: CancelToken): Promise<MilestonePhaseItemDto> {
        let url_ = this.baseUrl + "/MilestonePhaseItem/items/{itemId}/toggle-complete";
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTogglePhaseItemComplete(_response);
        });
    }

    protected processTogglePhaseItemComplete(response: AxiosResponse): Promise<MilestonePhaseItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestonePhaseItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestonePhaseItemDto>(null as any);
    }

    getLinks(jobId: number, itemId: string, cancelToken?: CancelToken): Promise<MilestoneLinkDto[]> {
        let url_ = this.baseUrl + "/MilestonePhaseItem/items/jobs/{jobId}/items/{itemId}/links";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinks(_response);
        });
    }

    protected processGetLinks(response: AxiosResponse): Promise<MilestoneLinkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestoneLinkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestoneLinkDto[]>(null as any);
    }
}

export interface IMilestoneTemplateApiClient {
    createTemplate( cancelToken?: CancelToken): Promise<MilestoneTemplateDto>;
    updateTemplate(templateId: string, request: MilestoneTemplateRequestDto,  cancelToken?: CancelToken): Promise<MilestoneTemplateDto>;
    removeTemplate(templateId: string,  cancelToken?: CancelToken): Promise<MilestoneTemplateDto>;
    getTemplateById(templateId: string,  cancelToken?: CancelToken): Promise<MilestoneTemplateWithPhasesDto>;
    getTemplates( cancelToken?: CancelToken): Promise<MilestoneTemplateDto[]>;
}

export class MilestoneTemplateApiClient implements IMilestoneTemplateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createTemplate( cancelToken?: CancelToken): Promise<MilestoneTemplateDto> {
        let url_ = this.baseUrl + "/MilestoneTemplate/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTemplate(_response);
        });
    }

    protected processCreateTemplate(response: AxiosResponse): Promise<MilestoneTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestoneTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestoneTemplateDto>(null as any);
    }

    updateTemplate(templateId: string, request: MilestoneTemplateRequestDto, cancelToken?: CancelToken): Promise<MilestoneTemplateDto> {
        let url_ = this.baseUrl + "/MilestoneTemplate/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTemplate(_response);
        });
    }

    protected processUpdateTemplate(response: AxiosResponse): Promise<MilestoneTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestoneTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestoneTemplateDto>(null as any);
    }

    removeTemplate(templateId: string, cancelToken?: CancelToken): Promise<MilestoneTemplateDto> {
        let url_ = this.baseUrl + "/MilestoneTemplate/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveTemplate(_response);
        });
    }

    protected processRemoveTemplate(response: AxiosResponse): Promise<MilestoneTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestoneTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestoneTemplateDto>(null as any);
    }

    getTemplateById(templateId: string, cancelToken?: CancelToken): Promise<MilestoneTemplateWithPhasesDto> {
        let url_ = this.baseUrl + "/MilestoneTemplate/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateById(_response);
        });
    }

    protected processGetTemplateById(response: AxiosResponse): Promise<MilestoneTemplateWithPhasesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestoneTemplateWithPhasesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestoneTemplateWithPhasesDto>(null as any);
    }

    getTemplates( cancelToken?: CancelToken): Promise<MilestoneTemplateDto[]> {
        let url_ = this.baseUrl + "/MilestoneTemplate/templates/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplates(_response);
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<MilestoneTemplateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MilestoneTemplateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MilestoneTemplateDto[]>(null as any);
    }
}

export interface INotificationsApiClient {
    preview(resourceType: string, jobId: number, entityId: string, evt: string | null | undefined, external: boolean | undefined,  cancelToken?: CancelToken): Promise<NotificationPreviewDto>;
    send(resourceType: string, jobId: number, entityId: string, request: NotificationCompositionRequest,  cancelToken?: CancelToken): Promise<NotificationHistoryDto>;
    skip(resourceType: string, jobId: number, entityId: string, request: NotificationCompositionRequest,  cancelToken?: CancelToken): Promise<NotificationHistoryDto>;
    history(resourceType: string, jobId: number, entityId: string,  cancelToken?: CancelToken): Promise<NotificationHistoryDto[]>;
    resend(resourceType: string, jobId: number, entityId: string, logId: string,  cancelToken?: CancelToken): Promise<NotificationHistoryDto>;
}

export class NotificationsApiClient implements INotificationsApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    preview(resourceType: string, jobId: number, entityId: string, evt: string | null | undefined, external: boolean | undefined, cancelToken?: CancelToken): Promise<NotificationPreviewDto> {
        let url_ = this.baseUrl + "/notifications/{resourceType}/{jobId}/{entityId}/preview?";
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (evt !== undefined && evt !== null)
            url_ += "event=" + encodeURIComponent("" + evt) + "&";
        if (external === null)
            throw new globalThis.Error("The parameter 'external' cannot be null.");
        else if (external !== undefined)
            url_ += "external=" + encodeURIComponent("" + external) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<NotificationPreviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationPreviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationPreviewDto>(null as any);
    }

    send(resourceType: string, jobId: number, entityId: string, request: NotificationCompositionRequest, cancelToken?: CancelToken): Promise<NotificationHistoryDto> {
        let url_ = this.baseUrl + "/notifications/{resourceType}/{jobId}/{entityId}/send";
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: AxiosResponse): Promise<NotificationHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationHistoryDto>(null as any);
    }

    skip(resourceType: string, jobId: number, entityId: string, request: NotificationCompositionRequest, cancelToken?: CancelToken): Promise<NotificationHistoryDto> {
        let url_ = this.baseUrl + "/notifications/{resourceType}/{jobId}/{entityId}/skip";
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSkip(_response);
        });
    }

    protected processSkip(response: AxiosResponse): Promise<NotificationHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationHistoryDto>(null as any);
    }

    history(resourceType: string, jobId: number, entityId: string, cancelToken?: CancelToken): Promise<NotificationHistoryDto[]> {
        let url_ = this.baseUrl + "/notifications/{resourceType}/{jobId}/{entityId}";
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHistory(_response);
        });
    }

    protected processHistory(response: AxiosResponse): Promise<NotificationHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationHistoryDto[]>(null as any);
    }

    resend(resourceType: string, jobId: number, entityId: string, logId: string, cancelToken?: CancelToken): Promise<NotificationHistoryDto> {
        let url_ = this.baseUrl + "/notifications/{resourceType}/{jobId}/{entityId}/resend/{logId}";
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (logId === undefined || logId === null)
            throw new globalThis.Error("The parameter 'logId' must be defined.");
        url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResend(_response);
        });
    }

    protected processResend(response: AxiosResponse): Promise<NotificationHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationHistoryDto>(null as any);
    }
}

export interface IOfficeApiClient {
    list( cancelToken?: CancelToken): Promise<OrganizationOfficeDto[]>;
    create(request: OrganizationOfficeRequestDto,  cancelToken?: CancelToken): Promise<OrganizationOfficeDto>;
    /**
     * Get a single office by ID, applying the same office visibility scoping as List.
     */
    get(id: number,  cancelToken?: CancelToken): Promise<OrganizationOfficeDto>;
    update(id: number, request: OrganizationOfficeRequestDto,  cancelToken?: CancelToken): Promise<OrganizationOfficeDto>;
    delete(id: number,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    getByDivision(divisionId: number,  cancelToken?: CancelToken): Promise<OrganizationOfficeDto>;
}

export class OfficeApiClient implements IOfficeApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list( cancelToken?: CancelToken): Promise<OrganizationOfficeDto[]> {
        let url_ = this.baseUrl + "/Office";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<OrganizationOfficeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationOfficeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationOfficeDto[]>(null as any);
    }

    create(request: OrganizationOfficeRequestDto, cancelToken?: CancelToken): Promise<OrganizationOfficeDto> {
        let url_ = this.baseUrl + "/Office";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OrganizationOfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationOfficeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationOfficeDto>(null as any);
    }

    /**
     * Get a single office by ID, applying the same office visibility scoping as List.
     */
    get(id: number, cancelToken?: CancelToken): Promise<OrganizationOfficeDto> {
        let url_ = this.baseUrl + "/Office/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrganizationOfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationOfficeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationOfficeDto>(null as any);
    }

    update(id: number, request: OrganizationOfficeRequestDto, cancelToken?: CancelToken): Promise<OrganizationOfficeDto> {
        let url_ = this.baseUrl + "/Office/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OrganizationOfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationOfficeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationOfficeDto>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Office/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getByDivision(divisionId: number, cancelToken?: CancelToken): Promise<OrganizationOfficeDto> {
        let url_ = this.baseUrl + "/Office/by-division/{divisionId}";
        if (divisionId === undefined || divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' must be defined.");
        url_ = url_.replace("{divisionId}", encodeURIComponent("" + divisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDivision(_response);
        });
    }

    protected processGetByDivision(response: AxiosResponse): Promise<OrganizationOfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationOfficeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationOfficeDto>(null as any);
    }
}

export interface IOrganizationApiClient {
    syncDivisions( cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class OrganizationApiClient implements IOrganizationApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    syncDivisions( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Organization/sync/divisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncDivisions(_response);
        });
    }

    protected processSyncDivisions(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IOrganizationRoleApiClient {
    list( cancelToken?: CancelToken): Promise<OrganizationRoleDto[]>;
    create(request: OrganizationRoleRequestDto,  cancelToken?: CancelToken): Promise<OrganizationRoleDto>;
    /**
     * Get a single organization role by ID, applying the same office visibility scoping as List.
     */
    get(id: number,  cancelToken?: CancelToken): Promise<OrganizationRoleDto>;
    update(id: number, request: OrganizationRoleRequestDto,  cancelToken?: CancelToken): Promise<OrganizationRoleDto>;
    delete(id: number,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class OrganizationRoleApiClient implements IOrganizationRoleApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list( cancelToken?: CancelToken): Promise<OrganizationRoleDto[]> {
        let url_ = this.baseUrl + "/OrganizationRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<OrganizationRoleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationRoleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationRoleDto[]>(null as any);
    }

    create(request: OrganizationRoleRequestDto, cancelToken?: CancelToken): Promise<OrganizationRoleDto> {
        let url_ = this.baseUrl + "/OrganizationRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OrganizationRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationRoleDto>(null as any);
    }

    /**
     * Get a single organization role by ID, applying the same office visibility scoping as List.
     */
    get(id: number, cancelToken?: CancelToken): Promise<OrganizationRoleDto> {
        let url_ = this.baseUrl + "/OrganizationRole/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrganizationRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationRoleDto>(null as any);
    }

    update(id: number, request: OrganizationRoleRequestDto, cancelToken?: CancelToken): Promise<OrganizationRoleDto> {
        let url_ = this.baseUrl + "/OrganizationRole/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OrganizationRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationRoleDto>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/OrganizationRole/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IPayCodeApiClient {
    list(req: PayCodeListRequest,  cancelToken?: CancelToken): Promise<PayCodeDto[]>;
    get(id: string,  cancelToken?: CancelToken): Promise<PayCodeDto>;
    update(id: string, request: PayCodeRequestDto,  cancelToken?: CancelToken): Promise<PayCodeDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<PayCodeDto>;
    create(request: PayCodeRequestDto,  cancelToken?: CancelToken): Promise<PayCodeDto>;
}

export class PayCodeApiClient implements IPayCodeApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(req: PayCodeListRequest, cancelToken?: CancelToken): Promise<PayCodeDto[]> {
        let url_ = this.baseUrl + "/PayCode/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<PayCodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayCodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayCodeDto[]>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<PayCodeDto> {
        let url_ = this.baseUrl + "/PayCode/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PayCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayCodeDto>(null as any);
    }

    update(id: string, request: PayCodeRequestDto, cancelToken?: CancelToken): Promise<PayCodeDto> {
        let url_ = this.baseUrl + "/PayCode/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<PayCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayCodeDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<PayCodeDto> {
        let url_ = this.baseUrl + "/PayCode/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<PayCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayCodeDto>(null as any);
    }

    create(request: PayCodeRequestDto, cancelToken?: CancelToken): Promise<PayCodeDto> {
        let url_ = this.baseUrl + "/PayCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PayCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PayCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayCodeDto>(null as any);
    }
}

export interface IPostApiClient {
    /**
     * Get a single post by ID with authorization checks
     */
    getPostById(jobId: number, postId: string,  cancelToken?: CancelToken): Promise<PostDto>;
    /**
     * Update an existing post (creator only)
     */
    updatePost(jobId: number, postId: string, request: PostRequestDto,  cancelToken?: CancelToken): Promise<PostDto>;
    /**
     * Soft delete a post (creator only)
     */
    deletePost(jobId: number, postId: string,  cancelToken?: CancelToken): Promise<PostDto>;
    /**
     * Search posts with filters and pagination
     * @param sortBy (optional) 
     * @param postType (optional) 
     * @param query (optional) 
     * @param page (optional) 
     */
    searchPosts(jobId: number, request: PostSearchRequestDto, sortBy: string | undefined, postType: string | undefined, query: string | undefined, page: number | undefined,  cancelToken?: CancelToken): Promise<PaginatedPostResponse>;
    /**
     * Get all assigned unresolved posts (global)
     */
    getAllAssignedPosts( cancelToken?: CancelToken): Promise<PostDto[]>;
    /**
     * Get assigned unresolved posts for a specific job
     */
    getAssignedPosts(jobId: number,  cancelToken?: CancelToken): Promise<PostDto[]>;
    /**
     * Create a new post
     */
    createPost(jobId: number, request: PostRequestDto,  cancelToken?: CancelToken): Promise<PostDto>;
    /**
     * Toggle resolved status
     */
    resolvePost(jobId: number, postId: string, request: PostResolveRequestDto,  cancelToken?: CancelToken): Promise<PostDto>;
    /**
     * Get comments for a post
     */
    getComments(jobId: number, postId: string,  cancelToken?: CancelToken): Promise<PostCommentDto[]>;
    /**
     * Create a comment
     */
    createComment(jobId: number, postId: string, request: PostCommentRequestDto,  cancelToken?: CancelToken): Promise<PostCommentDto>;
    /**
     * Update a comment
     */
    updateComment(jobId: number, postId: string, commentId: string, request: PostCommentRequestDto,  cancelToken?: CancelToken): Promise<PostCommentDto>;
    /**
     * Delete a comment (author only)
     */
    deleteComment(jobId: number, postId: string, commentId: string,  cancelToken?: CancelToken): Promise<PostCommentDto>;
    /**
     * Search for linkable items (meetings, rfis, changes, dailys)
     */
    getLinkOptions(jobId: number, request: PostSearchQueryDto,  cancelToken?: CancelToken): Promise<PostLinkItemDto[]>;
    /**
     * Search for linkable documents
     */
    getDocumentOptions(jobId: number, request: PostSearchQueryDto,  cancelToken?: CancelToken): Promise<PostDocumentDto[]>;
}

export class PostApiClient implements IPostApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get a single post by ID with authorization checks
     */
    getPostById(jobId: number, postId: string, cancelToken?: CancelToken): Promise<PostDto> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/{postId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPostById(_response);
        });
    }

    protected processGetPostById(response: AxiosResponse): Promise<PostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDto>(null as any);
    }

    /**
     * Update an existing post (creator only)
     */
    updatePost(jobId: number, postId: string, request: PostRequestDto, cancelToken?: CancelToken): Promise<PostDto> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/{postId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePost(_response);
        });
    }

    protected processUpdatePost(response: AxiosResponse): Promise<PostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDto>(null as any);
    }

    /**
     * Soft delete a post (creator only)
     */
    deletePost(jobId: number, postId: string, cancelToken?: CancelToken): Promise<PostDto> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/{postId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePost(_response);
        });
    }

    protected processDeletePost(response: AxiosResponse): Promise<PostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDto>(null as any);
    }

    /**
     * Search posts with filters and pagination
     * @param sortBy (optional) 
     * @param postType (optional) 
     * @param query (optional) 
     * @param page (optional) 
     */
    searchPosts(jobId: number, request: PostSearchRequestDto, sortBy: string | undefined, postType: string | undefined, query: string | undefined, page: number | undefined, cancelToken?: CancelToken): Promise<PaginatedPostResponse> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/search?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (postType === null)
            throw new globalThis.Error("The parameter 'postType' cannot be null.");
        else if (postType !== undefined)
            url_ += "postType=" + encodeURIComponent("" + postType) + "&";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPosts(_response);
        });
    }

    protected processSearchPosts(response: AxiosResponse): Promise<PaginatedPostResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PaginatedPostResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedPostResponse>(null as any);
    }

    /**
     * Get all assigned unresolved posts (global)
     */
    getAllAssignedPosts( cancelToken?: CancelToken): Promise<PostDto[]> {
        let url_ = this.baseUrl + "/Post/assigned";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAssignedPosts(_response);
        });
    }

    protected processGetAllAssignedPosts(response: AxiosResponse): Promise<PostDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDto[]>(null as any);
    }

    /**
     * Get assigned unresolved posts for a specific job
     */
    getAssignedPosts(jobId: number, cancelToken?: CancelToken): Promise<PostDto[]> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/assigned";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignedPosts(_response);
        });
    }

    protected processGetAssignedPosts(response: AxiosResponse): Promise<PostDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDto[]>(null as any);
    }

    /**
     * Create a new post
     */
    createPost(jobId: number, request: PostRequestDto, cancelToken?: CancelToken): Promise<PostDto> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePost(_response);
        });
    }

    protected processCreatePost(response: AxiosResponse): Promise<PostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDto>(null as any);
    }

    /**
     * Toggle resolved status
     */
    resolvePost(jobId: number, postId: string, request: PostResolveRequestDto, cancelToken?: CancelToken): Promise<PostDto> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/{postId}/resolve";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolvePost(_response);
        });
    }

    protected processResolvePost(response: AxiosResponse): Promise<PostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDto>(null as any);
    }

    /**
     * Get comments for a post
     */
    getComments(jobId: number, postId: string, cancelToken?: CancelToken): Promise<PostCommentDto[]> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/{postId}/comments";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComments(_response);
        });
    }

    protected processGetComments(response: AxiosResponse): Promise<PostCommentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostCommentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostCommentDto[]>(null as any);
    }

    /**
     * Create a comment
     */
    createComment(jobId: number, postId: string, request: PostCommentRequestDto, cancelToken?: CancelToken): Promise<PostCommentDto> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/{postId}/comments";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateComment(_response);
        });
    }

    protected processCreateComment(response: AxiosResponse): Promise<PostCommentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostCommentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostCommentDto>(null as any);
    }

    /**
     * Update a comment
     */
    updateComment(jobId: number, postId: string, commentId: string, request: PostCommentRequestDto, cancelToken?: CancelToken): Promise<PostCommentDto> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/{postId}/comments/{commentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (commentId === undefined || commentId === null)
            throw new globalThis.Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: AxiosResponse): Promise<PostCommentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostCommentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostCommentDto>(null as any);
    }

    /**
     * Delete a comment (author only)
     */
    deleteComment(jobId: number, postId: string, commentId: string, cancelToken?: CancelToken): Promise<PostCommentDto> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/{postId}/comments/{commentId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (commentId === undefined || commentId === null)
            throw new globalThis.Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: AxiosResponse): Promise<PostCommentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostCommentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostCommentDto>(null as any);
    }

    /**
     * Search for linkable items (meetings, rfis, changes, dailys)
     */
    getLinkOptions(jobId: number, request: PostSearchQueryDto, cancelToken?: CancelToken): Promise<PostLinkItemDto[]> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/link-options";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkOptions(_response);
        });
    }

    protected processGetLinkOptions(response: AxiosResponse): Promise<PostLinkItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostLinkItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostLinkItemDto[]>(null as any);
    }

    /**
     * Search for linkable documents
     */
    getDocumentOptions(jobId: number, request: PostSearchQueryDto, cancelToken?: CancelToken): Promise<PostDocumentDto[]> {
        let url_ = this.baseUrl + "/Post/jobs/{jobId}/document-options";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentOptions(_response);
        });
    }

    protected processGetDocumentOptions(response: AxiosResponse): Promise<PostDocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostDocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDocumentDto[]>(null as any);
    }
}

export interface IProactSettingApiClient {
    get( cancelToken?: CancelToken): Promise<ProactSettingDto>;
    update(request: UpdateProactSettingRequest,  cancelToken?: CancelToken): Promise<ProactSettingDto>;
}

export class ProactSettingApiClient implements IProactSettingApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get( cancelToken?: CancelToken): Promise<ProactSettingDto> {
        let url_ = this.baseUrl + "/proact-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProactSettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProactSettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProactSettingDto>(null as any);
    }

    update(request: UpdateProactSettingRequest, cancelToken?: CancelToken): Promise<ProactSettingDto> {
        let url_ = this.baseUrl + "/proact-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ProactSettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProactSettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProactSettingDto>(null as any);
    }
}

export interface IRateApiClient {
    getOrgRates( cancelToken?: CancelToken): Promise<Rate[]>;
    getRatesByJob(jobId: number,  cancelToken?: CancelToken): Promise<Rate[]>;
    createJobRate(jobId: number, body: RateRequest,  cancelToken?: CancelToken): Promise<Rate>;
    removeJobRate(rateId: number,  cancelToken?: CancelToken): Promise<Rate>;
}

export class RateApiClient implements IRateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOrgRates( cancelToken?: CancelToken): Promise<Rate[]> {
        let url_ = this.baseUrl + "/Rate/org";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgRates(_response);
        });
    }

    protected processGetOrgRates(response: AxiosResponse): Promise<Rate[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Rate[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Rate[]>(null as any);
    }

    getRatesByJob(jobId: number, cancelToken?: CancelToken): Promise<Rate[]> {
        let url_ = this.baseUrl + "/Rate/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRatesByJob(_response);
        });
    }

    protected processGetRatesByJob(response: AxiosResponse): Promise<Rate[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Rate[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Rate[]>(null as any);
    }

    createJobRate(jobId: number, body: RateRequest, cancelToken?: CancelToken): Promise<Rate> {
        let url_ = this.baseUrl + "/Rate/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJobRate(_response);
        });
    }

    protected processCreateJobRate(response: AxiosResponse): Promise<Rate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Rate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Rate>(null as any);
    }

    removeJobRate(rateId: number, cancelToken?: CancelToken): Promise<Rate> {
        let url_ = this.baseUrl + "/Rate/{rateId}";
        if (rateId === undefined || rateId === null)
            throw new globalThis.Error("The parameter 'rateId' must be defined.");
        url_ = url_.replace("{rateId}", encodeURIComponent("" + rateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveJobRate(_response);
        });
    }

    protected processRemoveJobRate(response: AxiosResponse): Promise<Rate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Rate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Rate>(null as any);
    }
}

export interface IRfiApiClient {
    /**
     * Get all RFIs for a job
     */
    getRfisByJob(jobId: number,  cancelToken?: CancelToken): Promise<RfiDto[]>;
    /**
     * Create or update an RFI
     */
    createOrUpdateRfi(jobId: number, request: RfiRequestDto,  cancelToken?: CancelToken): Promise<RfiDto>;
    /**
     * Get a specific RFI by ID
     */
    getRfiById(jobId: number, rfiId: string,  cancelToken?: CancelToken): Promise<RfiDto>;
    /**
     * Get job documents that can be attached to an RFI from the system: non-folder, non-archived
    documents, excluding the generated "RFIs" folder.
     */
    getDocumentOptions(jobId: number,  cancelToken?: CancelToken): Promise<RfiDocumentOptionDto[]>;
    /**
     * Rotate the RFI's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, rfiId: string,  cancelToken?: CancelToken): Promise<RfiDto>;
    /**
     * Get RFI by ID for external users (no auth required)
     * @param token (optional) 
     */
    getExternalRfi(rfiId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<RfiDto>;
    /**
     * Update RFI from external user
     * @param token (optional) 
     */
    updateExternalRfi(rfiId: string, token: string | null | undefined, request: RfiExternalUpdateDto,  cancelToken?: CancelToken): Promise<RfiDto>;
    /**
     * Upload a temporary attachment file
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Clone an existing job document into a temporary RFI attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: RfiAttachFromDocumentRequest,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Get PDF link for an RFI
     */
    getRfiPdfLink(rfiId: string,  cancelToken?: CancelToken): Promise<RfiPdfLinkDto>;
    /**
     * Generate PDF for an RFI
     */
    generateRfiPdf(jobId: number, rfiId: string,  cancelToken?: CancelToken): Promise<PdfResult>;
    /**
     * Render an RFI PDF for preview without storing a document version.
     */
    previewRfiPdf(jobId: number, rfiId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Render the printable RFI Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getRfiLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class RfiApiClient implements IRfiApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all RFIs for a job
     */
    getRfisByJob(jobId: number, cancelToken?: CancelToken): Promise<RfiDto[]> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRfisByJob(_response);
        });
    }

    protected processGetRfisByJob(response: AxiosResponse): Promise<RfiDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiDto[]>(null as any);
    }

    /**
     * Create or update an RFI
     */
    createOrUpdateRfi(jobId: number, request: RfiRequestDto, cancelToken?: CancelToken): Promise<RfiDto> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateRfi(_response);
        });
    }

    protected processCreateOrUpdateRfi(response: AxiosResponse): Promise<RfiDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiDto>(null as any);
    }

    /**
     * Get a specific RFI by ID
     */
    getRfiById(jobId: number, rfiId: string, cancelToken?: CancelToken): Promise<RfiDto> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}/{rfiId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (rfiId === undefined || rfiId === null)
            throw new globalThis.Error("The parameter 'rfiId' must be defined.");
        url_ = url_.replace("{rfiId}", encodeURIComponent("" + rfiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRfiById(_response);
        });
    }

    protected processGetRfiById(response: AxiosResponse): Promise<RfiDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiDto>(null as any);
    }

    /**
     * Get job documents that can be attached to an RFI from the system: non-folder, non-archived
    documents, excluding the generated "RFIs" folder.
     */
    getDocumentOptions(jobId: number, cancelToken?: CancelToken): Promise<RfiDocumentOptionDto[]> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}/document-options";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentOptions(_response);
        });
    }

    protected processGetDocumentOptions(response: AxiosResponse): Promise<RfiDocumentOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiDocumentOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiDocumentOptionDto[]>(null as any);
    }

    /**
     * Rotate the RFI's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, rfiId: string, cancelToken?: CancelToken): Promise<RfiDto> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}/{rfiId}/external-access/rotate";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (rfiId === undefined || rfiId === null)
            throw new globalThis.Error("The parameter 'rfiId' must be defined.");
        url_ = url_.replace("{rfiId}", encodeURIComponent("" + rfiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRotateExternalAccess(_response);
        });
    }

    protected processRotateExternalAccess(response: AxiosResponse): Promise<RfiDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiDto>(null as any);
    }

    /**
     * Get RFI by ID for external users (no auth required)
     * @param token (optional) 
     */
    getExternalRfi(rfiId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<RfiDto> {
        let url_ = this.baseUrl + "/Rfi/external/{rfiId}?";
        if (rfiId === undefined || rfiId === null)
            throw new globalThis.Error("The parameter 'rfiId' must be defined.");
        url_ = url_.replace("{rfiId}", encodeURIComponent("" + rfiId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalRfi(_response);
        });
    }

    protected processGetExternalRfi(response: AxiosResponse): Promise<RfiDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiDto>(null as any);
    }

    /**
     * Update RFI from external user
     * @param token (optional) 
     */
    updateExternalRfi(rfiId: string, token: string | null | undefined, request: RfiExternalUpdateDto, cancelToken?: CancelToken): Promise<RfiDto> {
        let url_ = this.baseUrl + "/Rfi/external/{rfiId}?";
        if (rfiId === undefined || rfiId === null)
            throw new globalThis.Error("The parameter 'rfiId' must be defined.");
        url_ = url_.replace("{rfiId}", encodeURIComponent("" + rfiId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExternalRfi(_response);
        });
    }

    protected processUpdateExternalRfi(response: AxiosResponse): Promise<RfiDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiDto>(null as any);
    }

    /**
     * Upload a temporary attachment file
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Rfi/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (category !== null && category !== undefined)
            content_.append("category", category.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTempFile(_response);
        });
    }

    protected processUploadTempFile(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Clone an existing job document into a temporary RFI attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: RfiAttachFromDocumentRequest, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}/attach-from-document";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAttachFromDocument(_response);
        });
    }

    protected processAttachFromDocument(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Get PDF link for an RFI
     */
    getRfiPdfLink(rfiId: string, cancelToken?: CancelToken): Promise<RfiPdfLinkDto> {
        let url_ = this.baseUrl + "/Rfi/{rfiId}/pdf-link";
        if (rfiId === undefined || rfiId === null)
            throw new globalThis.Error("The parameter 'rfiId' must be defined.");
        url_ = url_.replace("{rfiId}", encodeURIComponent("" + rfiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRfiPdfLink(_response);
        });
    }

    protected processGetRfiPdfLink(response: AxiosResponse): Promise<RfiPdfLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiPdfLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiPdfLinkDto>(null as any);
    }

    /**
     * Generate PDF for an RFI
     */
    generateRfiPdf(jobId: number, rfiId: string, cancelToken?: CancelToken): Promise<PdfResult> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}/{rfiId}/pdf";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (rfiId === undefined || rfiId === null)
            throw new globalThis.Error("The parameter 'rfiId' must be defined.");
        url_ = url_.replace("{rfiId}", encodeURIComponent("" + rfiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateRfiPdf(_response);
        });
    }

    protected processGenerateRfiPdf(response: AxiosResponse): Promise<PdfResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PdfResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PdfResult>(null as any);
    }

    /**
     * Render an RFI PDF for preview without storing a document version.
     */
    previewRfiPdf(jobId: number, rfiId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}/{rfiId}/pdf/preview";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (rfiId === undefined || rfiId === null)
            throw new globalThis.Error("The parameter 'rfiId' must be defined.");
        url_ = url_.replace("{rfiId}", encodeURIComponent("" + rfiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewRfiPdf(_response);
        });
    }

    protected processPreviewRfiPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Render the printable RFI Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getRfiLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Rfi/job/{jobId}/log/pdf?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (submittedToContactId !== undefined && submittedToContactId !== null)
            url_ += "submittedToContactId=" + encodeURIComponent("" + submittedToContactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRfiLogPdf(_response);
        });
    }

    protected processGetRfiLogPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IRfisOverviewApiClient {
    /**
     * Get all RFIs across every job the caller can see, for the cross-job overview page.
     */
    getRfis( cancelToken?: CancelToken): Promise<RfiOverviewDto[]>;
}

export class RfisOverviewApiClient implements IRfisOverviewApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all RFIs across every job the caller can see, for the cross-job overview page.
     */
    getRfis( cancelToken?: CancelToken): Promise<RfiOverviewDto[]> {
        let url_ = this.baseUrl + "/rfis/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRfis(_response);
        });
    }

    protected processGetRfis(response: AxiosResponse): Promise<RfiOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RfiOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RfiOverviewDto[]>(null as any);
    }
}

export interface IScimIntegrationApiClient {
    list( cancelToken?: CancelToken): Promise<ScimIntegrationDto[]>;
    create(request: CreateScimIntegrationRequest,  cancelToken?: CancelToken): Promise<ScimIntegrationDto>;
    get(id: string,  cancelToken?: CancelToken): Promise<ScimIntegrationDto>;
    update(id: string, request: UpdateScimIntegrationRequest,  cancelToken?: CancelToken): Promise<ScimIntegrationDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    disable(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    test(id: string,  cancelToken?: CancelToken): Promise<ScimTestResult>;
    fullSync(id: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    mappings(id: string,  cancelToken?: CancelToken): Promise<ScimUserMappingDto[]>;
    logs(id: string, page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<ScimSyncLogResponse>;
    logDetail(id: string, logId: string,  cancelToken?: CancelToken): Promise<ScimSyncLogDetailDto>;
}

export class ScimIntegrationApiClient implements IScimIntegrationApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list( cancelToken?: CancelToken): Promise<ScimIntegrationDto[]> {
        let url_ = this.baseUrl + "/scim-integrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ScimIntegrationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScimIntegrationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScimIntegrationDto[]>(null as any);
    }

    create(request: CreateScimIntegrationRequest, cancelToken?: CancelToken): Promise<ScimIntegrationDto> {
        let url_ = this.baseUrl + "/scim-integrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ScimIntegrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScimIntegrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScimIntegrationDto>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<ScimIntegrationDto> {
        let url_ = this.baseUrl + "/scim-integrations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ScimIntegrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScimIntegrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScimIntegrationDto>(null as any);
    }

    update(id: string, request: UpdateScimIntegrationRequest, cancelToken?: CancelToken): Promise<ScimIntegrationDto> {
        let url_ = this.baseUrl + "/scim-integrations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ScimIntegrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScimIntegrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScimIntegrationDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim-integrations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    disable(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim-integrations/{id}/disable";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisable(_response);
        });
    }

    protected processDisable(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    test(id: string, cancelToken?: CancelToken): Promise<ScimTestResult> {
        let url_ = this.baseUrl + "/scim-integrations/{id}/test";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: AxiosResponse): Promise<ScimTestResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScimTestResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScimTestResult>(null as any);
    }

    fullSync(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim-integrations/{id}/full-sync";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFullSync(_response);
        });
    }

    protected processFullSync(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    mappings(id: string, cancelToken?: CancelToken): Promise<ScimUserMappingDto[]> {
        let url_ = this.baseUrl + "/scim-integrations/{id}/mappings";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMappings(_response);
        });
    }

    protected processMappings(response: AxiosResponse): Promise<ScimUserMappingDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScimUserMappingDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScimUserMappingDto[]>(null as any);
    }

    logs(id: string, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ScimSyncLogResponse> {
        let url_ = this.baseUrl + "/scim-integrations/{id}/logs?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogs(_response);
        });
    }

    protected processLogs(response: AxiosResponse): Promise<ScimSyncLogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScimSyncLogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScimSyncLogResponse>(null as any);
    }

    logDetail(id: string, logId: string, cancelToken?: CancelToken): Promise<ScimSyncLogDetailDto> {
        let url_ = this.baseUrl + "/scim-integrations/{id}/logs/{logId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (logId === undefined || logId === null)
            throw new globalThis.Error("The parameter 'logId' must be defined.");
        url_ = url_.replace("{logId}", encodeURIComponent("" + logId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogDetail(_response);
        });
    }

    protected processLogDetail(response: AxiosResponse): Promise<ScimSyncLogDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScimSyncLogDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScimSyncLogDetailDto>(null as any);
    }
}

export interface IServiceJobApiClient {
    /**
     * List all service jobs with optional filtering (admin only)
     */
    list(req: ServiceJobListRequest,  cancelToken?: CancelToken): Promise<JobDto[]>;
    /**
     * Get all service jobs for the current authenticated user
     */
    getMyServiceJobs( cancelToken?: CancelToken): Promise<JobDto[]>;
    /**
     * Get all service jobs for a specific user (admin only)
     */
    getUserServiceJobs(userId: number,  cancelToken?: CancelToken): Promise<JobDto[]>;
}

export class ServiceJobApiClient implements IServiceJobApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all service jobs with optional filtering (admin only)
     */
    list(req: ServiceJobListRequest, cancelToken?: CancelToken): Promise<JobDto[]> {
        let url_ = this.baseUrl + "/ServiceJob/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<JobDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto[]>(null as any);
    }

    /**
     * Get all service jobs for the current authenticated user
     */
    getMyServiceJobs( cancelToken?: CancelToken): Promise<JobDto[]> {
        let url_ = this.baseUrl + "/ServiceJob/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyServiceJobs(_response);
        });
    }

    protected processGetMyServiceJobs(response: AxiosResponse): Promise<JobDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto[]>(null as any);
    }

    /**
     * Get all service jobs for a specific user (admin only)
     */
    getUserServiceJobs(userId: number, cancelToken?: CancelToken): Promise<JobDto[]> {
        let url_ = this.baseUrl + "/ServiceJob/user/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserServiceJobs(_response);
        });
    }

    protected processGetUserServiceJobs(response: AxiosResponse): Promise<JobDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto[]>(null as any);
    }
}

export interface IServiceWorkOrderApiClient {
    search(query: string | null | undefined,  cancelToken?: CancelToken): Promise<ServiceWorkOrderSearchResultDto>;
}

export class ServiceWorkOrderApiClient implements IServiceWorkOrderApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    search(query: string | null | undefined, cancelToken?: CancelToken): Promise<ServiceWorkOrderSearchResultDto> {
        let url_ = this.baseUrl + "/ServiceWorkOrder/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<ServiceWorkOrderSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ServiceWorkOrderSearchResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceWorkOrderSearchResultDto>(null as any);
    }
}

export interface ISubmittalApiClient {
    /**
     * Get all Submittals for a job
     */
    getSubmittalsByJob(jobId: number,  cancelToken?: CancelToken): Promise<SubmittalDto[]>;
    /**
     * Create or update a Submittal
     */
    createOrUpdateSubmittal(jobId: number, request: SubmittalRequestDto,  cancelToken?: CancelToken): Promise<SubmittalDto>;
    /**
     * Get a specific Submittal by ID
     */
    getSubmittalById(jobId: number, submittalId: string,  cancelToken?: CancelToken): Promise<SubmittalDto>;
    /**
     * Get job documents that can be attached to a Submittal from the system: non-folder, non-archived
    documents, excluding the generated "Submittals" folder.
     */
    getDocumentOptions(jobId: number,  cancelToken?: CancelToken): Promise<SubmittalDocumentOptionDto[]>;
    /**
     * Rotate the Submittal's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, submittalId: string,  cancelToken?: CancelToken): Promise<SubmittalDto>;
    /**
     * Upload a temporary attachment file
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Clone an existing job document into a temporary Submittal attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: SubmittalAttachFromDocumentRequest,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Generate PDF for a Submittal
     */
    generateSubmittalPdf(jobId: number, submittalId: string,  cancelToken?: CancelToken): Promise<PdfResult>;
    /**
     * Render a Submittal PDF for preview without storing a document version.
     */
    previewSubmittalPdf(jobId: number, submittalId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Render the printable Submittal Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getSubmittalLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class SubmittalApiClient implements ISubmittalApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all Submittals for a job
     */
    getSubmittalsByJob(jobId: number, cancelToken?: CancelToken): Promise<SubmittalDto[]> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmittalsByJob(_response);
        });
    }

    protected processGetSubmittalsByJob(response: AxiosResponse): Promise<SubmittalDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SubmittalDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmittalDto[]>(null as any);
    }

    /**
     * Create or update a Submittal
     */
    createOrUpdateSubmittal(jobId: number, request: SubmittalRequestDto, cancelToken?: CancelToken): Promise<SubmittalDto> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateSubmittal(_response);
        });
    }

    protected processCreateOrUpdateSubmittal(response: AxiosResponse): Promise<SubmittalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SubmittalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmittalDto>(null as any);
    }

    /**
     * Get a specific Submittal by ID
     */
    getSubmittalById(jobId: number, submittalId: string, cancelToken?: CancelToken): Promise<SubmittalDto> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}/{submittalId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (submittalId === undefined || submittalId === null)
            throw new globalThis.Error("The parameter 'submittalId' must be defined.");
        url_ = url_.replace("{submittalId}", encodeURIComponent("" + submittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmittalById(_response);
        });
    }

    protected processGetSubmittalById(response: AxiosResponse): Promise<SubmittalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SubmittalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmittalDto>(null as any);
    }

    /**
     * Get job documents that can be attached to a Submittal from the system: non-folder, non-archived
    documents, excluding the generated "Submittals" folder.
     */
    getDocumentOptions(jobId: number, cancelToken?: CancelToken): Promise<SubmittalDocumentOptionDto[]> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}/document-options";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentOptions(_response);
        });
    }

    protected processGetDocumentOptions(response: AxiosResponse): Promise<SubmittalDocumentOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SubmittalDocumentOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmittalDocumentOptionDto[]>(null as any);
    }

    /**
     * Rotate the Submittal's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, submittalId: string, cancelToken?: CancelToken): Promise<SubmittalDto> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}/{submittalId}/external-access/rotate";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (submittalId === undefined || submittalId === null)
            throw new globalThis.Error("The parameter 'submittalId' must be defined.");
        url_ = url_.replace("{submittalId}", encodeURIComponent("" + submittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRotateExternalAccess(_response);
        });
    }

    protected processRotateExternalAccess(response: AxiosResponse): Promise<SubmittalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SubmittalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmittalDto>(null as any);
    }

    /**
     * Upload a temporary attachment file
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Submittal/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (category !== null && category !== undefined)
            content_.append("category", category.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTempFile(_response);
        });
    }

    protected processUploadTempFile(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Clone an existing job document into a temporary Submittal attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: SubmittalAttachFromDocumentRequest, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}/attach-from-document";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAttachFromDocument(_response);
        });
    }

    protected processAttachFromDocument(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Generate PDF for a Submittal
     */
    generateSubmittalPdf(jobId: number, submittalId: string, cancelToken?: CancelToken): Promise<PdfResult> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}/{submittalId}/pdf";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (submittalId === undefined || submittalId === null)
            throw new globalThis.Error("The parameter 'submittalId' must be defined.");
        url_ = url_.replace("{submittalId}", encodeURIComponent("" + submittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSubmittalPdf(_response);
        });
    }

    protected processGenerateSubmittalPdf(response: AxiosResponse): Promise<PdfResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PdfResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PdfResult>(null as any);
    }

    /**
     * Render a Submittal PDF for preview without storing a document version.
     */
    previewSubmittalPdf(jobId: number, submittalId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}/{submittalId}/pdf/preview";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (submittalId === undefined || submittalId === null)
            throw new globalThis.Error("The parameter 'submittalId' must be defined.");
        url_ = url_.replace("{submittalId}", encodeURIComponent("" + submittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewSubmittalPdf(_response);
        });
    }

    protected processPreviewSubmittalPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Render the printable Submittal Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getSubmittalLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Submittal/job/{jobId}/log/pdf?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (submittedToContactId !== undefined && submittedToContactId !== null)
            url_ += "submittedToContactId=" + encodeURIComponent("" + submittedToContactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmittalLogPdf(_response);
        });
    }

    protected processGetSubmittalLogPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface ITimesheetApiClient {
    /**
     * Get users who belong to the given office as their primary office, for use
    in timesheet-report employee pickers. Honors the "only my team" filter.
     * @param onlyMyTeam (optional) 
     */
    getTimesheetUsersForOffice(officeId: number, onlyMyTeam: boolean | null | undefined,  cancelToken?: CancelToken): Promise<UserDto[]>;
    /**
     * The Timesheet Payroll Report for one office and work week as a PDF: approved timesheets of
    the office's report users, one block per employee.
     */
    getTimesheetPayrollPdf(req: GetTimesheetReportRequest,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * The Timesheet Audit Report for one employee of an office as a PDF: one card per approved
    timesheet created in the date range, with rows, signature and history.
     */
    getTimesheetAuditPdf(request: GetAuditReportRequest,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    getTimesheetExcelExport(request: GetTimesheetExcelExportRequest,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    getTimesheetWeekHours(userId: number, year: number, weekId: number,  cancelToken?: CancelToken): Promise<TimesheetWeekHoursDto>;
    getTimesheet(request: GetTimesheetRequest,  cancelToken?: CancelToken): Promise<TimesheetDto>;
    getTimesheets(req: GetTimesheetsRequest,  cancelToken?: CancelToken): Promise<TimesheetDto[]>;
    getTimeSummary(officeId: number, year: number, weekId: number, onlyMyTeam: boolean | null | undefined,  cancelToken?: CancelToken): Promise<{ [key: string]: number; }>;
    getMissingTimesheetsForOffice(officeId: number, year: number, weekId: number, request: GetMissingTimesheetsRequest,  cancelToken?: CancelToken): Promise<MissingTimesheetUserRow[]>;
    bulkTransitionTimesheets(request: BulkTransitionTimesheetsRequest,  cancelToken?: CancelToken): Promise<TimesheetDto[]>;
    createTimesheet(data: TimesheetRequestDto,  cancelToken?: CancelToken): Promise<TimesheetDto>;
    sendTimesheetNotification(data: GetTimesheetRequest,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    updateExternal(timesheetId: string, token: string | null | undefined, req: UpdateExternalTimesheetRequest,  cancelToken?: CancelToken): Promise<TimesheetDto>;
    getExternalTimesheetById(timesheetId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<TimesheetDto>;
    getExternalBatchReview(token: string,  cancelToken?: CancelToken): Promise<CombinedTimesheetReviewDto>;
    updateExternalBatchReview(token: string, request: BulkBatchApprovalRequest,  cancelToken?: CancelToken): Promise<TimesheetDto[]>;
    previewEffectiveRate(request: PreviewEffectiveRateRequest,  cancelToken?: CancelToken): Promise<EffectiveRateCalculationResponse>;
    delete(id: string,  cancelToken?: CancelToken): Promise<boolean>;
}

export class TimesheetApiClient implements ITimesheetApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get users who belong to the given office as their primary office, for use
    in timesheet-report employee pickers. Honors the "only my team" filter.
     * @param onlyMyTeam (optional) 
     */
    getTimesheetUsersForOffice(officeId: number, onlyMyTeam: boolean | null | undefined, cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/users/office/{officeId}?";
        if (officeId === undefined || officeId === null)
            throw new globalThis.Error("The parameter 'officeId' must be defined.");
        url_ = url_.replace("{officeId}", encodeURIComponent("" + officeId));
        if (onlyMyTeam !== undefined && onlyMyTeam !== null)
            url_ += "onlyMyTeam=" + encodeURIComponent("" + onlyMyTeam) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimesheetUsersForOffice(_response);
        });
    }

    protected processGetTimesheetUsersForOffice(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * The Timesheet Payroll Report for one office and work week as a PDF: approved timesheets of
    the office's report users, one block per employee.
     */
    getTimesheetPayrollPdf(req: GetTimesheetReportRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/payroll/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimesheetPayrollPdf(_response);
        });
    }

    protected processGetTimesheetPayrollPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * The Timesheet Audit Report for one employee of an office as a PDF: one card per approved
    timesheet created in the date range, with rows, signature and history.
     */
    getTimesheetAuditPdf(request: GetAuditReportRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/audit/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimesheetAuditPdf(_response);
        });
    }

    protected processGetTimesheetAuditPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getTimesheetExcelExport(request: GetTimesheetExcelExportRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Timesheet/export/excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimesheetExcelExport(_response);
        });
    }

    protected processGetTimesheetExcelExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getTimesheetWeekHours(userId: number, year: number, weekId: number, cancelToken?: CancelToken): Promise<TimesheetWeekHoursDto> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/users/{userId}/weeks/{year}/{weekId}/hours";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (weekId === undefined || weekId === null)
            throw new globalThis.Error("The parameter 'weekId' must be defined.");
        url_ = url_.replace("{weekId}", encodeURIComponent("" + weekId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimesheetWeekHours(_response);
        });
    }

    protected processGetTimesheetWeekHours(response: AxiosResponse): Promise<TimesheetWeekHoursDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimesheetWeekHoursDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimesheetWeekHoursDto>(null as any);
    }

    getTimesheet(request: GetTimesheetRequest, cancelToken?: CancelToken): Promise<TimesheetDto> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/single";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimesheet(_response);
        });
    }

    protected processGetTimesheet(response: AxiosResponse): Promise<TimesheetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimesheetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimesheetDto>(null as any);
    }

    getTimesheets(req: GetTimesheetsRequest, cancelToken?: CancelToken): Promise<TimesheetDto[]> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimesheets(_response);
        });
    }

    protected processGetTimesheets(response: AxiosResponse): Promise<TimesheetDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimesheetDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimesheetDto[]>(null as any);
    }

    getTimeSummary(officeId: number, year: number, weekId: number, onlyMyTeam: boolean | null | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/Timesheet/summary/offices/{officeId}/{year}/{weekId}?";
        if (officeId === undefined || officeId === null)
            throw new globalThis.Error("The parameter 'officeId' must be defined.");
        url_ = url_.replace("{officeId}", encodeURIComponent("" + officeId));
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (weekId === undefined || weekId === null)
            throw new globalThis.Error("The parameter 'weekId' must be defined.");
        url_ = url_.replace("{weekId}", encodeURIComponent("" + weekId));
        if (onlyMyTeam !== undefined && onlyMyTeam !== null)
            url_ += "onlyMyTeam=" + encodeURIComponent("" + onlyMyTeam) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeSummary(_response);
        });
    }

    protected processGetTimeSummary(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    getMissingTimesheetsForOffice(officeId: number, year: number, weekId: number, request: GetMissingTimesheetsRequest, cancelToken?: CancelToken): Promise<MissingTimesheetUserRow[]> {
        let url_ = this.baseUrl + "/Timesheet/missing/offices/{officeId}/{year}/{weekId}";
        if (officeId === undefined || officeId === null)
            throw new globalThis.Error("The parameter 'officeId' must be defined.");
        url_ = url_.replace("{officeId}", encodeURIComponent("" + officeId));
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (weekId === undefined || weekId === null)
            throw new globalThis.Error("The parameter 'weekId' must be defined.");
        url_ = url_.replace("{weekId}", encodeURIComponent("" + weekId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissingTimesheetsForOffice(_response);
        });
    }

    protected processGetMissingTimesheetsForOffice(response: AxiosResponse): Promise<MissingTimesheetUserRow[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MissingTimesheetUserRow[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MissingTimesheetUserRow[]>(null as any);
    }

    bulkTransitionTimesheets(request: BulkTransitionTimesheetsRequest, cancelToken?: CancelToken): Promise<TimesheetDto[]> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/bulk/transition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkTransitionTimesheets(_response);
        });
    }

    protected processBulkTransitionTimesheets(response: AxiosResponse): Promise<TimesheetDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimesheetDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimesheetDto[]>(null as any);
    }

    createTimesheet(data: TimesheetRequestDto, cancelToken?: CancelToken): Promise<TimesheetDto> {
        let url_ = this.baseUrl + "/Timesheet/timesheets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTimesheet(_response);
        });
    }

    protected processCreateTimesheet(response: AxiosResponse): Promise<TimesheetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimesheetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimesheetDto>(null as any);
    }

    sendTimesheetNotification(data: GetTimesheetRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTimesheetNotification(_response);
        });
    }

    protected processSendTimesheetNotification(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateExternal(timesheetId: string, token: string | null | undefined, req: UpdateExternalTimesheetRequest, cancelToken?: CancelToken): Promise<TimesheetDto> {
        let url_ = this.baseUrl + "/Timesheet/external/{timesheetId}?";
        if (timesheetId === undefined || timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' must be defined.");
        url_ = url_.replace("{timesheetId}", encodeURIComponent("" + timesheetId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExternal(_response);
        });
    }

    protected processUpdateExternal(response: AxiosResponse): Promise<TimesheetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimesheetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimesheetDto>(null as any);
    }

    getExternalTimesheetById(timesheetId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<TimesheetDto> {
        let url_ = this.baseUrl + "/Timesheet/external/{timesheetId}?";
        if (timesheetId === undefined || timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' must be defined.");
        url_ = url_.replace("{timesheetId}", encodeURIComponent("" + timesheetId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalTimesheetById(_response);
        });
    }

    protected processGetExternalTimesheetById(response: AxiosResponse): Promise<TimesheetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimesheetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimesheetDto>(null as any);
    }

    getExternalBatchReview(token: string, cancelToken?: CancelToken): Promise<CombinedTimesheetReviewDto> {
        let url_ = this.baseUrl + "/Timesheet/external/batch/{token}";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalBatchReview(_response);
        });
    }

    protected processGetExternalBatchReview(response: AxiosResponse): Promise<CombinedTimesheetReviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CombinedTimesheetReviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CombinedTimesheetReviewDto>(null as any);
    }

    updateExternalBatchReview(token: string, request: BulkBatchApprovalRequest, cancelToken?: CancelToken): Promise<TimesheetDto[]> {
        let url_ = this.baseUrl + "/Timesheet/external/batch/{token}";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExternalBatchReview(_response);
        });
    }

    protected processUpdateExternalBatchReview(response: AxiosResponse): Promise<TimesheetDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimesheetDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimesheetDto[]>(null as any);
    }

    previewEffectiveRate(request: PreviewEffectiveRateRequest, cancelToken?: CancelToken): Promise<EffectiveRateCalculationResponse> {
        let url_ = this.baseUrl + "/Timesheet/rates/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewEffectiveRate(_response);
        });
    }

    protected processPreviewEffectiveRate(response: AxiosResponse): Promise<EffectiveRateCalculationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EffectiveRateCalculationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EffectiveRateCalculationResponse>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Timesheet/timesheets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ITransmittalApiClient {
    /**
     * Get all Transmittals for a job
     */
    getTransmittalsByJob(jobId: number,  cancelToken?: CancelToken): Promise<TransmittalDto[]>;
    /**
     * Create or update a Transmittal
     */
    createOrUpdateTransmittal(jobId: number, request: TransmittalRequestDto,  cancelToken?: CancelToken): Promise<TransmittalDto>;
    /**
     * Get a specific Transmittal by ID
     */
    getTransmittalById(jobId: number, transmittalId: string,  cancelToken?: CancelToken): Promise<TransmittalDto>;
    /**
     * Get all PDF documents in the Transmittals folder for a job
     */
    getAllTransmittalPdfLinks(jobId: number,  cancelToken?: CancelToken): Promise<TransmittalPdfLinkDto[]>;
    /**
     * Get job documents that can be attached to a Transmittal from the system: non-folder,
    non-archived documents, excluding the generated "Transmittals" folder.
     */
    getDocumentOptions(jobId: number,  cancelToken?: CancelToken): Promise<TransmittalPdfOptionDto[]>;
    /**
     * Get the latest PDF link for a specific transmittal
     */
    getLatestTransmittalPdf(jobId: number, transmittalId: string,  cancelToken?: CancelToken): Promise<TransmittalPdfLinkDto>;
    /**
     * Rotate the Transmittal's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, transmittalId: string,  cancelToken?: CancelToken): Promise<TransmittalDto>;
    /**
     * Get Transmittal by ID for external users (no auth required)
     * @param token (optional) 
     */
    getExternalTransmittal(transmittalId: string, token: string | null | undefined,  cancelToken?: CancelToken): Promise<TransmittalDto>;
    /**
     * Update Transmittal from external user
     * @param token (optional) 
     */
    updateExternalTransmittal(transmittalId: string, token: string | null | undefined, request: TransmittalExternalUpdateDto,  cancelToken?: CancelToken): Promise<TransmittalDto>;
    /**
     * Upload a temporary attachment file for transmittal
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Clone an existing job document into a temporary transmittal attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: TransmittalAttachFromDocumentRequest,  cancelToken?: CancelToken): Promise<ResourceAttachmentDto>;
    /**
     * Generate PDF for a Transmittal
     */
    generateTransmittalPdf(jobId: number, transmittalId: string,  cancelToken?: CancelToken): Promise<PdfResult>;
    /**
     * Render a Transmittal PDF for preview without storing a document version.
     */
    previewTransmittalPdf(jobId: number, transmittalId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Render the printable Transmittal Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getTransmittalLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class TransmittalApiClient implements ITransmittalApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all Transmittals for a job
     */
    getTransmittalsByJob(jobId: number, cancelToken?: CancelToken): Promise<TransmittalDto[]> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransmittalsByJob(_response);
        });
    }

    protected processGetTransmittalsByJob(response: AxiosResponse): Promise<TransmittalDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalDto[]>(null as any);
    }

    /**
     * Create or update a Transmittal
     */
    createOrUpdateTransmittal(jobId: number, request: TransmittalRequestDto, cancelToken?: CancelToken): Promise<TransmittalDto> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateTransmittal(_response);
        });
    }

    protected processCreateOrUpdateTransmittal(response: AxiosResponse): Promise<TransmittalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalDto>(null as any);
    }

    /**
     * Get a specific Transmittal by ID
     */
    getTransmittalById(jobId: number, transmittalId: string, cancelToken?: CancelToken): Promise<TransmittalDto> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/{transmittalId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (transmittalId === undefined || transmittalId === null)
            throw new globalThis.Error("The parameter 'transmittalId' must be defined.");
        url_ = url_.replace("{transmittalId}", encodeURIComponent("" + transmittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransmittalById(_response);
        });
    }

    protected processGetTransmittalById(response: AxiosResponse): Promise<TransmittalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalDto>(null as any);
    }

    /**
     * Get all PDF documents in the Transmittals folder for a job
     */
    getAllTransmittalPdfLinks(jobId: number, cancelToken?: CancelToken): Promise<TransmittalPdfLinkDto[]> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/pdf-links";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTransmittalPdfLinks(_response);
        });
    }

    protected processGetAllTransmittalPdfLinks(response: AxiosResponse): Promise<TransmittalPdfLinkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalPdfLinkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalPdfLinkDto[]>(null as any);
    }

    /**
     * Get job documents that can be attached to a Transmittal from the system: non-folder,
    non-archived documents, excluding the generated "Transmittals" folder.
     */
    getDocumentOptions(jobId: number, cancelToken?: CancelToken): Promise<TransmittalPdfOptionDto[]> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/document-options";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentOptions(_response);
        });
    }

    protected processGetDocumentOptions(response: AxiosResponse): Promise<TransmittalPdfOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalPdfOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalPdfOptionDto[]>(null as any);
    }

    /**
     * Get the latest PDF link for a specific transmittal
     */
    getLatestTransmittalPdf(jobId: number, transmittalId: string, cancelToken?: CancelToken): Promise<TransmittalPdfLinkDto> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/{transmittalId}/latest-pdf";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (transmittalId === undefined || transmittalId === null)
            throw new globalThis.Error("The parameter 'transmittalId' must be defined.");
        url_ = url_.replace("{transmittalId}", encodeURIComponent("" + transmittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestTransmittalPdf(_response);
        });
    }

    protected processGetLatestTransmittalPdf(response: AxiosResponse): Promise<TransmittalPdfLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalPdfLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalPdfLinkDto>(null as any);
    }

    /**
     * Rotate the Transmittal's external access token, revoking every previously shared customer link.
     */
    rotateExternalAccess(jobId: number, transmittalId: string, cancelToken?: CancelToken): Promise<TransmittalDto> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/{transmittalId}/external-access/rotate";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (transmittalId === undefined || transmittalId === null)
            throw new globalThis.Error("The parameter 'transmittalId' must be defined.");
        url_ = url_.replace("{transmittalId}", encodeURIComponent("" + transmittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRotateExternalAccess(_response);
        });
    }

    protected processRotateExternalAccess(response: AxiosResponse): Promise<TransmittalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalDto>(null as any);
    }

    /**
     * Get Transmittal by ID for external users (no auth required)
     * @param token (optional) 
     */
    getExternalTransmittal(transmittalId: string, token: string | null | undefined, cancelToken?: CancelToken): Promise<TransmittalDto> {
        let url_ = this.baseUrl + "/Transmittal/external/{transmittalId}?";
        if (transmittalId === undefined || transmittalId === null)
            throw new globalThis.Error("The parameter 'transmittalId' must be defined.");
        url_ = url_.replace("{transmittalId}", encodeURIComponent("" + transmittalId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalTransmittal(_response);
        });
    }

    protected processGetExternalTransmittal(response: AxiosResponse): Promise<TransmittalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalDto>(null as any);
    }

    /**
     * Update Transmittal from external user
     * @param token (optional) 
     */
    updateExternalTransmittal(transmittalId: string, token: string | null | undefined, request: TransmittalExternalUpdateDto, cancelToken?: CancelToken): Promise<TransmittalDto> {
        let url_ = this.baseUrl + "/Transmittal/external/{transmittalId}?";
        if (transmittalId === undefined || transmittalId === null)
            throw new globalThis.Error("The parameter 'transmittalId' must be defined.");
        url_ = url_.replace("{transmittalId}", encodeURIComponent("" + transmittalId));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExternalTransmittal(_response);
        });
    }

    protected processUpdateExternalTransmittal(response: AxiosResponse): Promise<TransmittalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransmittalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransmittalDto>(null as any);
    }

    /**
     * Upload a temporary attachment file for transmittal
     * @param file (optional) 
     * @param category (optional) 
     */
    uploadTempFile(file: FileParameter | undefined, category: string | null | undefined, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Transmittal/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (category !== null && category !== undefined)
            content_.append("category", category.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTempFile(_response);
        });
    }

    protected processUploadTempFile(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Clone an existing job document into a temporary transmittal attachment so it can be added on save.
     */
    attachFromDocument(jobId: number, request: TransmittalAttachFromDocumentRequest, cancelToken?: CancelToken): Promise<ResourceAttachmentDto> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/attach-from-document";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAttachFromDocument(_response);
        });
    }

    protected processAttachFromDocument(response: AxiosResponse): Promise<ResourceAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ResourceAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceAttachmentDto>(null as any);
    }

    /**
     * Generate PDF for a Transmittal
     */
    generateTransmittalPdf(jobId: number, transmittalId: string, cancelToken?: CancelToken): Promise<PdfResult> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/{transmittalId}/pdf";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (transmittalId === undefined || transmittalId === null)
            throw new globalThis.Error("The parameter 'transmittalId' must be defined.");
        url_ = url_.replace("{transmittalId}", encodeURIComponent("" + transmittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateTransmittalPdf(_response);
        });
    }

    protected processGenerateTransmittalPdf(response: AxiosResponse): Promise<PdfResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PdfResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PdfResult>(null as any);
    }

    /**
     * Render a Transmittal PDF for preview without storing a document version.
     */
    previewTransmittalPdf(jobId: number, transmittalId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/{transmittalId}/pdf/preview";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (transmittalId === undefined || transmittalId === null)
            throw new globalThis.Error("The parameter 'transmittalId' must be defined.");
        url_ = url_.replace("{transmittalId}", encodeURIComponent("" + transmittalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewTransmittalPdf(_response);
        });
    }

    protected processPreviewTransmittalPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Render the printable Transmittal Log for a job as landscape PDF bytes. Not stored.
     * @param statuses (optional) 
     * @param submittedToContactId (optional) 
     */
    getTransmittalLogPdf(jobId: number, statuses: string[] | null | undefined, submittedToContactId: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Transmittal/job/{jobId}/log/pdf?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (submittedToContactId !== undefined && submittedToContactId !== null)
            url_ += "submittedToContactId=" + encodeURIComponent("" + submittedToContactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransmittalLogPdf(_response);
        });
    }

    protected processGetTransmittalLogPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IUnitPricingApiClient {
    getUnitPricing( cancelToken?: CancelToken): Promise<UnitPricing[]>;
}

export class UnitPricingApiClient implements IUnitPricingApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUnitPricing( cancelToken?: CancelToken): Promise<UnitPricing[]> {
        let url_ = this.baseUrl + "/UnitPricing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnitPricing(_response);
        });
    }

    protected processGetUnitPricing(response: AxiosResponse): Promise<UnitPricing[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UnitPricing[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitPricing[]>(null as any);
    }
}

export interface IUserApiClient {
    me( cancelToken?: CancelToken): Promise<UserDto>;
    getUsers( cancelToken?: CancelToken): Promise<UserDto[]>;
    /**
     * Search users by name for pickers, limited to 100 results.
     * @param query (optional) 
     */
    searchUsers(query: string | null | undefined,  cancelToken?: CancelToken): Promise<UserSearchDto[]>;
    getUserLogins(id: number,  cancelToken?: CancelToken): Promise<UserLoginDto[]>;
    getUsersLogins(page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<PagedResultOfUserLoginDto>;
    /**
     * List the users visible to the requesting user. Archived users are left out unless includeArchived is true.
    Admins can see all users; non-admins only see users in their offices.
     * @param includeArchived (optional) 
     */
    listAdminUsers(includeArchived: boolean | undefined,  cancelToken?: CancelToken): Promise<UserDto[]>;
    /**
     * Get a single user by ID, applying the same visibility rules as ListAdminUsers.
     */
    getAdminUser(id: number,  cancelToken?: CancelToken): Promise<UserDto>;
    /**
     * Update an existing user with the specified roles, offices, and permissions.
     */
    updateUser(id: number, request: UpdateUserRequest,  cancelToken?: CancelToken): Promise<UserDto>;
    /**
     * Invite/create a new user with the specified roles, offices, and permissions.
     */
    inviteUser(request: InviteUserRequest,  cancelToken?: CancelToken): Promise<UserDto>;
    /**
     * Update only the status of an existing user.
     */
    updateUserStatus(id: number, request: UpdateUserStatusRequest,  cancelToken?: CancelToken): Promise<UserDto>;
    /**
     * Archive a user: disables sign-in and hides them from pickers while keeping every
    historical reference to them intact.
     */
    archiveUser(id: number,  cancelToken?: CancelToken): Promise<UserDto>;
    /**
     * The user returns to invited if they never signed in, otherwise to confirmed.
     */
    unarchiveUser(id: number,  cancelToken?: CancelToken): Promise<UserDto>;
    /**
     * Assume the identity of a target user for debugging. Restricted to sys_admin.
    Creates an audit log entry and returns the target user's profile.
     */
    assumeUser(id: number,  cancelToken?: CancelToken): Promise<UserDto>;
}

export class UserApiClient implements IUserApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    me( cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getUsers( cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * Search users by name for pickers, limited to 100 results.
     * @param query (optional) 
     */
    searchUsers(query: string | null | undefined, cancelToken?: CancelToken): Promise<UserSearchDto[]> {
        let url_ = this.baseUrl + "/user/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: AxiosResponse): Promise<UserSearchDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserSearchDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSearchDto[]>(null as any);
    }

    getUserLogins(id: number, cancelToken?: CancelToken): Promise<UserLoginDto[]> {
        let url_ = this.baseUrl + "/user/{id}/logins";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserLogins(_response);
        });
    }

    protected processGetUserLogins(response: AxiosResponse): Promise<UserLoginDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserLoginDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLoginDto[]>(null as any);
    }

    getUsersLogins(page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResultOfUserLoginDto> {
        let url_ = this.baseUrl + "/user/logins?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersLogins(_response);
        });
    }

    protected processGetUsersLogins(response: AxiosResponse): Promise<PagedResultOfUserLoginDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedResultOfUserLoginDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultOfUserLoginDto>(null as any);
    }

    /**
     * List the users visible to the requesting user. Archived users are left out unless includeArchived is true.
    Admins can see all users; non-admins only see users in their offices.
     * @param includeArchived (optional) 
     */
    listAdminUsers(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/user/admin/list?";
        if (includeArchived === null)
            throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAdminUsers(_response);
        });
    }

    protected processListAdminUsers(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * Get a single user by ID, applying the same visibility rules as ListAdminUsers.
     */
    getAdminUser(id: number, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/admin/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminUser(_response);
        });
    }

    protected processGetAdminUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * Update an existing user with the specified roles, offices, and permissions.
     */
    updateUser(id: number, request: UpdateUserRequest, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/admin/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * Invite/create a new user with the specified roles, offices, and permissions.
     */
    inviteUser(request: InviteUserRequest, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/admin/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteUser(_response);
        });
    }

    protected processInviteUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * Update only the status of an existing user.
     */
    updateUserStatus(id: number, request: UpdateUserStatusRequest, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/admin/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserStatus(_response);
        });
    }

    protected processUpdateUserStatus(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * Archive a user: disables sign-in and hides them from pickers while keeping every
    historical reference to them intact.
     */
    archiveUser(id: number, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/admin/{id}/archive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveUser(_response);
        });
    }

    protected processArchiveUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * The user returns to invited if they never signed in, otherwise to confirmed.
     */
    unarchiveUser(id: number, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/admin/{id}/unarchive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnarchiveUser(_response);
        });
    }

    protected processUnarchiveUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * Assume the identity of a target user for debugging. Restricted to sys_admin.
    Creates an audit log entry and returns the target user's profile.
     */
    assumeUser(id: number, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/admin/{id}/assume";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssumeUser(_response);
        });
    }

    protected processAssumeUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export interface IUserNotificationApiClient {
    list(req: UserNotificationListRequest,  cancelToken?: CancelToken): Promise<UserNotificationDto[]>;
    get(id: string,  cancelToken?: CancelToken): Promise<UserNotificationDto>;
    markRead(id: string, request: UserNotificationMarkReadRequest,  cancelToken?: CancelToken): Promise<UserNotificationDto>;
    forceRead(id: string, request: UserNotificationMarkReadRequest,  cancelToken?: CancelToken): Promise<UserNotificationDto>;
}

export class UserNotificationApiClient implements IUserNotificationApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(req: UserNotificationListRequest, cancelToken?: CancelToken): Promise<UserNotificationDto[]> {
        let url_ = this.baseUrl + "/UserNotification/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<UserNotificationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserNotificationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserNotificationDto[]>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<UserNotificationDto> {
        let url_ = this.baseUrl + "/UserNotification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserNotificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserNotificationDto>(null as any);
    }

    markRead(id: string, request: UserNotificationMarkReadRequest, cancelToken?: CancelToken): Promise<UserNotificationDto> {
        let url_ = this.baseUrl + "/UserNotification/{id}/mark-read";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkRead(_response);
        });
    }

    protected processMarkRead(response: AxiosResponse): Promise<UserNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserNotificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserNotificationDto>(null as any);
    }

    forceRead(id: string, request: UserNotificationMarkReadRequest, cancelToken?: CancelToken): Promise<UserNotificationDto> {
        let url_ = this.baseUrl + "/UserNotification/{id}/force-read";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForceRead(_response);
        });
    }

    protected processForceRead(response: AxiosResponse): Promise<UserNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserNotificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserNotificationDto>(null as any);
    }
}

export interface IUserProfileApiClient {
    updateNotificationChannels(request: UpdateNotificationChannelsRequest,  cancelToken?: CancelToken): Promise<UserDto>;
    updateSmsConsent(request: SmsConsentDecisionRequest,  cancelToken?: CancelToken): Promise<UserDto>;
    optOutOfSms( cancelToken?: CancelToken): Promise<UserDto>;
    requestPhoneVerification(request: RequestPhoneVerificationRequest,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    verifyPhone(request: VerifyPhoneRequest,  cancelToken?: CancelToken): Promise<UserDto>;
    deletePhone( cancelToken?: CancelToken): Promise<UserDto>;
}

export class UserProfileApiClient implements IUserProfileApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    updateNotificationChannels(request: UpdateNotificationChannelsRequest, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/me/notification-channels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNotificationChannels(_response);
        });
    }

    protected processUpdateNotificationChannels(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    updateSmsConsent(request: SmsConsentDecisionRequest, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/me/sms-consent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSmsConsent(_response);
        });
    }

    protected processUpdateSmsConsent(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    optOutOfSms( cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/me/sms-opt-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOptOutOfSms(_response);
        });
    }

    protected processOptOutOfSms(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    requestPhoneVerification(request: RequestPhoneVerificationRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/user/me/phone/request-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestPhoneVerification(_response);
        });
    }

    protected processRequestPhoneVerification(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    verifyPhone(request: VerifyPhoneRequest, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/me/phone/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyPhone(_response);
        });
    }

    protected processVerifyPhone(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    deletePhone( cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/me/phone";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePhone(_response);
        });
    }

    protected processDeletePhone(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export interface IUserRateApiClient {
    list(req: UserListRequest,  cancelToken?: CancelToken): Promise<UserRateDto[]>;
    get(id: number,  cancelToken?: CancelToken): Promise<UserRateDto>;
    update(id: number, request: UserRateRequestDto,  cancelToken?: CancelToken): Promise<UserRateDto>;
    /**
     * @param contentType (optional) Gets the raw Content-Type header of the uploaded file.
     * @param contentDisposition (optional) Gets the raw Content-Disposition header of the uploaded file.
     * @param headers (optional) Gets the header dictionary of the uploaded file.
     * @param length (optional) Gets the file length in bytes.
     * @param name (optional) Gets the form field name from the Content-Disposition header.
     * @param fileName (optional) Gets the file name from the Content-Disposition header.
     */
    import(contentType: string | undefined, contentDisposition: string | undefined, headers: Headers[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined,  cancelToken?: CancelToken): Promise<UserRateImportResult>;
}

export class UserRateApiClient implements IUserRateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(req: UserListRequest, cancelToken?: CancelToken): Promise<UserRateDto[]> {
        let url_ = this.baseUrl + "/UserRate/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<UserRateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserRateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRateDto[]>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<UserRateDto> {
        let url_ = this.baseUrl + "/UserRate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRateDto>(null as any);
    }

    update(id: number, request: UserRateRequestDto, cancelToken?: CancelToken): Promise<UserRateDto> {
        let url_ = this.baseUrl + "/UserRate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRateDto>(null as any);
    }

    /**
     * @param contentType (optional) Gets the raw Content-Type header of the uploaded file.
     * @param contentDisposition (optional) Gets the raw Content-Disposition header of the uploaded file.
     * @param headers (optional) Gets the header dictionary of the uploaded file.
     * @param length (optional) Gets the file length in bytes.
     * @param name (optional) Gets the form field name from the Content-Disposition header.
     * @param fileName (optional) Gets the file name from the Content-Disposition header.
     */
    import(contentType: string | undefined, contentDisposition: string | undefined, headers: Headers[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, cancelToken?: CancelToken): Promise<UserRateImportResult> {
        let url_ = this.baseUrl + "/UserRate/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new globalThis.Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new globalThis.Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new globalThis.Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<UserRateImportResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserRateImportResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRateImportResult>(null as any);
    }
}

export interface IWbsApiClient {
    /**
     * Get all cost codes (excludes service cost codes)
     */
    getCostCodes( cancelToken?: CancelToken): Promise<CostCodeDto[]>;
    /**
     * Create a new cost code
     */
    createCostCode(request: CostCodeRequestDto,  cancelToken?: CancelToken): Promise<WbsCostCodeDetailsResponse>;
    /**
     * Update a cost code
     */
    updateCostCode(costCodeId: string, request: CostCodeRequestDto,  cancelToken?: CancelToken): Promise<WbsCostCodeDetailsResponse>;
    /**
     * Delete a cost code
     */
    deleteCostCode(costCodeId: string,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * Get WBS structure for a job
     */
    getJobWbs(jobId: number,  cancelToken?: CancelToken): Promise<WbsTreeResponse>;
    /**
     * Create WBS structure for a job
     */
    createJobWbs(jobId: number, request: WbsRequestDto,  cancelToken?: CancelToken): Promise<WbsDto>;
    /**
     * Update WBS structure for a job
     */
    updateJobWbs(jobId: number, request: WbsRequestDto,  cancelToken?: CancelToken): Promise<WbsDto>;
    /**
     * Create a new WBS account
     */
    createAccount(wbsId: string, request: WbsAccountRequestDto,  cancelToken?: CancelToken): Promise<WbsAccountResponse>;
    /**
     * Update a WBS account
     */
    updateAccount(accountId: string, request: WbsAccountRequestDto,  cancelToken?: CancelToken): Promise<WbsAccountResponse>;
    /**
     * Delete (archive) a WBS account
     */
    deleteAccount(accountId: string,  cancelToken?: CancelToken): Promise<WbsAccountResponse>;
    /**
     * Get adjustments for a WBS account
     */
    getAccountAdjustments(accountId: string,  cancelToken?: CancelToken): Promise<WbsAdjustmentDto[]>;
    /**
     * Create a new WBS account adjustment
     */
    createAdjustment(accountId: string, request: WbsAdjustmentRequestDto,  cancelToken?: CancelToken): Promise<WbsAdjustmentDto>;
    /**
     * Update a WBS account adjustment
     */
    updateAdjustment(adjustmentId: string, request: WbsAdjustmentRequestDto,  cancelToken?: CancelToken): Promise<WbsAdjustmentDto>;
    /**
     * Delete (archive) a WBS account adjustment
     */
    deleteAdjustment(adjustmentId: string,  cancelToken?: CancelToken): Promise<WbsAdjustmentDto>;
    /**
     * Get all adjustment types
     */
    getAdjustmentTypes( cancelToken?: CancelToken): Promise<WbsAdjustmentTypeDto[]>;
    /**
     * Get WBS accounts for timesheet creation (only leaf labor accounts)
     */
    getTimesheetAccounts(jobId: number,  cancelToken?: CancelToken): Promise<WbsTimesheetAccountDto[]>;
    /**
     * Refresh CTC data for a specific account
     */
    refreshAccountCtcData(accountId: string,  cancelToken?: CancelToken): Promise<WbsAccountResponse>;
    /**
     * Import the job's Great Plains cost codes missing from its WBS and sync CTC labor hours estimates
     */
    refreshJobCtcData(jobId: number,  cancelToken?: CancelToken): Promise<CtcRefreshResponseDto>;
}

export class WbsApiClient implements IWbsApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all cost codes (excludes service cost codes)
     */
    getCostCodes( cancelToken?: CancelToken): Promise<CostCodeDto[]> {
        let url_ = this.baseUrl + "/Wbs/cost-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCostCodes(_response);
        });
    }

    protected processGetCostCodes(response: AxiosResponse): Promise<CostCodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CostCodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCodeDto[]>(null as any);
    }

    /**
     * Create a new cost code
     */
    createCostCode(request: CostCodeRequestDto, cancelToken?: CancelToken): Promise<WbsCostCodeDetailsResponse> {
        let url_ = this.baseUrl + "/Wbs/cost-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCostCode(_response);
        });
    }

    protected processCreateCostCode(response: AxiosResponse): Promise<WbsCostCodeDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsCostCodeDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsCostCodeDetailsResponse>(null as any);
    }

    /**
     * Update a cost code
     */
    updateCostCode(costCodeId: string, request: CostCodeRequestDto, cancelToken?: CancelToken): Promise<WbsCostCodeDetailsResponse> {
        let url_ = this.baseUrl + "/Wbs/cost-codes/{costCodeId}";
        if (costCodeId === undefined || costCodeId === null)
            throw new globalThis.Error("The parameter 'costCodeId' must be defined.");
        url_ = url_.replace("{costCodeId}", encodeURIComponent("" + costCodeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCostCode(_response);
        });
    }

    protected processUpdateCostCode(response: AxiosResponse): Promise<WbsCostCodeDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsCostCodeDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsCostCodeDetailsResponse>(null as any);
    }

    /**
     * Delete a cost code
     */
    deleteCostCode(costCodeId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Wbs/cost-codes/{costCodeId}";
        if (costCodeId === undefined || costCodeId === null)
            throw new globalThis.Error("The parameter 'costCodeId' must be defined.");
        url_ = url_.replace("{costCodeId}", encodeURIComponent("" + costCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCostCode(_response);
        });
    }

    protected processDeleteCostCode(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Get WBS structure for a job
     */
    getJobWbs(jobId: number, cancelToken?: CancelToken): Promise<WbsTreeResponse> {
        let url_ = this.baseUrl + "/Wbs/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobWbs(_response);
        });
    }

    protected processGetJobWbs(response: AxiosResponse): Promise<WbsTreeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsTreeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsTreeResponse>(null as any);
    }

    /**
     * Create WBS structure for a job
     */
    createJobWbs(jobId: number, request: WbsRequestDto, cancelToken?: CancelToken): Promise<WbsDto> {
        let url_ = this.baseUrl + "/Wbs/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJobWbs(_response);
        });
    }

    protected processCreateJobWbs(response: AxiosResponse): Promise<WbsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsDto>(null as any);
    }

    /**
     * Update WBS structure for a job
     */
    updateJobWbs(jobId: number, request: WbsRequestDto, cancelToken?: CancelToken): Promise<WbsDto> {
        let url_ = this.baseUrl + "/Wbs/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobWbs(_response);
        });
    }

    protected processUpdateJobWbs(response: AxiosResponse): Promise<WbsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsDto>(null as any);
    }

    /**
     * Create a new WBS account
     */
    createAccount(wbsId: string, request: WbsAccountRequestDto, cancelToken?: CancelToken): Promise<WbsAccountResponse> {
        let url_ = this.baseUrl + "/Wbs/{wbsId}/accounts";
        if (wbsId === undefined || wbsId === null)
            throw new globalThis.Error("The parameter 'wbsId' must be defined.");
        url_ = url_.replace("{wbsId}", encodeURIComponent("" + wbsId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: AxiosResponse): Promise<WbsAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAccountResponse>(null as any);
    }

    /**
     * Update a WBS account
     */
    updateAccount(accountId: string, request: WbsAccountRequestDto, cancelToken?: CancelToken): Promise<WbsAccountResponse> {
        let url_ = this.baseUrl + "/Wbs/accounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccount(_response);
        });
    }

    protected processUpdateAccount(response: AxiosResponse): Promise<WbsAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAccountResponse>(null as any);
    }

    /**
     * Delete (archive) a WBS account
     */
    deleteAccount(accountId: string, cancelToken?: CancelToken): Promise<WbsAccountResponse> {
        let url_ = this.baseUrl + "/Wbs/accounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount(_response);
        });
    }

    protected processDeleteAccount(response: AxiosResponse): Promise<WbsAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAccountResponse>(null as any);
    }

    /**
     * Get adjustments for a WBS account
     */
    getAccountAdjustments(accountId: string, cancelToken?: CancelToken): Promise<WbsAdjustmentDto[]> {
        let url_ = this.baseUrl + "/Wbs/accounts/{accountId}/adjustments";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountAdjustments(_response);
        });
    }

    protected processGetAccountAdjustments(response: AxiosResponse): Promise<WbsAdjustmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAdjustmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAdjustmentDto[]>(null as any);
    }

    /**
     * Create a new WBS account adjustment
     */
    createAdjustment(accountId: string, request: WbsAdjustmentRequestDto, cancelToken?: CancelToken): Promise<WbsAdjustmentDto> {
        let url_ = this.baseUrl + "/Wbs/accounts/{accountId}/adjustments";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAdjustment(_response);
        });
    }

    protected processCreateAdjustment(response: AxiosResponse): Promise<WbsAdjustmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAdjustmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAdjustmentDto>(null as any);
    }

    /**
     * Update a WBS account adjustment
     */
    updateAdjustment(adjustmentId: string, request: WbsAdjustmentRequestDto, cancelToken?: CancelToken): Promise<WbsAdjustmentDto> {
        let url_ = this.baseUrl + "/Wbs/adjustments/{adjustmentId}";
        if (adjustmentId === undefined || adjustmentId === null)
            throw new globalThis.Error("The parameter 'adjustmentId' must be defined.");
        url_ = url_.replace("{adjustmentId}", encodeURIComponent("" + adjustmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAdjustment(_response);
        });
    }

    protected processUpdateAdjustment(response: AxiosResponse): Promise<WbsAdjustmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAdjustmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAdjustmentDto>(null as any);
    }

    /**
     * Delete (archive) a WBS account adjustment
     */
    deleteAdjustment(adjustmentId: string, cancelToken?: CancelToken): Promise<WbsAdjustmentDto> {
        let url_ = this.baseUrl + "/Wbs/adjustments/{adjustmentId}";
        if (adjustmentId === undefined || adjustmentId === null)
            throw new globalThis.Error("The parameter 'adjustmentId' must be defined.");
        url_ = url_.replace("{adjustmentId}", encodeURIComponent("" + adjustmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAdjustment(_response);
        });
    }

    protected processDeleteAdjustment(response: AxiosResponse): Promise<WbsAdjustmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAdjustmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAdjustmentDto>(null as any);
    }

    /**
     * Get all adjustment types
     */
    getAdjustmentTypes( cancelToken?: CancelToken): Promise<WbsAdjustmentTypeDto[]> {
        let url_ = this.baseUrl + "/Wbs/adjustment-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdjustmentTypes(_response);
        });
    }

    protected processGetAdjustmentTypes(response: AxiosResponse): Promise<WbsAdjustmentTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAdjustmentTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAdjustmentTypeDto[]>(null as any);
    }

    /**
     * Get WBS accounts for timesheet creation (only leaf labor accounts)
     */
    getTimesheetAccounts(jobId: number, cancelToken?: CancelToken): Promise<WbsTimesheetAccountDto[]> {
        let url_ = this.baseUrl + "/Wbs/timesheet-accounts/job/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimesheetAccounts(_response);
        });
    }

    protected processGetTimesheetAccounts(response: AxiosResponse): Promise<WbsTimesheetAccountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsTimesheetAccountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsTimesheetAccountDto[]>(null as any);
    }

    /**
     * Refresh CTC data for a specific account
     */
    refreshAccountCtcData(accountId: string, cancelToken?: CancelToken): Promise<WbsAccountResponse> {
        let url_ = this.baseUrl + "/Wbs/accounts/{accountId}/refresh-ctc";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshAccountCtcData(_response);
        });
    }

    protected processRefreshAccountCtcData(response: AxiosResponse): Promise<WbsAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WbsAccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WbsAccountResponse>(null as any);
    }

    /**
     * Import the job's Great Plains cost codes missing from its WBS and sync CTC labor hours estimates
     */
    refreshJobCtcData(jobId: number, cancelToken?: CancelToken): Promise<CtcRefreshResponseDto> {
        let url_ = this.baseUrl + "/Wbs/job/{jobId}/refresh-ctc";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshJobCtcData(_response);
        });
    }

    protected processRefreshJobCtcData(response: AxiosResponse): Promise<CtcRefreshResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CtcRefreshResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CtcRefreshResponseDto>(null as any);
    }
}

export interface IWorkflowsApiClient {
    update(jobId: number, workflowId: string, data: WorkflowRequestDto,  cancelToken?: CancelToken): Promise<WorkflowDto>;
    getWorkflowTemplates( cancelToken?: CancelToken): Promise<WorkflowDto[]>;
    getWorkflowOptionsByOffice(officeId: number, resourceId: string,  cancelToken?: CancelToken): Promise<WorkflowDto[]>;
    getWorkflowByOffice(officeId: number, resourceId: string,  cancelToken?: CancelToken): Promise<WorkflowDto>;
    getWorkflowOptionsByDivision(divisionId: number, resourceId: string,  cancelToken?: CancelToken): Promise<WorkflowDto[]>;
    deleteWorkflow(templateId: number,  cancelToken?: CancelToken): Promise<WorkflowDto>;
    getWorkflowTemplateById(templateId: number,  cancelToken?: CancelToken): Promise<WorkflowDto>;
    updateWorkflowTemplate(templateId: number, data: WorkflowRequestDto,  cancelToken?: CancelToken): Promise<WorkflowDto>;
    getWorkflowTemplateByType(templateId: string,  cancelToken?: CancelToken): Promise<WorkflowDto>;
}

export class WorkflowsApiClient implements IWorkflowsApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    update(jobId: number, workflowId: string, data: WorkflowRequestDto, cancelToken?: CancelToken): Promise<WorkflowDto> {
        let url_ = this.baseUrl + "/Workflows/jobs/{jobId}/workflows/{workflowId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<WorkflowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto>(null as any);
    }

    getWorkflowTemplates( cancelToken?: CancelToken): Promise<WorkflowDto[]> {
        let url_ = this.baseUrl + "/Workflows/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkflowTemplates(_response);
        });
    }

    protected processGetWorkflowTemplates(response: AxiosResponse): Promise<WorkflowDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto[]>(null as any);
    }

    getWorkflowOptionsByOffice(officeId: number, resourceId: string, cancelToken?: CancelToken): Promise<WorkflowDto[]> {
        let url_ = this.baseUrl + "/Workflows/options/offices/{officeId}/{resourceId}";
        if (officeId === undefined || officeId === null)
            throw new globalThis.Error("The parameter 'officeId' must be defined.");
        url_ = url_.replace("{officeId}", encodeURIComponent("" + officeId));
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkflowOptionsByOffice(_response);
        });
    }

    protected processGetWorkflowOptionsByOffice(response: AxiosResponse): Promise<WorkflowDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto[]>(null as any);
    }

    getWorkflowByOffice(officeId: number, resourceId: string, cancelToken?: CancelToken): Promise<WorkflowDto> {
        let url_ = this.baseUrl + "/Workflows/offices/{officeId}/{resourceId}";
        if (officeId === undefined || officeId === null)
            throw new globalThis.Error("The parameter 'officeId' must be defined.");
        url_ = url_.replace("{officeId}", encodeURIComponent("" + officeId));
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkflowByOffice(_response);
        });
    }

    protected processGetWorkflowByOffice(response: AxiosResponse): Promise<WorkflowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto>(null as any);
    }

    getWorkflowOptionsByDivision(divisionId: number, resourceId: string, cancelToken?: CancelToken): Promise<WorkflowDto[]> {
        let url_ = this.baseUrl + "/Workflows/options/divisions/{divisionId}/{resourceId}";
        if (divisionId === undefined || divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' must be defined.");
        url_ = url_.replace("{divisionId}", encodeURIComponent("" + divisionId));
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkflowOptionsByDivision(_response);
        });
    }

    protected processGetWorkflowOptionsByDivision(response: AxiosResponse): Promise<WorkflowDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto[]>(null as any);
    }

    deleteWorkflow(templateId: number, cancelToken?: CancelToken): Promise<WorkflowDto> {
        let url_ = this.baseUrl + "/Workflows/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWorkflow(_response);
        });
    }

    protected processDeleteWorkflow(response: AxiosResponse): Promise<WorkflowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto>(null as any);
    }

    getWorkflowTemplateById(templateId: number, cancelToken?: CancelToken): Promise<WorkflowDto> {
        let url_ = this.baseUrl + "/Workflows/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkflowTemplateById(_response);
        });
    }

    protected processGetWorkflowTemplateById(response: AxiosResponse): Promise<WorkflowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto>(null as any);
    }

    updateWorkflowTemplate(templateId: number, data: WorkflowRequestDto, cancelToken?: CancelToken): Promise<WorkflowDto> {
        let url_ = this.baseUrl + "/Workflows/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWorkflowTemplate(_response);
        });
    }

    protected processUpdateWorkflowTemplate(response: AxiosResponse): Promise<WorkflowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto>(null as any);
    }

    getWorkflowTemplateByType(templateId: string, cancelToken?: CancelToken): Promise<WorkflowDto> {
        let url_ = this.baseUrl + "/Workflows/templates/type/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkflowTemplateByType(_response);
        });
    }

    protected processGetWorkflowTemplateByType(response: AxiosResponse): Promise<WorkflowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDto>(null as any);
    }
}

export interface IWorkTicketApiClient {
    list(jobId: number,  cancelToken?: CancelToken): Promise<WorkTicketDto[]>;
    get(id: string,  cancelToken?: CancelToken): Promise<WorkTicketDto>;
    update(id: string, request: WorkTicketRequestDto,  cancelToken?: CancelToken): Promise<WorkTicketDto>;
    delete(id: string,  cancelToken?: CancelToken): Promise<boolean>;
    create(request: WorkTicketRequestDto,  cancelToken?: CancelToken): Promise<WorkTicketDto>;
    download(id: string,  cancelToken?: CancelToken): Promise<DownloadUrlDto>;
}

export class WorkTicketApiClient implements IWorkTicketApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(jobId: number, cancelToken?: CancelToken): Promise<WorkTicketDto[]> {
        let url_ = this.baseUrl + "/WorkTicket/list/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<WorkTicketDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkTicketDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkTicketDto[]>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<WorkTicketDto> {
        let url_ = this.baseUrl + "/WorkTicket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<WorkTicketDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkTicketDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkTicketDto>(null as any);
    }

    update(id: string, request: WorkTicketRequestDto, cancelToken?: CancelToken): Promise<WorkTicketDto> {
        let url_ = this.baseUrl + "/WorkTicket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<WorkTicketDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkTicketDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkTicketDto>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/WorkTicket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    create(request: WorkTicketRequestDto, cancelToken?: CancelToken): Promise<WorkTicketDto> {
        let url_ = this.baseUrl + "/WorkTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<WorkTicketDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkTicketDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkTicketDto>(null as any);
    }

    download(id: string, cancelToken?: CancelToken): Promise<DownloadUrlDto> {
        let url_ = this.baseUrl + "/WorkTicket/{id}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<DownloadUrlDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DownloadUrlDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadUrlDto>(null as any);
    }
}

export interface ApiConnectionDto {
    id: string;
    name: string;
    baseUrl: string;
    redactedApiKey?: string | undefined;
    isEnabled: boolean;
    createdAt: Date;
    updatedAt: Date;
}

export interface CreateApiConnectionRequest {
    name: string;
    baseUrl: string;
    apiKey: string;
    isEnabled: boolean;
}

export interface UpdateApiConnectionRequest {
    name: string;
    baseUrl: string;
    apiKey?: string | undefined;
    isEnabled: boolean;
}

export interface ApplogsResultDto {
    /** False when no workspace is configured; Entries is then empty and no Azure call was made. */
    isConfigured: boolean;
    /** True when Azure Monitor returned only part of the matching rows; Entries holds what it did return. */
    isPartial: boolean;
    /** True when more rows matched than the requested limit; Entries holds the newest limit rows. */
    hasMore: boolean;
    entries: ApplogEntryDto[];
}

export interface ApplogEntryDto {
    timestamp: Date;
    level: ApplogLevel;
    message: string;
    exceptionType?: string | undefined;
    exceptionDetails?: string | undefined;
    operationId?: string | undefined;
    /** Raw JSON object of the log event's custom dimensions, as stored by Application Insights. */
    properties?: string | undefined;
}

/** Values match the Application Insights SeverityLevel column (0-4). */
export enum ApplogLevel {
    Verbose = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
    Critical = 4,
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface AttachmentDownloadResponse {
    url: string;
    name: string;
}

export interface AttachmentRequestDto {
}

export interface AttachmentDto extends AttachmentRequestDto {
    id: string;
    uid?: string | undefined;
    key?: string | undefined;
    path?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subtype?: string | undefined;
    resource?: string | undefined;
    size?: number | undefined;
    isTemporary?: boolean | undefined;
    archived?: boolean | undefined;
    jobId?: number | undefined;
    rfiId?: string | undefined;
    uploadedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    version?: string | undefined;
    status?: string | undefined;
    submittalId?: string | undefined;
    milestonePhaseItemId?: string | undefined;
    workTicketId?: string | undefined;
    changeId?: string | undefined;
    drawingId?: string | undefined;
    postId?: string | undefined;
    rfiResponseId?: string | undefined;
    dailyId?: string | undefined;
    comment?: string | undefined;
    designModelId?: string | undefined;
    meetingTopicId?: string | undefined;
    category?: string | undefined;
}

export interface UpdateCommentRequest {
    comment: string;
}

export interface AzureGroupSyncStatusDto {
    isConfigured: boolean;
    mappingCount: number;
    activeMembershipCount: number;
}

export interface AzureGroupSyncTestResult {
    success: boolean;
    error?: string | undefined;
}

export interface AzureGroupScopeMappingDto {
    id: string;
    scope: string;
    azureGroupId: string;
    azureGroupDisplayName?: string | undefined;
    isEnabled: boolean;
    createdAt: Date;
    updatedAt: Date;
}

export interface CreateAzureGroupScopeMappingRequest {
    scope: string;
    azureGroupId: string;
}

export interface UpdateAzureGroupScopeMappingRequest {
    scope: string;
    azureGroupId: string;
    isEnabled: boolean;
}

export interface AzureGroupUserMembershipDto {
    id: string;
    userId: number;
    userName?: string | undefined;
    userEmail?: string | undefined;
    azureGroupId: string;
    azureGroupDisplayName?: string | undefined;
    syncStatus: string;
    lastSyncedAt?: Date | undefined;
    lastError?: string | undefined;
}

export interface AzureGroupSyncLogResponse {
    logs: AzureGroupSyncLogDto[];
    retentionDays: number;
    totalCount: number;
}

export interface AzureGroupSyncLogDto {
    id: string;
    userId?: number | undefined;
    userEmail?: string | undefined;
    operation: string;
    azureGroupId?: string | undefined;
    succeeded: boolean;
    errorMessage?: string | undefined;
    createdAt: Date;
}

export interface BackgroundJobOverviewDto {
    statistics: BackgroundJobStatisticsDto;
    queues: BackgroundJobQueueDto[];
    hourlyHistory: BackgroundJobHistoryPointDto[];
}

export interface BackgroundJobStatisticsDto {
    enqueued: number;
    scheduled: number;
    processing: number;
    succeeded: number;
    failed: number;
    deleted: number;
    recurring: number;
    servers: number;
}

export interface BackgroundJobQueueDto {
    name: string;
    length: number;
    fetched: number;
}

export interface BackgroundJobHistoryPointDto {
    hour: Date;
    succeeded: number;
    failed: number;
}

export interface BackgroundJobServerDto {
    name: string;
    workersCount: number;
    queues: string[];
    startedAt?: Date | undefined;
    heartbeat?: Date | undefined;
}

export interface BackgroundJobPageDto {
    items: BackgroundJobSummaryDto[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export interface BackgroundJobSummaryDto {
    id: string;
    state: string;
    jobName: string;
    queue?: string | undefined;
    createdAt?: Date | undefined;
    enqueuedAt?: Date | undefined;
    scheduledAt?: Date | undefined;
    startedAt?: Date | undefined;
    succeededAt?: Date | undefined;
    failedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    exceptionType?: string | undefined;
    exceptionMessage?: string | undefined;
    totalDurationMs?: number | undefined;
}

export enum BackgroundJobStateFilter {
    Enqueued = 0,
    Scheduled = 1,
    Processing = 2,
    Succeeded = 3,
    Failed = 4,
    Deleted = 5,
}

export interface BackgroundJobDetailDto {
    summary: BackgroundJobSummaryDto;
    arguments: string[];
    history: BackgroundJobStateHistoryDto[];
}

export interface BackgroundJobStateHistoryDto {
    stateName: string;
    reason?: string | undefined;
    createdAt?: Date | undefined;
    data: { [key: string]: string; };
}

export interface RecurringBackgroundJobDto {
    id: string;
    jobName: string;
    cron?: string | undefined;
    queue?: string | undefined;
    timeZoneId?: string | undefined;
    lastExecution?: Date | undefined;
    lastJobId?: string | undefined;
    lastJobState?: string | undefined;
    nextExecution?: Date | undefined;
    error?: string | undefined;
}

/** DTO for Change responses */
export interface ChangeDto {
    id: string;
    changeNumber?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    date?: Date | undefined;
    impactNotes?: string | undefined;
    externalContact?: string | undefined;
    stepIndex?: number | undefined;
    workflowId?: number | undefined;
    jobId?: number | undefined;
    assigneeUserId?: number | undefined;
    createdById?: number | undefined;
    archived?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    submittedToContactId?: string | undefined;
    submittedToUserId?: number | undefined;
    proposedAmount?: number | undefined;
    approvedAmount?: number | undefined;
    proposedDays?: number | undefined;
    approvedDays?: number | undefined;
    submittedByCompany?: string | undefined;
    changeTypeId?: string | undefined;
    changeTypeName?: string | undefined;
    createdBy?: UserCoreDto | undefined;
    assignee?: UserCoreDto | undefined;
    job?: ChangeJobDto | undefined;
    workflow?: WorkflowDto | undefined;
    submittedToContact?: WorkflowContactDto | undefined;
    submittedToUser?: UserCoreDto | undefined;
    attachments?: ResourceAttachmentDto[] | undefined;
    history?: ChangeHistoryDto[] | undefined;
}

export interface UserCoreDto {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
    employeeId?: string | undefined;
    supervisorId?: number | undefined;
    supervisor?: UserCoreDto | undefined;
    classificationId?: string | undefined;
    classification?: ClassificationDto | undefined;
    classificationLevelId?: string | undefined;
    classificationLevel?: ClassificationLevelDto | undefined;
    classificationName?: string | undefined;
    classificationLevelName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberVerifiedAt?: Date | undefined;
    smsConsentStatus: string;
    notificationChannels: string[];
    /** True iff the user has never been prompted and SMS is enabled (Sms:Enabled). The frontend
shows the consent interstitial on this flag only. */
    requiresSmsConsentPrompt: boolean;
}

export interface ClassificationRequestDto {
    id?: string | undefined;
    name: string;
    levels?: ClassificationLevelRequestDto[] | undefined;
}

export interface ClassificationDto extends ClassificationRequestDto {
    id: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    levels?: ClassificationLevelDto[] | undefined;
}

export interface ClassificationLevelRequestDto {
    id?: string | undefined;
    name: string;
    rateModifierPercent: number;
}

export interface ClassificationLevelDto extends ClassificationLevelRequestDto {
    id: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    classificationId: string;
    classification?: ClassificationDto | undefined;
}

/** Minimal job info for Change */
export interface ChangeJobDto {
    id: number;
    jobNumber?: string | undefined;
    name?: string | undefined;
}

export interface WorkflowRequestDto {
    id: number;
    jobId?: number | undefined;
    resourceId?: string | undefined;
    name?: string | undefined;
    createButtonColor?: string | undefined;
    isActive?: boolean | undefined;
    isArchived?: boolean | undefined;
    isDefault?: boolean | undefined;
    allowDraft?: boolean | undefined;
    allowOwner?: boolean | undefined;
    createButtonText?: string | undefined;
    originalWorkflowId?: number | undefined;
    isTemplate?: boolean | undefined;
    officeId?: number | undefined;
    assignAsDefault?: boolean | undefined;
    authorizedRoles: WorkflowRoleDto[];
    authorizedUsers: WorkflowUserDto[];
    excludedUsers: WorkflowUserDto[];
    requestSteps: WorkflowStepRequestDto[];
}

export interface WorkflowDto extends WorkflowRequestDto {
    isSystem: boolean;
    createdById?: number | undefined;
    lastUpdatedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    office?: OrganizationOfficeDto | undefined;
    createdBy?: UserCoreDto | undefined;
    lastUpdatedBy?: UserCoreDto | undefined;
    steps: WorkflowStepDto[];
}

export interface OrganizationOfficeRequestDto {
    name: string;
    description?: string | undefined;
    modules?: string[] | undefined;
    dailyModules?: OfficeDailyModulesDto | undefined;
    dailyQuestions?: OfficeQuestionDto[] | undefined;
    rfiWorkflowId?: number | undefined;
    submittalWorkflowId?: number | undefined;
    drawingWorkflowId?: number | undefined;
    transmittalWorkflowId?: number | undefined;
    timesheetWorkflowId?: number | undefined;
    changeOrderWorkflowId?: number | undefined;
    perDiemEnabled?: boolean | undefined;
    perDiemAmount?: number | undefined;
    targetDivisionIds?: number[] | undefined;
    timezone?: string | undefined;
    businessHoursStart?: string | undefined;
    businessHoursEnd?: string | undefined;
    businessDays?: number[] | undefined;
}

export interface OrganizationOfficeDto extends OrganizationOfficeRequestDto {
    id: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    divisions?: DivisionDto[] | undefined;
    users?: UserCoreDto[] | undefined;
}

export interface DivisionDto {
    id: number;
    name: string;
    offices?: OrganizationOfficeDto[] | undefined;
}

export interface OfficeDailyModulesDto {
    tickets?: boolean | undefined;
    timesheets?: boolean | undefined;
    notes?: boolean | undefined;
    progress?: boolean | undefined;
    equipment?: boolean | undefined;
    contractors?: boolean | undefined;
    concerns?: boolean | undefined;
    media?: boolean | undefined;
    questions?: boolean | undefined;
}

export interface OfficeQuestionDto {
    id: string;
    question: string;
}

export interface WorkflowStepRequestDto {
    id: number;
    workflowId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    allowReject?: boolean | undefined;
    allowRevise?: boolean | undefined;
    allowVoid?: boolean | undefined;
    editable?: boolean | undefined;
    isExternalStep?: boolean | undefined;
    isLastStep?: boolean | undefined;
    notifyAssignees?: boolean | undefined;
    buttonText?: string | undefined;
    buttonColor?: string | undefined;
    label?: string | undefined;
    displayLabel?: string | undefined;
    description?: string | undefined;
    stepNumber?: number | undefined;
    createPdf?: boolean | undefined;
    attachPdfToNotification?: boolean | undefined;
    isEmployeeReviewStep?: boolean | undefined;
    isSupervisorReviewStep?: boolean | undefined;
    allowOwner?: boolean | undefined;
    notifyOnSignedEdit?: boolean | undefined;
    assignedRoles: WorkflowRoleRequestDto[];
    approvalRoles: WorkflowRoleRequestDto[];
    notifyRoles: WorkflowRoleRequestDto[];
    assignedUsers: WorkflowUserRequestDto[];
    excludedAssignedUsers: WorkflowUserRequestDto[];
    notifyUsers: WorkflowUserRequestDto[];
    excludedNotifyUsers: WorkflowUserRequestDto[];
    approvalUsers: WorkflowUserRequestDto[];
    excludedApprovalUsers: WorkflowUserRequestDto[];
}

export interface WorkflowStepDto extends WorkflowStepRequestDto {
    assignedRoles: WorkflowRoleDto[];
    approvalRoles: WorkflowRoleDto[];
    notifyRoles: WorkflowRoleDto[];
    assignedUsers: WorkflowUserDto[];
    excludedAssignedUsers: WorkflowUserDto[];
    notifyUsers: WorkflowUserDto[];
    excludedNotifyUsers: WorkflowUserDto[];
    approvalUsers: WorkflowUserDto[];
    excludedApprovalUsers: WorkflowUserDto[];
}

export interface WorkflowRoleRequestDto {
    id: number;
    workflowId?: number | undefined;
    workflowStepId?: number | undefined;
    type: string;
    organizationRoleId?: number | undefined;
}

export interface WorkflowRoleDto extends WorkflowRoleRequestDto {
    organizationRole?: OrganizationRoleDto | undefined;
}

export interface OrganizationRoleRequestDto {
    name: string;
    scopes?: string[] | undefined;
    description?: string | undefined;
    office?: string | undefined;
    dailyAuditTracking?: boolean | undefined;
    serviceJobTracking?: boolean | undefined;
}

export interface OrganizationRoleDto extends OrganizationRoleRequestDto {
    id: number;
    whitelist?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    users?: UserCoreDto[] | undefined;
}

export interface WorkflowUserRequestDto {
    id?: number | undefined;
    jobUserId?: number | undefined;
    workflowId?: number | undefined;
    workflowStepId?: number | undefined;
    type: string;
}

export interface WorkflowUserDto extends WorkflowUserRequestDto {
    jobUser?: JobUserDto | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface JobUserDto {
    id: number;
    userId?: number | undefined;
    jobId?: number | undefined;
    source: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    user?: UserDto | undefined;
}

export interface UserDto extends UserCoreDto {
    isDisabled: boolean;
    isArchived: boolean;
    archivedAt?: Date | undefined;
    status: string;
    deviceId?: string | undefined;
    isSuperuser: boolean;
    lastLogin?: Date | undefined;
    createdAt: Date;
    updatedAt: Date;
    companyName?: string | undefined;
    apps?: string | undefined;
    azureId?: string | undefined;
    allowedJobIds?: number[] | undefined;
    allowedCtcJobNumbers?: string[] | undefined;
    divisionAdmin?: boolean | undefined;
    disableDivisionAccess?: boolean | undefined;
    restrictDivisionAccess?: boolean | undefined;
    jobTitle?: string | undefined;
    jobTitleId?: string | undefined;
    hireDate?: Date | undefined;
    rateImportKey?: string | undefined;
    primaryOfficeId?: number | undefined;
    userOrganizationRole?: UserOrganizationRoleDto[] | undefined;
    userOrganizationOffice?: UserOrganizationOfficeDto[] | undefined;
    userDivision?: UserDivisionDto[] | undefined;
}

export interface UserOrganizationRoleDto {
    id: number;
    userId?: number | undefined;
    organizationRoleId?: number | undefined;
    organizationRole?: OrganizationRoleDto | undefined;
}

export interface UserOrganizationOfficeDto {
    id: number;
    userId?: number | undefined;
    organizationOfficeId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    organizationOffice?: OrganizationOfficeDto | undefined;
}

export interface UserDivisionDto {
    id: number;
    userId?: number | undefined;
    divisionId?: number | undefined;
    division?: DivisionDto | undefined;
}

/** Summary of a Contact referenced by a workflow record (Change, Transmittal, RFI). */
export interface WorkflowContactDto {
    id: string;
    name?: string | undefined;
    company?: string | undefined;
    email?: string | undefined;
}

/** Minimal attachment DTO for resource responses (RFIs, Changes, etc.) Includes only display-relevant fields plus a computed DownloadUrl */
export interface ResourceAttachmentDto {
    id: string;
    uid?: string | undefined;
    key?: string | undefined;
    path?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subtype?: string | undefined;
    comment?: string | undefined;
    size?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    downloadUrl?: string | undefined;
    category?: string | undefined;
    externalUrl?: string | undefined;
}

/** History entry DTO for Change */
export interface ChangeHistoryDto {
    id: number;
    resource?: string | undefined;
    resourceTitle?: string | undefined;
    action?: string | undefined;
    fields?: string | undefined;
    person?: string | undefined;
    statusChange?: boolean | undefined;
    previousStatus?: string | undefined;
    updatedStatus?: string | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
}

/** Request DTO for creating or updating a Change */
export interface ChangeRequestDto {
    id?: string | undefined;
    date?: Date | undefined;
    description?: string | undefined;
    status?: string | undefined;
    impactNotes?: string | undefined;
    assigneeUserId?: number | undefined;
    stepIndex?: number | undefined;
    workflowId?: number | undefined;
    externalContact?: any | undefined;
    submittedToContactId?: string | undefined;
    proposedAmount?: number | undefined;
    approvedAmount?: number | undefined;
    proposedDays?: number | undefined;
    approvedDays?: number | undefined;
    submittedByCompany?: string | undefined;
    changeTypeId?: string | undefined;
    filesToAdd?: AttachmentIdDto[] | undefined;
    filesToRemove?: AttachmentIdDto[] | undefined;
    saveOnly: boolean;
    notification?: NotificationCompositionRequest | undefined;
}

/** Simple ID reference for attachments (used in request DTOs) */
export interface AttachmentIdDto {
    id: string;
}

/** The composition a caller submits to stage an email (POST /send or /skip). */
export interface NotificationCompositionRequest {
    eventType: string;
    subject?: string | undefined;
    bodyHtml?: string | undefined;
    to: RecipientDto[];
    cc: RecipientDto[];
    bcc: RecipientDto[];
    attachPdf: boolean;
    skipEmail: boolean;
    skipReason?: string | undefined;
}

/** One To/Cc/Bcc recipient in a composed notification. */
export interface RecipientDto {
    address: string;
    displayName?: string | undefined;
    userId?: number | undefined;
    contactId?: string | undefined;
}

/** Request DTO for external Change updates (from external users) */
export interface ChangeExternalUpdateDto {
    status?: string | undefined;
    stepIndex?: number | undefined;
    filesToAdd?: AttachmentIdDto[] | undefined;
    filesToRemove?: AttachmentIdDto[] | undefined;
}

/** A job document that can be attached to a Change from the system. */
export interface ChangeDocumentOptionDto {
    id: string;
    name?: string | undefined;
    path?: string | undefined;
    type?: string | undefined;
}

/** Request to attach an existing job document to a Change. */
export interface AttachFromDocumentRequest {
    documentId: string;
}

/** Response for PDF links */
export interface ChangePdfLinkDto {
    documentId?: string | undefined;
    name?: string | undefined;
    path?: string | undefined;
}

export interface PdfResult {
    documentId: string;
    fileName: string;
    downloadUrl: string;
}

/** Slim Change row for the cross-job overview list. Carries only the fields the overview table renders plus its owning job, and a status-color-only workflow (no user/role graph). */
export interface ChangeOverviewDto {
    id: string;
    changeNumber?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    date?: Date | undefined;
    proposedAmount?: number | undefined;
    approvedAmount?: number | undefined;
    proposedDays?: number | undefined;
    approvedDays?: number | undefined;
    createdByName?: string | undefined;
    assigneeName?: string | undefined;
    jobId: number;
    jobNumber?: string | undefined;
    jobName?: string | undefined;
    workflowId?: number | undefined;
    workflow?: OverviewWorkflowDto | undefined;
}

/** Step-color-only workflow projection shared by the cross-job overview tables (Changes, RFIs). Steps are ordered by step number so the client can index them by StepIndex. */
export interface OverviewWorkflowDto {
    id: number;
    steps: OverviewStepDto[];
}

/** A single color-only step in an overview workflow projection. */
export interface OverviewStepDto {
    label?: string | undefined;
    buttonColor?: string | undefined;
}

export interface ChangeTemplateDto {
    id: string;
    title?: string | undefined;
    asOfDate?: Date | undefined;
    officeId?: number | undefined;
    isActive?: boolean | undefined;
    designSheets?: RateSheetDto[] | undefined;
    laborSheets?: RateSheetDto[] | undefined;
    createdById?: number | undefined;
    createdBy?: UserCoreDto | undefined;
    office?: OrganizationOfficeDto | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface RateSheetDto {
    id?: string | undefined;
    title?: string | undefined;
    rows?: RateRowDto[] | undefined;
}

export interface RateRowDto {
    id?: string | undefined;
    description?: string | undefined;
    baseRate?: string | undefined;
    timeAndAHalfRate?: string | undefined;
    doubleRate?: string | undefined;
    otherRate?: string | undefined;
    color?: string | undefined;
}

export interface ChangeTemplateRequestDto {
    title?: string | undefined;
    asOfDate?: Date | undefined;
    officeId?: number | undefined;
    isActive?: boolean | undefined;
    designSheets?: RateSheetDto[] | undefined;
    laborSheets?: RateSheetDto[] | undefined;
}

export interface ChangeTypeRequestDto {
    id?: string | undefined;
    name: string;
    isActive: boolean;
    sortOrder: number;
}

export interface ChangeTypeDto extends ChangeTypeRequestDto {
    id: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface ChangeTypeListRequest {
    name?: string | undefined;
}

export interface ChatConversationSummaryDto {
    id: string;
    title: string;
    model: string;
    jobId?: number | undefined;
    page?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
    /** The conversation this one was forked from; null when there is none or it has been deleted. */
    forkedFromConversationId?: string | undefined;
    /** Title of ForkedFromConversationId; null whenever that is null. */
    forkedFromTitle?: string | undefined;
    /** The conversation neither reads nor saves the owner's memory notes. */
    memoryOff: boolean;
}

export interface CreateConversationRequestDto {
    jobId?: number | undefined;
    page?: string | undefined;
    /** The conversation neither reads nor saves the owner's memory notes. Cannot be changed later. */
    memoryOff: boolean;
}

/** A generic wrapper for paginated API responses. */
export interface PagedResultOfChatConversationSummaryDto {
    /** The items for the current page. */
    items: ChatConversationSummaryDto[];
    /** The total number of items across all pages. */
    totalCount: number;
    /** The current page number (1-based). */
    page: number;
    /** The number of items per page. */
    pageSize: number;
    /** The total number of pages. */
    totalPages: number;
    /** Whether there is a previous page. */
    hasPreviousPage: boolean;
    /** Whether there is a next page. */
    hasNextPage: boolean;
}

export interface ChatConversationDto extends ChatConversationSummaryDto {
    messages: ChatMessageDto[];
}

export interface ChatMessageDto {
    id: string;
    role: string;
    text: string;
    /** Ordered text/tool-activity/chart/table/memory segments for rendering tool calls, charts, tables, and memory notes interleaved with the text
they relate to. Null for user messages and for assistant messages persisted before this
column existed — callers fall back to Text in that case. */
    segments?: ChatSegment[] | undefined;
    model?: string | undefined;
    stopReason?: string | undefined;
    /** The reasoning effort sent to the model for this reply. Null for user messages and for replies saved before it was recorded. */
    reasoningEffort?: string | undefined;
    /** The part of the reply's output tokens spent on reasoning. 0 for user messages, fork copies, and replies saved before it was recorded. */
    reasoningTokens: number;
    /** What this reply added to the owner's daily estimated cost. 0 for user messages, fork copies, and replies saved before it was recorded. */
    estCostUsd: number;
    createdAt: Date;
    /** Set when an edit and resend took this message out of the conversation. Only the admin conversation detail
returns superseded messages; everywhere else this is null. */
    supersededAt?: Date | undefined;
    /** The owner's vote on this reply; null when there is no vote. */
    feedback?: ChatMessageFeedbackDto | undefined;
    /** Memory note ids the reply reported using. The notes may have been deleted since. */
    usedMemoryIds: number[];
}

/** One ordered part of an assistant reply; kind names which. */
export interface ChatSegment {
    kind: string;
}

export interface ChatTextSegment extends ChatSegment {
    text: string;
}

export interface ChatToolsSegment extends ChatSegment {
    activity: ChatToolActivityDto[];
}

export interface ChatToolActivityDto {
    /** The model's id for the tool call. Null for replies saved before call ids were recorded. */
    callId?: string | undefined;
    name: string;
    rowCount?: number | undefined;
    truncated: boolean;
    isError: boolean;
    /** The `chat_sql_audit` row of a `run_sql` call. Null for other tools and for replies saved before audit ids were recorded. */
    auditId?: string | undefined;
}

export interface ChatChartSegment extends ChatSegment {
    chart: ChatChartSpecDto;
}

export interface ChatChartSpecDto {
    /** "bar", "line", "area", "pie", or "stacked-bar". */
    type: string;
    title: string;
    xLabel: string;
    series: ChatChartSeriesDto[];
    points: ChatChartPointDto[];
}

export interface ChatChartSeriesDto {
    label: string;
    /** "number", "count", "hours", "currency", or "percent". Every series in one chart shares the same unit. */
    unit: string;
}

export interface ChatChartPointDto {
    x: string;
    /** One value per series, in Series order. */
    values: number[];
}

export interface ChatTableSegment extends ChatSegment {
    table: ChatTableSpecDto;
}

export interface ChatTableSpecDto {
    title?: string | undefined;
    columns: ChatTableColumnDto[];
    /** One list per row, one cell per column in Columns order. Cells are numbers, strings,
booleans, or null; dates and timestamps are ISO 8601 strings. */
    rows: any[][];
    /** The source query returned more rows than it kept; Rows holds only the first ones. */
    truncated: boolean;
    /** The `chat_sql_audit` row of the source `run_sql` call, for the full-result CSV download. */
    auditId?: string | undefined;
}

export interface ChatTableColumnDto {
    key: string;
    label: string;
    /** "text", "number", "currency", "hours", "percent", or "date". A numeric format's cells are numbers or null; percent values are already scaled (42.5 means 42.5%). */
    format: string;
    /** One ref: link per row, in Rows order, null where a key value is null. Null when the column has no link. */
    refs?: string[] | undefined;
}

export interface ChatMemorySegment extends ChatSegment {
    /** "saved" or "removed". */
    memoryAction: string;
    /** The note as the tool left it when the reply streamed. Its current state is in the owner's memory list. */
    memory: ChatMemoryDto;
}

export interface ChatMemoryDto {
    id: number;
    /** "preference", "focus", "alias", or "default". */
    kind: string;
    text: string;
    /** "proposed", "active", or "declined". */
    status: string;
    /** "user_request", "suggestion", or "manual". */
    source: string;
    /** Null for a manual note and once the conversation is hard-deleted. */
    sourceConversationId?: string | undefined;
    useCount: number;
    lastUsedAt?: Date | undefined;
    createdAt: Date;
    updatedAt: Date;
}

export interface ChatMessageFeedbackDto {
    /** "up" or "down". */
    rating: string;
    /** "wrong_data", "missing_data", "misunderstood", "too_slow", "formatting", or "other". Null on an "up" rating. */
    reason?: string | undefined;
    comment?: string | undefined;
}

export interface ForkConversationRequestDto {
    /** A user message of the source conversation. The fork gets the messages before it; the message itself is not copied. */
    messageId: string;
}

export interface UpdateConversationTitleRequestDto {
    title: string;
}

export interface SetMessageFeedbackRequestDto {
    /** "up" or "down". */
    rating: string;
    /** Required on a "down" rating; ignored on an "up" rating. */
    reason?: string | undefined;
    /** At most 1000 characters. Ignored on an "up" rating. */
    comment?: string | undefined;
}

export interface ChatUsageDto {
    inputTokens: number;
    outputTokens: number;
    cacheReadTokens: number;
    requestCount: number;
    estCostUsd: number;
    dailyTokenBudget: number;
    withinBudget: boolean;
}

export enum ChatEntityKind {
    Job = 0,
    Rfi = 1,
    Change = 2,
    Submittal = 3,
    Drawing = 4,
    Daily = 5,
    Meeting = 6,
    Post = 7,
    Timesheet = 8,
}

/** One server-sent event of a streamed chat turn; type names which. */
export interface ChatStreamEvent {
    type: string;
}

/** The first event once the user message is saved. */
export interface ChatStartEvent extends ChatStreamEvent {
    userMessageId: string;
}

export interface ChatDeltaEvent extends ChatStreamEvent {
    text: string;
}

/** CallId is the model's id for the tool call; the call's ChatToolResultEvent carries the same id. */
export interface ChatToolUseEvent extends ChatStreamEvent {
    callId: string;
    name: string;
    status: string;
}

/** The result of the ChatToolUseEvent with the same CallId. AuditId is the `chat_sql_audit` row of a `run_sql` call, null for other tools. */
export interface ChatToolResultEvent extends ChatStreamEvent {
    callId: string;
    rowCount: number;
    truncated: boolean;
    isError: boolean;
    auditId?: string | undefined;
}

export interface ChatChartEvent extends ChatStreamEvent {
    spec: ChatChartSpecDto;
}

export interface ChatTableEvent extends ChatStreamEvent {
    spec: ChatTableSpecDto;
}

/** Action is ActionSaved for the note save_memory saved, or ActionRemoved for the note forget_memory removed, as it was before the delete. */
export interface ChatMemoryEvent extends ChatStreamEvent {
    action: string;
    memory: ChatMemoryDto;
}

/** The reply's token totals. InputTokens excludes the cached input in CacheReadTokens. */
export interface ChatUsageEvent extends ChatStreamEvent {
    inputTokens: number;
    outputTokens: number;
    cacheReadTokens: number;
}

/** The last event of a saved reply. StopReason is a ChatStopReasons value. */
export interface ChatDoneEvent extends ChatStreamEvent {
    messageId: string;
    stopReason: string;
    usedMemoryIds: number[];
}

/** Ends the stream. Code is "upstream_unavailable" or "content_filtered" for those failures, otherwise null. */
export interface ChatErrorEvent extends ChatStreamEvent {
    message: string;
    code?: string | undefined;
    retryAfterSeconds?: number | undefined;
}

/** A generic wrapper for paginated API responses. */
export interface PagedResultOfAdminConversationDto {
    /** The items for the current page. */
    items: AdminConversationDto[];
    /** The total number of items across all pages. */
    totalCount: number;
    /** The current page number (1-based). */
    page: number;
    /** The number of items per page. */
    pageSize: number;
    /** The total number of pages. */
    totalPages: number;
    /** Whether there is a previous page. */
    hasPreviousPage: boolean;
    /** Whether there is a next page. */
    hasNextPage: boolean;
}

export interface AdminConversationDto extends ChatConversationSummaryDto {
    userId: number;
    userName?: string | undefined;
    negativeFeedbackCount: number;
}

export interface AdminConversationDetailDto extends ChatConversationDto {
    userId: number;
    userName?: string | undefined;
}

/** A generic wrapper for paginated API responses. */
export interface PagedResultOfSqlToolAuditDto {
    /** The items for the current page. */
    items: SqlToolAuditDto[];
    /** The total number of items across all pages. */
    totalCount: number;
    /** The current page number (1-based). */
    page: number;
    /** The number of items per page. */
    pageSize: number;
    /** The total number of pages. */
    totalPages: number;
    /** Whether there is a previous page. */
    hasPreviousPage: boolean;
    /** Whether there is a next page. */
    hasNextPage: boolean;
}

export interface SqlToolAuditDto {
    id: string;
    messageId: string;
    userId: number;
    userName?: string | undefined;
    generatedSql: string;
    validationResult: string;
    executed: boolean;
    rowCount?: number | undefined;
    truncated: boolean;
    durationMs?: number | undefined;
    error?: string | undefined;
    createdAt: Date;
}

/** A generic wrapper for paginated API responses. */
export interface PagedResultOfAdminUsageDto {
    /** The items for the current page. */
    items: AdminUsageDto[];
    /** The total number of items across all pages. */
    totalCount: number;
    /** The current page number (1-based). */
    page: number;
    /** The number of items per page. */
    pageSize: number;
    /** The total number of pages. */
    totalPages: number;
    /** Whether there is a previous page. */
    hasPreviousPage: boolean;
    /** Whether there is a next page. */
    hasNextPage: boolean;
}

export interface AdminUsageDto {
    userId: number;
    userName?: string | undefined;
    usageDate: Date;
    inputTokens: number;
    outputTokens: number;
    cacheReadTokens: number;
    requestCount: number;
    estCostUsd: number;
}

/** Cross-source rollup for the admin stats overview cards — token/cost usage, activity counts, and SQL-tool quality metrics. */
export interface AdminStatsOverviewDto {
    estCostUsd: number;
    inputTokens: number;
    outputTokens: number;
    cacheReadTokens: number;
    /** cacheReadTokens / (inputTokens + cacheReadTokens); 0 when both are 0. */
    cacheHitRatio: number;
    requestCount: number;
    activeUserCount: number;
    conversationCount: number;
    messageCount: number;
    sqlAttemptCount: number;
    sqlAcceptedCount: number;
    sqlRejectedCount: number;
    sqlExecutedCount: number;
    sqlErrorCount: number;
    sqlTruncatedCount: number;
    sqlAvgDurationMs?: number | undefined;
    sqlP95DurationMs?: number | undefined;
    positiveFeedbackCount: number;
    negativeFeedbackCount: number;
    /** "down" votes per reason, one entry for every reason code in ReasonCodes order. */
    feedbackReasonCounts: FeedbackReasonCountDto[];
    /** Assistant replies created in the range, grouped by reasoning effort, most replies first. Includes superseded replies and
replies in deleted conversations, which were billed too; leaves out fork copies. */
    reasoningEffortBreakdown: AdminReasoningEffortStatsDto[];
    /** Tool calls of replies created in the range, leaving out fork copies and deleted conversations. */
    toolUse: AdminToolUseStatsDto;
    /** The same tool calls as ToolUse by tool name, most calls first. */
    tools: AdminToolStatsDto[];
}

export interface FeedbackReasonCountDto {
    reason: string;
    count: number;
}

export interface AdminReasoningEffortStatsDto {
    /** Null groups the replies saved before the effort was recorded. */
    reasoningEffort?: string | undefined;
    messageCount: number;
    /** Includes ReasoningTokens. */
    outputTokens: number;
    reasoningTokens: number;
    estCostUsd: number;
}

export interface AdminToolUseStatsDto {
    repliesWithToolCalls: number;
    /** Null when no reply made a tool call. */
    avgRoundsPerReplyWithTools?: number | undefined;
    /** The share of assistant replies that stopped at the tool round limit, 0 to 1, over the replies of
ReasoningEffortBreakdown. */
    toolRoundLimitShare: number;
    callCount: number;
    /** Calls that repeated an earlier call of the same reply and returned its result without running. */
    duplicateCallCount: number;
    /** Calls past the per-round or per-reply call limit, which did not run. */
    cappedCallCount: number;
}

export interface AdminToolStatsDto {
    toolName: string;
    callCount: number;
    /** Errors of the calls that ran, leaving out duplicate and capped calls. */
    errorCount: number;
    /** errorCount over the calls that ran, 0 to 1. */
    errorRate: number;
    /** Over the calls that ran; 0 when none ran. */
    avgDurationMs: number;
    p95DurationMs: number;
    avgResultBytes: number;
}

/** One day's worth of the admin stats time series. */
export interface AdminStatsDailyPointDto {
    date: Date;
    estCostUsd: number;
    inputTokens: number;
    outputTokens: number;
    requestCount: number;
    activeUserCount: number;
    sqlAcceptedCount: number;
    sqlRejectedCount: number;
}

/** Per-user rollup for the admin stats breakdown table, ordered by cost descending. */
export interface AdminUserStatsDto {
    userId: number;
    userName?: string | undefined;
    estCostUsd: number;
    totalTokens: number;
    requestCount: number;
    conversationCount: number;
    sqlRejectedCount: number;
    /** Latest of the user's daily-usage date or conversation-updated timestamp. */
    lastActivityAt?: Date | undefined;
}

/** A generic wrapper for paginated API responses. */
export interface PagedResultOfAdminFeedbackItemDto {
    /** The items for the current page. */
    items: AdminFeedbackItemDto[];
    /** The total number of items across all pages. */
    totalCount: number;
    /** The current page number (1-based). */
    page: number;
    /** The number of items per page. */
    pageSize: number;
    /** The total number of pages. */
    totalPages: number;
    /** Whether there is a previous page. */
    hasPreviousPage: boolean;
    /** Whether there is a next page. */
    hasNextPage: boolean;
}

/** One page of votes. UpCount, DownCount and ReasonCounts are computed under the date, user and search filters only, so they stay stable while the rating and reason filters change. */
export interface AdminFeedbackPageDto extends PagedResultOfAdminFeedbackItemDto {
    upCount: number;
    downCount: number;
    /** One entry for every reason code in ReasonCodes order. */
    reasonCounts: FeedbackReasonCountDto[];
}

export interface AdminFeedbackItemDto {
    messageId: string;
    conversationId: string;
    conversationTitle: string;
    userId: number;
    userName?: string | undefined;
    /** "up" or "down". */
    rating: string;
    reason?: string | undefined;
    comment?: string | undefined;
    /** When the current vote was cast; a changed vote carries the date of the change. */
    votedAt: Date;
    /** Text of the user message immediately before the rated reply; null when there is none. */
    question?: string | undefined;
    /** Full text of the rated reply. */
    answer: string;
    /** The reasoning effort sent to the model for the rated reply; null when it was not recorded. */
    reasoningEffort?: string | undefined;
    /** What the rated reply added to the owner's daily estimated cost; 0 when it was not recorded. */
    estCostUsd: number;
}

export interface ChatMemoryListDto {
    /** The user's Use memory setting. */
    enabled: boolean;
    /** Every note of the user in every status, newest first. */
    notes: ChatMemoryDto[];
}

export interface SetChatMemoryEnabledRequestDto {
    enabled: boolean;
}

export interface ChatMemoryRequestDto {
    /** "preference", "focus", "alias", or "default". */
    kind: string;
    /** At most 200 characters after trimming. */
    text: string;
}

export interface ClassificationListRequest {
    name?: string | undefined;
}

/** DTO for MSSQL Customer entity (GreatPlains) */
export interface ClientGpDto {
    custNumber: string;
    custName?: string | undefined;
    lastUpdated?: Date | undefined;
}

/** DTO for PostgreSQL Client entity */
export interface ClientRequestDto {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface ClientDto extends ClientRequestDto {
    id: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface ContactRequestDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    notes?: string | undefined;
    customerNumber?: string | undefined;
    customerName?: string | undefined;
}

export interface ContactDto extends ContactRequestDto {
    id: string;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: UserCoreDto | undefined;
}

export interface ContactListRequest {
    customerNumber?: string | undefined;
}

export interface CcAdjustmentDto {
    id: string;
    wsJobNumber?: string | undefined;
    adjustments?: CostCodeAdjustmentItem[] | undefined;
    archived?: boolean | undefined;
    createdById?: number | undefined;
    updatedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    adjustedRev?: number | undefined;
}

export interface CostCodeAdjustmentItem {
    costCode?: string | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    hours?: number | undefined;
    rate?: number | undefined;
    ctc?: number | undefined;
    costAtCompletion?: number | undefined;
    overUnder?: number | undefined;
    jtdCost?: number | undefined;
    revisedEstimate?: number | undefined;
    category?: string | undefined;
    exclude: boolean;
}

export interface CcAdjustmentHistoryDto {
    id: string;
    wsJobNumber?: string | undefined;
    adjustments?: CostCodeAdjustmentItem[] | undefined;
    archived?: boolean | undefined;
    createdById?: number | undefined;
    updatedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    adjustedRev?: number | undefined;
    previousAdjustedRev?: number | undefined;
    revChanged?: boolean | undefined;
    createdBy?: UserCoreDto | undefined;
}

export interface CreateCostCodeAdjustmentRequest {
    adjustments?: CostCodeAdjustmentItem[] | undefined;
    adjustedRev: number;
}

export interface IntegrationStatusDto {
    id: number;
    description?: string | undefined;
    lastUpdateDate?: Date | undefined;
    mtdCalcMonth?: number | undefined;
    intgStatusId?: string | undefined;
}

export interface JobSummaryDto {
    billed: number;
    custNmbr: string;
    custName: string;
    divisions?: string | undefined;
    salesPerson: string;
    salesPersonName: string;
    certifiedPayroll: number;
    liquidatedDamages: string;
    ocip: string;
    taxExempt: boolean;
    vendorDiscount: number;
    contractAmt: number;
    costAtComp: number;
    currentCostMonth: number;
    estCostPeriodJtd: number;
    gmPrcnt: number;
    jobAddressCode: string;
    lastUpdated?: Date | undefined;
    marginCurrentMonth: number;
    pctCompleted: number;
    periodJtdCosts: number;
    revEarnedCurrMonth: number;
    revEarnedLastPeriodJtd: number;
    revEarnedPeriodJtd: number;
    wsJobName: string;
    wsJobNumber: string;
    jobStatus?: string | undefined;
}

export interface NextPreviousJobResponse {
    next: string;
    previous: string;
}

export interface CtcNextPreviousRequest {
    divisions?: string[] | undefined;
    offices?: string[] | undefined;
}

export interface CtcListResponse {
    jobs: JobSummaryDto[];
    linkedJobs: JobDto[];
    details: any;
}

export interface JobDto {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    jobNumber?: string | undefined;
    location?: LocationDto | undefined;
    ctcConnected?: boolean | undefined;
    division?: string | undefined;
    divisionId?: number | undefined;
    folderId?: string | undefined;
    documentTemplateId?: string | undefined;
    milestoneTemplateId?: string | undefined;
    changeTemplateId?: string | undefined;
    taxExempt?: boolean | undefined;
    vendorDiscounts?: boolean | undefined;
    milestoneId?: string | undefined;
    customerNumber?: string | undefined;
    customerName?: string | undefined;
    complexProgress?: boolean | undefined;
    archived?: boolean | undefined;
    perDiemEnabled?: boolean | undefined;
    perDiemAmount?: number | undefined;
    scalePayEnabled?: boolean | undefined;
    rfiWorkflowId?: number | undefined;
    submittalWorkflowId?: number | undefined;
    drawingWorkflowId?: number | undefined;
    transmittalWorkflowId?: number | undefined;
    changeOrderWorkflowId?: number | undefined;
    jobType: string;
    serviceUserId?: number | undefined;
    serviceOfficeId?: number | undefined;
    serviceUser?: UserCoreDto | undefined;
    serviceOffice?: OrganizationOfficeDto | undefined;
    divisionEntity?: DivisionDto | undefined;
    milestone?: MilestonePhaseDto | undefined;
    classificationRates?: JobClassificationRateDto[] | undefined;
    payCodeOverrides?: JobPayCodeDto[] | undefined;
    team?: JobUserDto[] | undefined;
    rates?: RateDto[] | undefined;
    hyperlinks?: HyperlinkDto[] | undefined;
    rfiWorkflow?: WorkflowDto | undefined;
    submittalWorkflow?: WorkflowDto | undefined;
    drawingWorkflow?: WorkflowDto | undefined;
    transmittalWorkflow?: WorkflowDto | undefined;
    changeOrderWorkflow?: WorkflowDto | undefined;
    timesheetWorkflow?: WorkflowDto | undefined;
}

/** Job location with address and optional geographic coordinates */
export interface LocationDto {
    address?: string | undefined;
    geo?: GeoDto | undefined;
}

/** Geographic coordinates for a job location */
export interface GeoDto {
    lat?: number | undefined;
    lng?: number | undefined;
}

export interface MilestonePhaseRequestDto {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    complete?: boolean | undefined;
    status?: string | undefined;
    order?: number | undefined;
    oldId?: string | undefined;
    jobId?: number | undefined;
    templateId?: string | undefined;
}

export interface MilestonePhaseDto extends MilestonePhaseRequestDto {
    id: string;
    default?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    targetItems?: MilestonePhaseItemDto[] | undefined;
}

export interface MilestonePhaseItemRequestDto {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    critical?: string | undefined;
    requireAssociation?: string | undefined;
    complete?: boolean | undefined;
    status?: string | undefined;
    phaseId?: string | undefined;
    jobId?: number | undefined;
    milestoneTemplateId?: string | undefined;
    assigneeUserId?: number | undefined;
    assignedTo?: RoleReferenceDto[] | undefined;
}

export interface MilestonePhaseItemDto extends MilestonePhaseItemRequestDto {
    id: string;
    default?: boolean | undefined;
    order: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    phase?: MilestonePhaseReferenceDto | undefined;
    assignedTo?: OrganizationRoleDto[] | undefined;
}

/** The owning phase as seen from an item. Slim on purpose: a full MilestonePhaseDto here would make the phase and item maps mutually recursive. */
export interface MilestonePhaseReferenceDto {
    id: string;
    title?: string | undefined;
    order?: number | undefined;
}

export interface RoleReferenceDto {
    id: number;
}

export interface JobClassificationRateRequestDto {
    id?: string | undefined;
    jobId: number;
    classificationId: string;
    scaleRate: number;
    fringeRate: number;
}

export interface JobClassificationRateDto extends JobClassificationRateRequestDto {
    id: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    classification?: ClassificationDto | undefined;
}

export interface JobPayCodeRequestDto {
    id?: string | undefined;
    jobId: number;
    payCodeId: string;
    rateModifierMultiplier: number;
}

export interface JobPayCodeDto extends JobPayCodeRequestDto {
    id: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    payCode?: PayCodeDto | undefined;
}

export interface PayCodeRequestDto {
    id?: string | undefined;
    name: string;
    rateModifierMultiplier: number;
    bypassScalePay: boolean;
    isDirect: boolean;
    isOvertime: boolean;
    color?: string | undefined;
}

export interface PayCodeDto extends PayCodeRequestDto {
    id: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    jobOverrides?: JobPayCodeDto[] | undefined;
}

export interface RateRequestDto {
    id?: number | undefined;
    category?: string | undefined;
    label?: string | undefined;
    rate1?: string | undefined;
    rateMeasurement?: string | undefined;
    jobId?: number | undefined;
    archived?: boolean | undefined;
    isTemplate?: boolean | undefined;
    workTicketId?: string | undefined;
    quantity?: string | undefined;
}

export interface RateDto extends RateRequestDto {
    id: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface HyperlinkDto {
    id: string;
    jobId?: number | undefined;
    title?: string | undefined;
    url?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface CtcListFiltersRequest {
    divisions?: string[] | undefined;
    offices?: string[] | undefined;
}

export interface JobPoDataDto {
    id: number;
    wsJobNumber?: string | undefined;
    jobName?: string | undefined;
    ponumber?: string | undefined;
    poStatus?: string | undefined;
    docdate?: Date | undefined;
    vendorid?: string | undefined;
    vendname?: string | undefined;
    poAmount?: number | undefined;
    remainingPoBalance?: number | undefined;
    modifdt?: Date | undefined;
    buyerid?: string | undefined;
    poLineStatus?: string | undefined;
    itemnmbr?: string | undefined;
    itemdesc?: string | undefined;
    locncode?: string | undefined;
    uofm?: string | undefined;
    division?: string | undefined;
    costcode?: string | undefined;
    qtyorder?: number | undefined;
    qtycance?: number | undefined;
    unitcost?: number | undefined;
    extdcost?: number | undefined;
}

export interface JobChangeOrderDto {
    wsJobNumber?: string | undefined;
    changeOrderNbr?: string | undefined;
    changeOrderStatus?: string | undefined;
    chgOrderDescription?: string | undefined;
    trimmedChgOrderDescription?: string | undefined;
    changeOrderEstCost?: number | undefined;
    postingStatus?: string | undefined;
    postingDate?: Date | undefined;
    lastUpdated?: Date | undefined;
}

export interface JobMaterialsTotalResponse {
    value: number;
    remaining: number;
}

export interface JobCostDetailDto {
    wsJobNumber?: string | undefined;
    wsJobName?: string | undefined;
    divisions?: string | undefined;
    customer?: string | undefined;
    jobType?: string | undefined;
    estimator?: string | undefined;
    originalContract?: number | undefined;
    postedCoTotal?: number | undefined;
    contractToDate?: number | undefined;
    certifiedPayroll?: number | undefined;
    deviceCount?: string | undefined;
    squareFootage?: string | undefined;
    liquidatedDamages?: string | undefined;
    ocip?: string | undefined;
    bonded?: string | undefined;
    costCategory?: string | undefined;
    costCode?: string | undefined;
    costCodeDescription?: string | undefined;
    trxsorce?: string | undefined;
    docnumbr?: string | undefined;
    employeeName?: string | undefined;
    committedCost?: number | undefined;
    amount?: string | undefined;
    hours?: number | undefined;
    docdate?: Date | undefined;
    revenueAdj?: number | undefined;
    grossBilled?: number | undefined;
    retentionHeld?: number | undefined;
    retentionBilled?: number | undefined;
    ponumber?: string | undefined;
    jobTrxNumber?: string | undefined;
    documentSource?: string | undefined;
}

export interface CtcJobDetailResponse {
    importJobId?: number | undefined;
    job?: JobSummaryDto | undefined;
    details: JobCostDetailDto[];
    invoices: JobInvoiceDataDto[];
    changeOrders: JobChangeOrderDto[];
    summary: JobCostCodeSummaryGpDto[];
}

export interface JobInvoiceDataDto {
    id: number;
    wsJobNumber?: string | undefined;
    custname?: string | undefined;
    docType?: string | undefined;
    documentNumber?: string | undefined;
    docDate?: Date | undefined;
    documentAmount?: number | undefined;
    cashReceived?: number | undefined;
    cashRemainingAmount?: number | undefined;
    contractBilled?: number | undefined;
    invoiceDescription?: string | undefined;
}

export interface JobCostCodeSummaryGpDto {
    distDesc?: string | undefined;
    wsJobNumber?: string | undefined;
    wsJobName?: string | undefined;
    divisions?: string | undefined;
    costCode?: string | undefined;
    costCodeDescription?: string | undefined;
    originalEstimateCost?: number | undefined;
    revisedEstimateCost?: number | undefined;
    committedCost?: number | undefined;
    jtdCost?: number | undefined;
    mtdCost?: number | undefined;
    estHours?: number | undefined;
    jtdHours?: number | undefined;
    mtdHours?: number | undefined;
    estimatedRate?: number | undefined;
    ctcHours?: number | undefined;
    jtdRate?: number | undefined;
    ctc?: number | undefined;
    priorEarned?: number | undefined;
}

export interface DailyRequestDto {
    id?: string | undefined;
    date?: Date | undefined;
    description?: string | undefined;
    questions?: DailyQuestionAnswer[] | undefined;
    weather?: string | undefined;
    status?: string | undefined;
    jobId?: number | undefined;
    excludeImages?: boolean | undefined;
    excludeProgress?: boolean | undefined;
    excludeQuestions?: boolean | undefined;
    excludeTickets?: boolean | undefined;
    excludeTimesheets?: boolean | undefined;
    exclusionImagesReason?: string | undefined;
    exclusionProgressReason?: string | undefined;
    exclusionQuestionsReason?: string | undefined;
    exclusionTicketsReason?: string | undefined;
    exclusionTimesheetsReason?: string | undefined;
    attachmentsToAdd?: AttachmentDto[] | undefined;
    attachmentsToRemove?: AttachmentDto[] | undefined;
    workTicketIdsToAdd?: string[] | undefined;
    progressItemRequests?: DailyProgressItemRequestDto[] | undefined;
    progressItemIds?: string[] | undefined;
}

export interface DailyDto extends DailyRequestDto {
    id: string;
    dailyNumber?: string | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: UserCoreDto | undefined;
    attachment?: AttachmentDto[] | undefined;
    workTicket?: WorkTicketDto[] | undefined;
    dailyProgressItem?: DailyProgressItemDto[] | undefined;
}

export interface WorkTicketRequestDto {
    id?: string | undefined;
    date?: Date | undefined;
    workPerformedDate?: Date | undefined;
    status?: string | undefined;
    requester?: string | undefined;
    signature?: string | undefined;
    useSignaturePad?: boolean | undefined;
    signatureString?: string | undefined;
    summary?: string | undefined;
    archived?: boolean | undefined;
    recipientId?: number | undefined;
    requestedById?: number | undefined;
    jobId?: number | undefined;
    dailyId?: string | undefined;
    attachmentsToAdd?: AttachmentDto[] | undefined;
    attachmentsToRemove?: AttachmentDto[] | undefined;
    rateRequests?: RateRequestDto[] | undefined;
}

export interface WorkTicketDto extends WorkTicketRequestDto {
    id: string;
    createdById?: number | undefined;
    ticketNumber?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    attachment?: AttachmentDto[] | undefined;
    createdBy?: UserCoreDto | undefined;
    recipient?: UserCoreDto | undefined;
    requestedBy?: UserCoreDto | undefined;
    rate?: RateDto[] | undefined;
    daily?: DailyReferenceDto | undefined;
}

/** Back-reference shape for DTOs a daily already links to. It must not reach back into DailyDto: a cycle between two DTOs makes AutoMapper mark both type maps recursive, and the depth-tracked collection plan it then compiles for their shared attachment lists is reused by unrelated maps, which throw on the parameterless Map overload. */
export interface DailyReferenceDto {
    id: string;
    dailyNumber?: string | undefined;
    date?: Date | undefined;
    status?: string | undefined;
}

export interface DailyProgressItemRequestDto {
    id?: string | undefined;
    date?: Date | undefined;
    jobNumber?: string | undefined;
    dailyId?: string | undefined;
    jobId?: number | undefined;
    value?: number | undefined;
    wbsAccountId?: string | undefined;
    wbsAccountAdjustmentId?: string | undefined;
}

export interface DailyProgressItemDto extends DailyProgressItemRequestDto {
    id: string;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface DailyQuestionAnswer {
    id?: number | undefined;
    note?: string | undefined;
    value?: string | undefined;
    question?: string | undefined;
}

export interface ListDailiesRequest {
    jobId?: number | undefined;
    userId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface DailyDesignProgressSummaryDto {
    wbsAccountId: string;
    quantity: number;
}

export interface DailyDesignProgressSummaryRequestDto {
    jobId: number;
    /** Includes the installed progress items already linked to this daily. */
    dailyId?: string | undefined;
    /** Includes the installed progress items with these ids. */
    progressItemIds?: string[] | undefined;
}

export interface UserDailiesAuditResponse {
    userId?: number | undefined;
    fullName?: string | undefined;
    date?: Date | undefined;
    count: number;
    countTimesheets: number;
    countProgress: number;
}

export interface UserDailiesAuditRequest {
    startDate: Date;
    endDate: Date;
    onlyMyTeam?: boolean | undefined;
    supervisorId?: number | undefined;
}

export interface DailyProgressHistoryDto {
    id: string;
    date?: Date | undefined;
    jobNumber?: string | undefined;
    item?: string | undefined;
    dailyId?: string | undefined;
    jobId?: number | undefined;
    value?: number | undefined;
    wbsAccountId?: string | undefined;
    wbsAccountAdjustmentId?: string | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: UserCoreDto | undefined;
    wbsAccount?: WbsAccountDto | undefined;
    wbsAccountAdjustment?: WbsAdjustmentDto | undefined;
}

export interface WbsAccountDto {
    id: string;
    wbsId?: string | undefined;
    parentId?: string | undefined;
    externalWbsId?: string | undefined;
    code?: string | undefined;
    effectiveCostCode?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    apply?: boolean | undefined;
    active?: boolean | undefined;
    archived?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isLeaf?: boolean | undefined;
    startDate?: Date | undefined;
    finishDate?: Date | undefined;
    costCodeId?: string | undefined;
    initialQuantityEstimate: number;
    currentQuantityEstimate?: number | undefined;
    currentQuantityActual?: number | undefined;
    initialHoursEstimate?: number | undefined;
    currentHoursEstimate?: number | undefined;
    currentHoursActual?: number | undefined;
    accountType?: string | undefined;
    unitOfMeasure?: string | undefined;
    isCtcConnected: boolean;
    perDiemEligible: boolean;
    scalePayEnabled: boolean;
    costCode?: WbsCostCodeSimpleResponse | undefined;
    inverseParent: WbsAccountDto[];
    parent?: WbsAccountDto | undefined;
}

export interface WbsCostCodeSimpleResponse {
    id: string;
    code: string;
    name: string;
}

export interface WbsAdjustmentRequestDto {
    adjustmentTypeId?: string | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    adjustmentDate?: Date | undefined;
    target?: string | undefined;
}

export interface WbsAdjustmentDto extends WbsAdjustmentRequestDto {
    id: string;
    wbsAccountId?: string | undefined;
    amount: number;
    createdById?: number | undefined;
    archived?: boolean | undefined;
    adjustmentDate: Date;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isSystemGenerated: boolean;
    target: string;
    adjustmentType?: WbsAdjustmentTypeDto | undefined;
    createdBy?: UserCoreDto | undefined;
    timesheetRows?: WbsTimesheetRowSummaryDto[] | undefined;
    dailyProgressItems?: WbsDailyProgressItemSummaryDto[] | undefined;
}

export interface WbsAdjustmentTypeDto {
    id: string;
    name: string;
    archived?: boolean | undefined;
}

export interface WbsTimesheetRowSummaryDto {
    id: string;
    timesheetId: string;
    hours?: number | undefined;
    date?: Date | undefined;
}

export interface WbsDailyProgressItemSummaryDto {
    id: string;
    dailyId?: string | undefined;
    hoursWorked?: number | undefined;
    date?: Date | undefined;
}

export interface DailyProgressItemsRequestDto {
    jobId: number;
    jobNumber: string;
    date: Date;
    progressItems: ProgressItemEntryDto[];
}

export interface ProgressItemEntryDto {
    wbsAccountId: string;
    value: number;
}

export interface DailyQuestionRequestDto {
    id?: number | undefined;
    isTemplate?: boolean | undefined;
    question?: string | undefined;
    order?: number | undefined;
    jobId?: number | undefined;
}

export interface DailyQuestionDto extends DailyQuestionRequestDto {
    id: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface ListQuestionsRequest {
    isTemplate?: boolean | undefined;
    jobId?: number | undefined;
}

export interface DailySettingRequestDto {
    questions?: boolean | undefined;
    tickets?: boolean | undefined;
    timesheets?: boolean | undefined;
    notes?: boolean | undefined;
    progress?: boolean | undefined;
    equipment?: boolean | undefined;
    contractors?: boolean | undefined;
    concerns?: boolean | undefined;
    media?: boolean | undefined;
}

export interface DailySettingDto extends DailySettingRequestDto {
    id: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface FolderTemplateRequestDto {
    id?: string | undefined;
    name?: string | undefined;
    active?: boolean | undefined;
    officeId?: number | undefined;
}

export interface FolderTemplateDto extends FolderTemplateRequestDto {
    id: string;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: UserCoreDto | undefined;
    office?: OrganizationOfficeDto | undefined;
}

export interface FolderTemplateWithFoldersDto {
    template: FolderTemplateDto;
    folders: DefaultFolderDto[];
}

export interface DefaultFolderRequestDto {
    id?: string | undefined;
    name?: string | undefined;
    templateId?: string | undefined;
    parentId?: string | undefined;
    masterId?: string | undefined;
}

export interface DefaultFolderDto extends DefaultFolderRequestDto {
    id: string;
    archived?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    children?: DefaultFolderDto[] | undefined;
}

export interface DesignModelRequestDto {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    fileSize: number;
    jobId: number;
    wbsAccountId?: string | undefined;
    attachmentsToAdd?: AttachmentDto[] | undefined;
    attachmentsToRemove?: AttachmentDto[] | undefined;
}

export interface DesignModelDto extends DesignModelRequestDto {
    conversionStatus?: string | undefined;
    conversionError?: string | undefined;
    /** File kinds ("ifc", "fab", "cad") whose blobs are gone from storage; filled on Get and Update only. */
    missingFileTypes: string[];
    createdByUserId?: number | undefined;
    updatedByUserId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    ifcData?: IfcDataDto[] | undefined;
    fabData?: FabDataDto | undefined;
    cadData?: CadDataDto | undefined;
    progressItem?: ProgressItemDto[] | undefined;
    attachment?: AttachmentDto[] | undefined;
    job?: JobDto | undefined;
    createdByUser?: UserCoreDto | undefined;
    updatedByUser?: UserCoreDto | undefined;
}

export interface IfcDataDto {
    id: string;
    glbUrl?: string | undefined;
    metadataUrl?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    designModelId?: string | undefined;
}

export interface FabDataDto {
    id: string;
    dataUrl?: string | undefined;
    designModelId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface CadDataDto {
    id: string;
    dataUrl?: string | undefined;
    designModelId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface ProgressItemDto {
    firetrolId: number;
    id?: string | undefined;
    jobId?: number | undefined;
    status?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    expressId?: number | undefined;
    properties: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    designModelId?: string | undefined;
    dailyId?: string | undefined;
}

export interface DownloadUrlDto {
    url: string;
}

export interface LineGroupingDto {
    headGroups: HeadGroupDto[];
    mainlinePipes: MainlinePipeRowDto[];
    quantities: LineQuantityDto[];
    warnings: GroupingWarningDto[];
    overrides: ProgressGroupingOverrideDto[];
    lineTypePrefixes: { [key: string]: string; };
}

export interface HeadGroupDto {
    groupId: string;
    lineName: string;
    prefix: string;
    headModel: string;
    headXyz: CadXyzDto;
    pipes: CadPipeRefDto[];
}

export interface CadXyzDto {
    x: number;
    y: number;
    z: number;
}

export interface CadPipeRefDto {
    cadPipeIndex: number;
    pieceSuffix?: string | undefined;
}

export interface MainlinePipeRowDto {
    lineName: string;
    prefix: string;
    fabPipeUid?: number | undefined;
    pieceSuffix?: string | undefined;
    lengthFeet: number;
}

export interface LineQuantityDto {
    prefix: string;
    quantity: number;
    uom: string;
}

export interface GroupingWarningDto {
    kind: string;
    message: string;
    lineName?: string | undefined;
    severity: string;
}

export interface ProgressGroupingOverrideDto {
    expressId: number;
    groupId?: string | undefined;
    lineName?: string | undefined;
}

export interface ApplyGroupingOverridesRequest {
    assignments: GroupingOverrideAssignmentDto[];
}

export interface GroupingOverrideAssignmentDto {
    expressIds: number[];
    existingGroupId?: string | undefined;
    newGroupLineName?: string | undefined;
}

export interface WbsAccountOptionDto {
    id: string;
    name: string;
    code: string;
}

export interface UpdateProgressItemRequest {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    expressId?: number | undefined;
    properties?: any | undefined;
    designModelId: string;
    groupId?: string | undefined;
    unitContribution?: number | undefined;
    pieceNumber?: string | undefined;
}

/** DTO for document data. */
export interface DocumentDto {
    id: string;
    uid?: string | undefined;
    key?: string | undefined;
    path?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    subtype?: string | undefined;
    resource?: string | undefined;
    size?: number | undefined;
    isFolder?: boolean | undefined;
    email?: string | undefined;
    access?: string | undefined;
    folderType?: string | undefined;
    sequenceNumber?: number | undefined;
    archived?: boolean | undefined;
    masterId?: string | undefined;
    parentId?: string | undefined;
    jobId?: number | undefined;
    uploadedById?: number | undefined;
    isLocked?: boolean | undefined;
    hidden?: boolean | undefined;
    ifcDocumentId?: string | undefined;
    version?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    uploadedBy?: UserCoreDto | undefined;
    parent?: DocumentDto | undefined;
    children: DocumentDto[];
    documents: DocumentDto[];
    versions: DocumentVersionDto[];
    activity: DocumentActivityDto[];
    sharedWith: DocumentSharedWithDto[];
}

/** DTO for document versions. */
export interface DocumentVersionDto {
    id: string;
    uid?: string | undefined;
    key?: string | undefined;
    path?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    subtype?: string | undefined;
    resource?: string | undefined;
    size?: number | undefined;
    version?: string | undefined;
    uploadedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    uploadedBy?: UserCoreDto | undefined;
}

/** DTO for document activity. */
export interface DocumentActivityDto {
    id: number;
    resource?: string | undefined;
    resourceTitle?: string | undefined;
    action?: string | undefined;
    type?: string | undefined;
    person?: string | undefined;
    documentId?: string | undefined;
    jobId?: number | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    user?: UserCoreDto | undefined;
}

/** DTO for shared with user (simplified job user). */
export interface DocumentSharedWithDto {
    id: number;
    userId?: number | undefined;
    jobUserId?: number | undefined;
    documentId?: string | undefined;
    user?: UserCoreDto | undefined;
}

/** Request DTO for creating/updating folders. */
export interface FolderRequestDto {
    name: string;
    email?: string | undefined;
    parentId?: string | undefined;
    masterId?: string | undefined;
    access?: string | undefined;
    folderType?: string | undefined;
    sharedWith?: SharedWithUserRequest[] | undefined;
}

/** Shared with user request item. */
export interface SharedWithUserRequest {
    id?: number | undefined;
    userId: number;
    jobUserId: number;
}

/** Request DTO for updating documents. */
export interface DocumentUpdateRequest {
    name?: string | undefined;
    description?: string | undefined;
}

/** Response DTO for document download. */
export interface DocumentDownloadResponse {
    url: string;
    name: string;
    type?: string | undefined;
}

/** DTO for Drawing responses */
export interface DrawingDto {
    id: string;
    drawingId: number;
    drawingNumber?: string | undefined;
    jobNumber?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    title?: string | undefined;
    type?: string | undefined;
    intentOfReview?: string | undefined;
    externalDrawingNumber?: string | undefined;
    company?: string | undefined;
    submittedOn?: Date | undefined;
    workflowId?: number | undefined;
    reporterUserId?: number | undefined;
    assigneeUserId?: number | undefined;
    jobId?: number | undefined;
    milestonePhaseItemId?: string | undefined;
    submittedToContactId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    daysOpen?: number | undefined;
    reporter?: UserCoreDto | undefined;
    assignee?: UserCoreDto | undefined;
    job?: DrawingJobDto | undefined;
    workflow?: WorkflowDto | undefined;
    submittedToContact?: WorkflowContactDto | undefined;
    attachments?: ResourceAttachmentDto[] | undefined;
    revisions?: ResourceAttachmentDto[] | undefined;
    history?: DrawingHistoryDto[] | undefined;
}

/** Minimal job info for Drawing */
export interface DrawingJobDto {
    id: number;
    jobNumber?: string | undefined;
    name?: string | undefined;
    drawingWorkflowId?: number | undefined;
    drawingWorkflow?: WorkflowDto | undefined;
}

/** History entry DTO for Drawing */
export interface DrawingHistoryDto {
    id: number;
    resource?: string | undefined;
    resourceTitle?: string | undefined;
    action?: string | undefined;
    fields?: string | undefined;
    person?: string | undefined;
    statusChange?: boolean | undefined;
    previousStatus?: string | undefined;
    updatedStatus?: string | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
}

/** A job document offered as an attach-from-system option for a Drawing. */
export interface DrawingDocumentOptionDto {
    id: string;
    name?: string | undefined;
    path?: string | undefined;
    type?: string | undefined;
}

/** Request DTO for creating or updating a Drawing */
export interface DrawingRequestDto {
    id?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    intentOfReview?: string | undefined;
    externalDrawingNumber?: string | undefined;
    company?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    workflowId?: number | undefined;
    assigneeUserId?: number | undefined;
    reporterUserId?: number | undefined;
    milestonePhaseItemId?: string | undefined;
    submittedToContactId?: string | undefined;
    filesToAdd?: AttachmentIdDto[] | undefined;
    filesToRemove?: AttachmentIdDto[] | undefined;
    saveOnly: boolean;
    notification?: NotificationCompositionRequest | undefined;
}

/** Request DTO for external Drawing updates (from external users) */
export interface DrawingExternalUpdateDto {
    status?: string | undefined;
    stepIndex?: number | undefined;
    filesToAdd?: AttachmentIdDto[] | undefined;
    filesToRemove?: AttachmentIdDto[] | undefined;
}

/** Request to attach an existing job document to a Drawing. */
export interface DrawingAttachFromDocumentRequest {
    documentId: string;
}

export interface EmailDto {
    technicalKey: number;
    subject?: string | undefined;
    body?: string | undefined;
    bodyPreview?: string | undefined;
    contentType?: string | undefined;
    hasAttachments?: boolean | undefined;
    webLink?: string | undefined;
    jobId?: string | undefined;
    productType?: string | undefined;
    autoIncrementedNum?: string | undefined;
    conversationId?: string | undefined;
    senderId?: number | undefined;
    creationDatetime?: Date | undefined;
    receivedDatetime?: Date | undefined;
    sentDatetime?: Date | undefined;
    sender?: RecipientDto2 | undefined;
    toRecipients?: ToRecipientDto[] | undefined;
    attachments?: EmailAttachmentDto[] | undefined;
}

export interface RecipientDto2 {
    technicalKey: number;
    publicId: string;
    address: string;
    name: string;
}

export interface ToRecipientDto {
    technicalKey: number;
    publicId: string;
    emailId: number;
    recipientId: number;
    recipient?: RecipientDto2 | undefined;
}

export interface EmailAttachmentDto {
    technicalKey: number;
    emailId: number;
    contentType?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;
    msId?: string | undefined;
}

export interface EmailListRequest {
    jobNumber?: string | undefined;
    productType?: string | undefined;
    productNumber?: string | undefined;
}

export interface EmailAttachmentDownloadDto {
    url: string;
    name?: string | undefined;
    type?: string | undefined;
}

export interface DatabaseStatusResponse {
    firetrolOnly: boolean;
    greatPlainsOnline: boolean;
    firetrolMessage: string;
    greatPlainsMessage: string;
}

export interface GetMeResponse {
    user: User;
    access: AccessInfo;
}

export interface User {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    isDisabled: boolean;
    isArchived: boolean;
    archivedAt?: Date | undefined;
    status: string;
    deviceId?: string | undefined;
    isSuperuser: boolean;
    lastLogin?: Date | undefined;
    createdAt: Date;
    updatedAt: Date;
    companyName?: string | undefined;
    apps?: string | undefined;
    azureId?: string | undefined;
    azureObjectId?: string | undefined;
    divisionAdmin?: boolean | undefined;
    allowAllJobs?: boolean | undefined;
    employeeId?: string | undefined;
    jobTitle?: string | undefined;
    jobTitleId?: string | undefined;
    hireDate?: Date | undefined;
    disableDivisionAccess?: boolean | undefined;
    supervisorId?: number | undefined;
    primaryOfficeId?: number | undefined;
    restrictDivisionAccess?: boolean | undefined;
    divisions?: string | undefined;
    classificationLevelId?: string | undefined;
    hourlyRate?: number | undefined;
    healthInsurance?: number | undefined;
    basicLife?: number | undefined;
    accidentalDeath?: number | undefined;
    holiday?: number | undefined;
    _401k?: number | undefined;
    vac?: number | undefined;
    rateImportKey?: string | undefined;
    classificationId?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberVerifiedAt?: Date | undefined;
    smsConsentStatus: SmsConsentStatus;
    smsConsentAt?: Date | undefined;
    notificationChannels?: string | undefined;
    /** Stored inverted because EF drops an inserted false on a bool column whose DB default is true. */
    chatMemoryDisabled: boolean;
    apiToken: ApiToken[];
    attachment: Attachment[];
    ccAdjustmentCreatedBy: CcAdjustment[];
    ccAdjustmentUpdatedBy: CcAdjustment[];
    ccAdjustmentsHistoryCreatedBy: CcAdjustmentsHistory[];
    ccAdjustmentsHistoryUpdatedBy: CcAdjustmentsHistory[];
    changeAssigneeUser: Change[];
    changeCreatedBy: Change[];
    changeSubmittedToUser: Change[];
    changeTemplate: ChangeTemplate[];
    checklistItemUser: ChecklistItemUser[];
    classification?: Classification | undefined;
    classificationLevel?: ClassificationLevel | undefined;
    contact: Contact[];
    ctcFileProcessedBy: CtcFile[];
    ctcFileUploadedBy: CtcFile[];
    daily: Daily[];
    dailyProgressItem: DailyProgressItem[];
    designModelCreatedByUser: DesignModel[];
    designModelUpdatedByUser: DesignModel[];
    document: Document[];
    documentActivity: DocumentActivity[];
    documentJobUser: DocumentJobUser[];
    documentVersion: DocumentVersion[];
    drawingAssigneeUser: Drawing[];
    drawingReporterUser: Drawing[];
    folderTemplate: FolderTemplate[];
    history: History[];
    inverseSupervisor: User[];
    issueComment: IssueComment[];
    job: Job[];
    ctcJobGrant: CtcJobGrant[];
    jobUser: JobUser[];
    meeting: Meeting[];
    meetingUser: MeetingUser[];
    milestonePhaseItem: MilestonePhaseItem[];
    milestoneTemplate: MilestoneTemplate[];
    piece: Piece[];
    postAssignedTo: Post[];
    postComment: PostComment[];
    postCreatedBy: Post[];
    postMention: PostMention[];
    rfiFromUser: Rfi[];
    rfiReporterUser: Rfi[];
    submittalAssigneeUser: Submittal[];
    submittalReporterUser: Submittal[];
    supervisor?: User | undefined;
    primaryOffice?: OrganizationOffice | undefined;
    timesheetCreatedBy: Timesheet[];
    timesheetHistory: TimesheetHistory[];
    timesheetUser: Timesheet[];
    topicIssueAssignee: TopicIssue[];
    topicIssueCreatedBy: TopicIssue[];
    transmittalAssigneeUser: Transmittal[];
    transmittalFromUser: Transmittal[];
    userAlert: UserAlert[];
    userDivision: UserDivision[];
    userLogin: UserLogin[];
    userNotificationPerson: UserNotification[];
    userNotificationUser: UserNotification[];
    userOrganizationOffice: UserOrganizationOffice[];
    userOrganizationRole: UserOrganizationRole[];
    wbsAccountAdjustment: WbsAccountAdjustment[];
    workTicketCreatedBy: WorkTicket[];
    workTicketRecipient: WorkTicket[];
    workTicketRequestedBy: WorkTicket[];
    workflowCreatedBy: Workflow[];
    workflowLastUpdatedBy: Workflow[];
    userAssumptionLogAdmin: UserAssumptionLog[];
    userAssumptionLogAssumed: UserAssumptionLog[];
    divisionsArray: string[];
    notificationChannelsArray: string[];
    fullName: string;
}

/** SMS consent state machine for a user. Lives in Firetrol.Data (rather than Firetrol.Services/Modules/Notifications) because it is the CLR type of User.SmsConsentStatus, and Firetrol.Services references Firetrol.Data — not the reverse; mirrors the WorkflowResourceType precedent in this same folder. */
export enum SmsConsentStatus {
    NotPrompted = 0,
    Declined = 1,
    Consented = 2,
    OptedOut = 3,
}

export interface ApiToken {
    id: number;
    userId?: number | undefined;
    name: string;
    type: string;
    token: string;
    expiresAt?: Date | undefined;
    createdAt: Date;
    user?: User | undefined;
}

export interface Attachment {
    id: string;
    uid?: string | undefined;
    key?: string | undefined;
    path?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subtype?: string | undefined;
    resource?: string | undefined;
    size?: number | undefined;
    isTemporary?: boolean | undefined;
    archived?: boolean | undefined;
    jobId?: number | undefined;
    rfiId?: string | undefined;
    uploadedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    version?: string | undefined;
    status?: string | undefined;
    submittalId?: string | undefined;
    milestonePhaseItemId?: string | undefined;
    workTicketId?: string | undefined;
    changeId?: string | undefined;
    transmittalId?: string | undefined;
    drawingId?: string | undefined;
    postId?: string | undefined;
    rfiResponseId?: string | undefined;
    dailyId?: string | undefined;
    comment?: string | undefined;
    designModelId?: string | undefined;
    meetingTopicId?: string | undefined;
    category?: string | undefined;
    change?: Change | undefined;
    daily?: Daily | undefined;
    designModel?: DesignModel | undefined;
    drawing?: Drawing | undefined;
    job?: Job | undefined;
    meetingTopic?: MeetingTopic | undefined;
    milestonePhaseItem?: MilestonePhaseItem | undefined;
    post?: Post | undefined;
    rfi?: Rfi | undefined;
    rfiResponse?: Rfi | undefined;
    submittal?: Submittal | undefined;
    transmittal?: Transmittal | undefined;
    uploadedBy?: User | undefined;
    workTicket?: WorkTicket | undefined;
}

export interface Change {
    resourceType: WorkflowResourceType;
    resourceNumber: string;
    id: string;
    date?: Date | undefined;
    status?: string | undefined;
    description?: string | undefined;
    impactNotes?: string | undefined;
    changeNumber?: string | undefined;
    archived?: boolean | undefined;
    jobId?: number | undefined;
    createdById?: number | undefined;
    assigneeUserId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    workflowId?: number | undefined;
    stepIndex?: number | undefined;
    externalContact?: string | undefined;
    externalAccessToken?: string | undefined;
    submittedToContactId?: string | undefined;
    submittedToUserId?: number | undefined;
    proposedAmount?: number | undefined;
    approvedAmount?: number | undefined;
    proposedDays?: number | undefined;
    approvedDays?: number | undefined;
    submittedByCompany?: string | undefined;
    changeTypeId?: string | undefined;
    changeType?: ChangeType | undefined;
    assigneeUser?: User | undefined;
    submittedToContact?: Contact | undefined;
    submittedToUser?: User | undefined;
    attachment: Attachment[];
    createdBy?: User | undefined;
    job?: Job | undefined;
    history: History[];
    postChange: PostChange[];
    workflow?: Workflow | undefined;
}

/** Enum representing the types of resources that support workflow processing. Used for type-safe workflow operations instead of magic strings. */
export enum WorkflowResourceType {
    Rfi = 0,
    Submittal = 1,
    Drawing = 2,
    Transmittal = 3,
    Timesheet = 4,
    Change = 5,
}

export interface ChangeType {
    id: string;
    name: string;
    isActive: boolean;
    sortOrder: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    change: Change[];
}

export interface Contact {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    notes?: string | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    customerNumber?: string | undefined;
    customerName?: string | undefined;
    createdBy?: User | undefined;
}

export interface Job {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    rfiWorkflowId?: number | undefined;
    jobNumber?: string | undefined;
    submittalWorkflowId?: number | undefined;
    location?: string | undefined;
    drawingWorkflowId?: number | undefined;
    folderId?: string | undefined;
    ctcConnected?: boolean | undefined;
    division?: string | undefined;
    documentTemplateId?: string | undefined;
    milestoneTemplateId?: string | undefined;
    taxExempt?: boolean | undefined;
    vendorDiscounts?: boolean | undefined;
    milestoneId?: string | undefined;
    customerNumber?: string | undefined;
    customerName?: string | undefined;
    transmittalWorkflowId?: number | undefined;
    changeOrderWorkflowId?: number | undefined;
    complexProgress?: boolean | undefined;
    archived?: boolean | undefined;
    changeTemplateId?: string | undefined;
    divisionId?: number | undefined;
    perDiemEnabled?: boolean | undefined;
    perDiemAmount?: number | undefined;
    scalePayEnabled?: boolean | undefined;
    jobType: string;
    serviceUserId?: number | undefined;
    serviceOfficeId?: number | undefined;
    attachment: Attachment[];
    change: Change[];
    changeOrderWorkflow?: Workflow | undefined;
    changeTemplate?: ChangeTemplate | undefined;
    ctcJob: CtcJob[];
    daily: Daily[];
    dailyProgressItem: DailyProgressItem[];
    dailyQuestion: DailyQuestion[];
    designModel: DesignModel[];
    divisionNavigation?: Division | undefined;
    document: Document[];
    documentActivity: DocumentActivity[];
    documentTemplate?: FolderTemplate | undefined;
    documentVersion: DocumentVersion[];
    drawing: Drawing[];
    drawingWorkflow?: Workflow | undefined;
    folder?: Document | undefined;
    history: History[];
    hyperlink: Hyperlink[];
    issueComment: IssueComment[];
    jobClassificationRate: JobClassificationRate[];
    jobDateSetting: JobDateSetting[];
    jobPayCode: JobPayCode[];
    jobUser: JobUser[];
    meeting: Meeting[];
    meetingTopic: MeetingTopic[];
    meetingTopicIssue: MeetingTopicIssue[];
    meetingType: MeetingType[];
    meetingUser: MeetingUser[];
    milestone?: MilestonePhase | undefined;
    milestonePhase: MilestonePhase[];
    milestonePhaseItem: MilestonePhaseItem[];
    milestoneTemplate?: MilestoneTemplate | undefined;
    post: Post[];
    postComment: PostComment[];
    progressItem: ProgressItem[];
    rate: Rate[];
    rfi: Rfi[];
    rfiWorkflow?: Workflow | undefined;
    serviceOffice?: OrganizationOffice | undefined;
    serviceUser?: User | undefined;
    submittal: Submittal[];
    submittalWorkflow?: Workflow | undefined;
    timesheet: Timesheet[];
    topicIssue: TopicIssue[];
    transmittal: Transmittal[];
    transmittalWorkflow?: Workflow | undefined;
    userNotification: UserNotification[];
    wbs?: Wbs | undefined;
    workTicket: WorkTicket[];
    workflow: Workflow[];
}

export interface Workflow {
    id: number;
    jobId?: number | undefined;
    createdById?: number | undefined;
    lastUpdatedById?: number | undefined;
    resourceId?: string | undefined;
    name?: string | undefined;
    createButtonColor?: string | undefined;
    isActive?: boolean | undefined;
    isArchived?: boolean | undefined;
    isDefault?: boolean | undefined;
    allowDraft?: boolean | undefined;
    createButtonText?: string | undefined;
    originalWorkflowId?: number | undefined;
    isTemplate?: boolean | undefined;
    isSystem: boolean;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    officeId?: number | undefined;
    allowOwner?: boolean | undefined;
    change: Change[];
    createdBy?: User | undefined;
    drawing: Drawing[];
    inverseOriginalWorkflow: Workflow[];
    job?: Job | undefined;
    jobChangeOrderWorkflow: Job[];
    jobDrawingWorkflow: Job[];
    jobRfiWorkflow: Job[];
    jobSubmittalWorkflow: Job[];
    jobTransmittalWorkflow: Job[];
    lastUpdatedBy?: User | undefined;
    office?: OrganizationOffice | undefined;
    organizationOfficeChangeOrderWorkflow: OrganizationOffice[];
    organizationOfficeDrawingWorkflow: OrganizationOffice[];
    organizationOfficeRfiWorkflow: OrganizationOffice[];
    organizationOfficeSubmittalWorkflow: OrganizationOffice[];
    organizationOfficeTimesheetWorkflow: OrganizationOffice[];
    organizationOfficeTransmittalWorkflow: OrganizationOffice[];
    originalWorkflow?: Workflow | undefined;
    rfi: Rfi[];
    submittal: Submittal[];
    timesheet: Timesheet[];
    transmittal: Transmittal[];
    workflowRole: WorkflowRole[];
    workflowStep: WorkflowStep[];
    workflowUser: WorkflowUser[];
}

export interface Drawing {
    resourceType: WorkflowResourceType;
    resourceNumber: string;
    id: string;
    status?: string | undefined;
    stepIndex?: number | undefined;
    drawingId: number;
    jobNumber?: string | undefined;
    drawingNumber?: string | undefined;
    submittedOn?: Date | undefined;
    title?: string | undefined;
    type?: string | undefined;
    intentOfReview?: string | undefined;
    externalDrawingNumber?: string | undefined;
    company?: string | undefined;
    milestonePhaseItemId?: string | undefined;
    workflowId?: number | undefined;
    reporterUserId?: number | undefined;
    assigneeUserId?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    externalAccessToken?: string | undefined;
    submittedToContactId?: string | undefined;
    submittedToContact?: Contact | undefined;
    assigneeUser?: User | undefined;
    attachment: Attachment[];
    history: History[];
    job?: Job | undefined;
    milestonePhaseItem?: MilestonePhaseItem | undefined;
    reporterUser?: User | undefined;
    workflow?: Workflow | undefined;
}

export interface History {
    id: number;
    resource?: string | undefined;
    resourceTitle?: string | undefined;
    action?: string | undefined;
    fields?: string | undefined;
    person?: string | undefined;
    statusChange?: boolean | undefined;
    previousStatus?: string | undefined;
    updatedStatus?: string | undefined;
    rfiId?: string | undefined;
    jobId?: number | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    submittalId?: string | undefined;
    drawingId?: string | undefined;
    transmittalId?: string | undefined;
    changeId?: string | undefined;
    change?: Change | undefined;
    drawing?: Drawing | undefined;
    job?: Job | undefined;
    rfi?: Rfi | undefined;
    submittal?: Submittal | undefined;
    transmittal?: Transmittal | undefined;
    user?: User | undefined;
}

export interface Rfi {
    resourceType: WorkflowResourceType;
    resourceNumber: string;
    id: string;
    rfiId: number;
    rfiNumber?: string | undefined;
    externalEmail?: string | undefined;
    uid?: string | undefined;
    costDays?: string | undefined;
    costDollars?: string | undefined;
    externalRfiNumber?: string | undefined;
    from?: string | undefined;
    fromCompany?: string | undefined;
    impact?: string | undefined;
    impactNotes?: string | undefined;
    question?: string | undefined;
    recommendation?: string | undefined;
    responseToImpacts?: string | undefined;
    responseToQuestions?: string | undefined;
    responseFrom?: string | undefined;
    responseDate?: Date | undefined;
    slug?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    submittedOn?: Date | undefined;
    workflowId?: number | undefined;
    fromUserId?: number | undefined;
    reporterUserId?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    needDate?: Date | undefined;
    externalContact?: string | undefined;
    externalAccessToken?: string | undefined;
    submittedToContactId?: string | undefined;
    submittedToContact?: Contact | undefined;
    attentionContactId?: string | undefined;
    attentionContact?: Contact | undefined;
    attachmentRfi: Attachment[];
    attachmentRfiResponse: Attachment[];
    fromUser?: User | undefined;
    history: History[];
    job?: Job | undefined;
    postRfi: PostRfi[];
    reporterUser?: User | undefined;
    workflow?: Workflow | undefined;
}

export interface PostRfi {
    id: number;
    postId?: string | undefined;
    rfiId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    post?: Post | undefined;
    rfi?: Rfi | undefined;
}

export interface Post {
    id: string;
    visibility?: string | undefined;
    content: string;
    plainTextContent: string;
    status?: string | undefined;
    archived?: boolean | undefined;
    postType?: string | undefined;
    jobId?: number | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    usersToNotify?: string | undefined;
    assignedToId?: number | undefined;
    constraint?: boolean | undefined;
    critical?: boolean | undefined;
    cost?: boolean | undefined;
    resolved?: boolean | undefined;
    date?: Date | undefined;
    ctc?: boolean | undefined;
    subject?: string | undefined;
    assignedTo?: User | undefined;
    attachment: Attachment[];
    createdBy?: User | undefined;
    job?: Job | undefined;
    postChange: PostChange[];
    postTransmittal: PostTransmittal[];
    postComment: PostComment[];
    postDaily: PostDaily[];
    postDocument: PostDocument[];
    postGroup: PostGroup[];
    postMeeting: PostMeeting[];
    postMention: PostMention[];
    postRfi: PostRfi[];
    userNotification: UserNotification[];
}

export interface PostChange {
    id: number;
    postId?: string | undefined;
    changeId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    change?: Change | undefined;
    post?: Post | undefined;
}

export interface PostTransmittal {
    id: number;
    postId?: string | undefined;
    transmittalId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    post?: Post | undefined;
    transmittal?: Transmittal | undefined;
}

export interface Transmittal {
    resourceType: WorkflowResourceType;
    resourceNumber: string;
    id: string;
    transmittalNumber?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    notes?: string | undefined;
    jobId?: number | undefined;
    assigneeUserId?: number | undefined;
    workflowId?: number | undefined;
    fromUserId?: number | undefined;
    dateSent?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    title?: string | undefined;
    externalContact?: string | undefined;
    externalAccessToken?: string | undefined;
    submittedToContactId?: string | undefined;
    submittedToContact?: Contact | undefined;
    assigneeUser?: User | undefined;
    fromUser?: User | undefined;
    history: History[];
    postTransmittal: PostTransmittal[];
    job?: Job | undefined;
    attachment: Attachment[];
    workflow?: Workflow | undefined;
}

export interface PostComment {
    id: string;
    comment?: string | undefined;
    authorId?: number | undefined;
    postId?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    author?: User | undefined;
    job?: Job | undefined;
    post?: Post | undefined;
}

export interface PostDaily {
    id: number;
    postId?: string | undefined;
    dailyId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    daily?: Daily | undefined;
    post?: Post | undefined;
}

export interface Daily {
    id: string;
    date?: Date | undefined;
    description?: string | undefined;
    questions?: string | undefined;
    weather?: string | undefined;
    status?: string | undefined;
    jobId?: number | undefined;
    dailyNumber?: string | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    excludeImages?: boolean | undefined;
    excludeProgress?: boolean | undefined;
    excludeQuestions?: boolean | undefined;
    excludeTickets?: boolean | undefined;
    excludeTimesheets?: boolean | undefined;
    exclusionImagesReason?: string | undefined;
    exclusionProgressReason?: string | undefined;
    exclusionQuestionsReason?: string | undefined;
    exclusionTicketsReason?: string | undefined;
    exclusionTimesheetsReason?: string | undefined;
    attachment: Attachment[];
    createdBy?: User | undefined;
    dailyProgressItem: DailyProgressItem[];
    job?: Job | undefined;
    postDaily: PostDaily[];
    workTicket: WorkTicket[];
    questionsArray: DailyQuestionAnswer[];
}

export interface DailyProgressItem {
    id: string;
    date?: Date | undefined;
    jobNumber?: string | undefined;
    item: string;
    dailyId?: string | undefined;
    createdById?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    value?: number | undefined;
    wbsAccountId?: string | undefined;
    wbsAccountAdjustmentId?: string | undefined;
    createdBy?: User | undefined;
    daily?: Daily | undefined;
    job?: Job | undefined;
    wbsAccount?: WbsAccount | undefined;
    wbsAccountAdjustment?: WbsAccountAdjustment | undefined;
}

export interface WbsAccount {
    id: string;
    wbsId?: string | undefined;
    parentId?: string | undefined;
    externalWbsId?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    apply?: boolean | undefined;
    active?: boolean | undefined;
    archived?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isLeaf?: boolean | undefined;
    startDate?: Date | undefined;
    finishDate?: Date | undefined;
    costCodeId?: string | undefined;
    initialQuantityEstimate: number;
    currentQuantityEstimate?: number | undefined;
    currentQuantityActual?: number | undefined;
    initialHoursEstimate?: number | undefined;
    currentHoursEstimate?: number | undefined;
    currentHoursActual?: number | undefined;
    accountType?: string | undefined;
    unitOfMeasure?: string | undefined;
    isCtcConnected: boolean;
    timesheetsOnly?: boolean | undefined;
    progressManaged: boolean;
    perDiemEligible: boolean;
    scalePayEnabled: boolean;
    costCode?: WbsCostCode | undefined;
    dailyProgressItem: DailyProgressItem[];
    inverseParent: WbsAccount[];
    parent?: WbsAccount | undefined;
    timesheetRow: TimesheetRow[];
    wbs?: Wbs | undefined;
    wbsAccountAdjustment: WbsAccountAdjustment[];
    designModel: DesignModel[];
}

export interface WbsCostCode {
    id: string;
    code: string;
    name: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isServiceCode?: boolean | undefined;
    wbsAccount: WbsAccount[];
    wbsCostCodeOffice: WbsCostCodeOffice[];
}

export interface WbsCostCodeOffice {
    id: number;
    wbsCostCodeId?: string | undefined;
    organizationOfficeId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    organizationOffice?: OrganizationOffice | undefined;
    wbsCostCode?: WbsCostCode | undefined;
}

export interface OrganizationOffice {
    id: number;
    name: string;
    description: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    divisions?: string | undefined;
    modules?: string | undefined;
    rfiWorkflowId?: number | undefined;
    submittalWorkflowId?: number | undefined;
    drawingWorkflowId?: number | undefined;
    transmittalWorkflowId?: number | undefined;
    timesheetWorkflowId?: number | undefined;
    changeOrderWorkflowId?: number | undefined;
    perDiemEnabled?: boolean | undefined;
    perDiemAmount?: number | undefined;
    dailyModules?: string | undefined;
    dailyQuestions?: string | undefined;
    timezone?: string | undefined;
    businessHoursStart?: string | undefined;
    businessHoursEnd?: string | undefined;
    businessDaysArray?: number[] | undefined;
    changeOrderWorkflow?: Workflow | undefined;
    changeTemplate: ChangeTemplate[];
    drawingWorkflow?: Workflow | undefined;
    folderTemplate: FolderTemplate[];
    job: Job[];
    jobTitle: JobTitle[];
    milestonesOffice: MilestonesOffice[];
    organizationOfficeDivision: OrganizationOfficeDivision[];
    rfiWorkflow?: Workflow | undefined;
    submittalWorkflow?: Workflow | undefined;
    timesheetWorkflow?: Workflow | undefined;
    transmittalWorkflow?: Workflow | undefined;
    primaryOfficeUsers: User[];
    userOrganizationOffice: UserOrganizationOffice[];
    wbsCostCodeOffice: WbsCostCodeOffice[];
    workflow: Workflow[];
}

export interface ChangeTemplate {
    id: string;
    createdById?: number | undefined;
    officeId?: number | undefined;
    asOfDate?: Date | undefined;
    isActive?: boolean | undefined;
    title?: string | undefined;
    archived?: boolean | undefined;
    designSheets?: string | undefined;
    laborSheets?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: User | undefined;
    job: Job[];
    office?: OrganizationOffice | undefined;
}

export interface FolderTemplate {
    id: string;
    name?: string | undefined;
    active?: boolean | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    officeId?: number | undefined;
    createdBy?: User | undefined;
    defaultFolder: DefaultFolder[];
    job: Job[];
    office?: OrganizationOffice | undefined;
}

export interface DefaultFolder {
    id: string;
    name?: string | undefined;
    archived?: boolean | undefined;
    masterId?: string | undefined;
    parentId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    templateId?: string | undefined;
    inverseMaster: DefaultFolder[];
    inverseParent: DefaultFolder[];
    master?: DefaultFolder | undefined;
    parent?: DefaultFolder | undefined;
    template?: FolderTemplate | undefined;
}

export interface JobTitle {
    id: string;
    title?: string | undefined;
    organizationOfficeId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    organizationOffice?: OrganizationOffice | undefined;
}

export interface MilestonesOffice {
    id: number;
    milestoneTemplateId?: string | undefined;
    organizationOfficeId?: number | undefined;
    createdAt: Date;
    updatedAt: Date;
    milestoneTemplate?: MilestoneTemplate | undefined;
    organizationOffice?: OrganizationOffice | undefined;
}

export interface MilestoneTemplate {
    id: string;
    name?: string | undefined;
    active?: boolean | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: User | undefined;
    job: Job[];
    milestonePhase: MilestonePhase[];
    milestonePhaseItem: MilestonePhaseItem[];
    milestonesOffice: MilestonesOffice[];
}

export interface MilestonePhase {
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    complete?: boolean | undefined;
    status?: string | undefined;
    order?: number | undefined;
    oldId?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    templateId?: string | undefined;
    job: Job[];
    jobNavigation?: Job | undefined;
    milestonePhaseItem: MilestonePhaseItem[];
    template?: MilestoneTemplate | undefined;
}

export interface MilestonePhaseItem {
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    complete?: boolean | undefined;
    status?: string | undefined;
    requireAssociation?: string | undefined;
    critical?: string | undefined;
    phaseId?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    milestoneTemplateId?: string | undefined;
    assigneeUserId?: number | undefined;
    order: number;
    assigneeUser?: User | undefined;
    attachment: Attachment[];
    checklistItemUser: ChecklistItemUser[];
    drawing: Drawing[];
    job?: Job | undefined;
    milestonePhaseItemRole: MilestonePhaseItemRole[];
    milestoneTemplate?: MilestoneTemplate | undefined;
    phase?: MilestonePhase | undefined;
    submittal: Submittal[];
}

export interface ChecklistItemUser {
    id: number;
    checklistItemId?: string | undefined;
    assignedToId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    assignedTo?: User | undefined;
    checklistItem?: MilestonePhaseItem | undefined;
}

export interface MilestonePhaseItemRole {
    id: number;
    milestonePhaseItemId?: string | undefined;
    organizationRoleId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    milestonePhaseItem?: MilestonePhaseItem | undefined;
    organizationRole?: OrganizationRole | undefined;
}

export interface OrganizationRole {
    id: number;
    name: string;
    whitelist: string;
    scopes: string;
    description: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    office?: string | undefined;
    dailyAuditTracking?: boolean | undefined;
    serviceJobTracking?: boolean | undefined;
    milestonePhaseItemRole: MilestonePhaseItemRole[];
    postGroup: PostGroup[];
    userOrganizationRole: UserOrganizationRole[];
    workflowRole: WorkflowRole[];
    whitelistArray: string[];
    scopesArray: string[];
}

export interface PostGroup {
    id: number;
    postId?: string | undefined;
    groupId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    group?: OrganizationRole | undefined;
    post?: Post | undefined;
}

export interface UserOrganizationRole {
    id: number;
    userId?: number | undefined;
    organizationRoleId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    organizationRole?: OrganizationRole | undefined;
    user?: User | undefined;
}

export interface WorkflowRole {
    id: number;
    workflowId?: number | undefined;
    organizationRoleId?: number | undefined;
    workflowStepId?: number | undefined;
    type: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    organizationRole?: OrganizationRole | undefined;
    workflow?: Workflow | undefined;
    workflowStep?: WorkflowStep | undefined;
}

export interface WorkflowStep {
    id: number;
    workflowId?: number | undefined;
    allowReject?: boolean | undefined;
    allowRevise?: boolean | undefined;
    allowVoid?: boolean | undefined;
    editable?: boolean | undefined;
    isExternalStep?: boolean | undefined;
    isLastStep?: boolean | undefined;
    notifyAssignees?: boolean | undefined;
    buttonText?: string | undefined;
    buttonColor?: string | undefined;
    label?: string | undefined;
    displayLabel?: string | undefined;
    description?: string | undefined;
    stepNumber?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createPdf?: boolean | undefined;
    attachPdfToNotification?: boolean | undefined;
    isEmployeeReviewStep?: boolean | undefined;
    allowOwner?: boolean | undefined;
    isSupervisorReviewStep?: boolean | undefined;
    notifyOnSignedEdit?: boolean | undefined;
    workflow?: Workflow | undefined;
    workflowRole: WorkflowRole[];
    workflowUser: WorkflowUser[];
}

export interface WorkflowUser {
    id: number;
    workflowId?: number | undefined;
    jobUserId?: number | undefined;
    workflowStepId?: number | undefined;
    type: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    jobUser?: JobUser | undefined;
    workflow?: Workflow | undefined;
    workflowStep?: WorkflowStep | undefined;
}

export interface JobUser {
    id: number;
    userId?: number | undefined;
    jobId?: number | undefined;
    source: JobUserSource;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    documentJobUser: DocumentJobUser[];
    job?: Job | undefined;
    user?: User | undefined;
    workflowUser: WorkflowUser[];
}

/** Origin of a job_users grant. Manual rows are created directly (team management or the allowed-jobs editor); Division rows are derived automatically from a restricted user's division membership and may only be mutated by division sync. Lives in Firetrol.Data because it is the CLR type of JobUser.Source, and Firetrol.Services references Firetrol.Data — not the reverse. */
export enum JobUserSource {
    Manual = 0,
    Division = 1,
}

export interface DocumentJobUser {
    id: number;
    userId?: number | undefined;
    jobUserId?: number | undefined;
    documentId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    document?: Document | undefined;
    jobUser?: JobUser | undefined;
    user?: User | undefined;
}

export interface Document {
    id: string;
    uid?: string | undefined;
    key?: string | undefined;
    path?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    subtype?: string | undefined;
    resource?: string | undefined;
    size?: number | undefined;
    isFolder?: boolean | undefined;
    email?: string | undefined;
    access?: string | undefined;
    folderType?: string | undefined;
    sequenceNumber?: number | undefined;
    archived?: boolean | undefined;
    masterId?: string | undefined;
    parentId?: string | undefined;
    jobId?: number | undefined;
    uploadedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isLocked?: boolean | undefined;
    hidden?: boolean | undefined;
    ifcDocumentId?: string | undefined;
    documentActivity: DocumentActivity[];
    documentJobUser: DocumentJobUser[];
    documentVersionDocument: DocumentVersion[];
    documentVersionIfcDocument: DocumentVersion[];
    documentVersionMaster: DocumentVersion[];
    documentVersionParent: DocumentVersion[];
    ifcDocument?: Document | undefined;
    inverseIfcDocument: Document[];
    inverseMaster: Document[];
    inverseParent: Document[];
    job?: Job | undefined;
    jobNavigation: Job[];
    master?: Document | undefined;
    meeting: Meeting[];
    meetingType: MeetingType[];
    parent?: Document | undefined;
    postDocument: PostDocument[];
    uploadedBy?: User | undefined;
}

export interface DocumentActivity {
    id: number;
    resource?: string | undefined;
    resourceTitle?: string | undefined;
    action?: string | undefined;
    type?: string | undefined;
    person?: string | undefined;
    documentId?: string | undefined;
    jobId?: number | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    document?: Document | undefined;
    job?: Job | undefined;
    user?: User | undefined;
}

export interface DocumentVersion {
    id: string;
    uid?: string | undefined;
    key?: string | undefined;
    path?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    subtype?: string | undefined;
    resource?: string | undefined;
    size?: number | undefined;
    isFolder?: boolean | undefined;
    email?: string | undefined;
    access?: string | undefined;
    folderType?: string | undefined;
    sequenceNumber?: number | undefined;
    archived?: boolean | undefined;
    documentId?: string | undefined;
    masterId?: string | undefined;
    parentId?: string | undefined;
    jobId?: number | undefined;
    uploadedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isLocked?: boolean | undefined;
    ifcDocumentId?: string | undefined;
    version?: string | undefined;
    document?: Document | undefined;
    ifcDocument?: Document | undefined;
    job?: Job | undefined;
    master?: Document | undefined;
    parent?: Document | undefined;
    uploadedBy?: User | undefined;
}

export interface Meeting {
    id: string;
    title?: string | undefined;
    status?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    customLeads?: string | undefined;
    customInvitees?: string | undefined;
    customAttendees?: string | undefined;
    customAdmins?: string | undefined;
    archived?: boolean | undefined;
    jobId?: number | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    meetingTypeId?: string | undefined;
    exportId?: string | undefined;
    createdBy?: User | undefined;
    export?: Document | undefined;
    issueComment: IssueComment[];
    job?: Job | undefined;
    meetingTopic: MeetingTopic[];
    meetingType?: MeetingType | undefined;
    meetingUser: MeetingUser[];
    postMeeting: PostMeeting[];
    topicIssue: TopicIssue[];
}

export interface IssueComment {
    id: string;
    dueDate?: Date | undefined;
    comment?: string | undefined;
    authorId?: number | undefined;
    meetingId?: string | undefined;
    topicId?: string | undefined;
    issueId?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    author?: User | undefined;
    issue?: TopicIssue | undefined;
    job?: Job | undefined;
    meeting?: Meeting | undefined;
    topic?: MeetingTopic | undefined;
}

export interface TopicIssue {
    id: string;
    complete?: boolean | undefined;
    description?: string | undefined;
    title?: string | undefined;
    priority?: string | undefined;
    dueDate?: Date | undefined;
    meetingId?: string | undefined;
    topicId?: string | undefined;
    assigneeId?: number | undefined;
    jobId?: number | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    assignee?: User | undefined;
    createdBy?: User | undefined;
    issueComment: IssueComment[];
    job?: Job | undefined;
    meeting?: Meeting | undefined;
    meetingTopicIssue: MeetingTopicIssue[];
    topic?: MeetingTopic | undefined;
}

export interface MeetingTopicIssue {
    id: number;
    jobId?: number | undefined;
    topicId?: string | undefined;
    issueId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    issue?: TopicIssue | undefined;
    job?: Job | undefined;
    topic?: MeetingTopic | undefined;
}

export interface MeetingTopic {
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    notepad?: string | undefined;
    meetingId?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    attachment: Attachment[];
    issueComment: IssueComment[];
    job?: Job | undefined;
    meeting?: Meeting | undefined;
    meetingTopicIssue: MeetingTopicIssue[];
    topicIssue: TopicIssue[];
}

export interface MeetingType {
    id: string;
    jobId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    archived?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    folderId?: string | undefined;
    folder?: Document | undefined;
    job?: Job | undefined;
    meeting: Meeting[];
}

export interface MeetingUser {
    id: number;
    userId?: number | undefined;
    meetingId?: string | undefined;
    type: string;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    job?: Job | undefined;
    meeting?: Meeting | undefined;
    user?: User | undefined;
}

export interface PostMeeting {
    id: number;
    postId?: string | undefined;
    meetingId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    meeting?: Meeting | undefined;
    post?: Post | undefined;
}

export interface PostDocument {
    id: number;
    postId?: string | undefined;
    documentId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    document?: Document | undefined;
    post?: Post | undefined;
}

export interface Submittal {
    resourceType: WorkflowResourceType;
    resourceNumber: string;
    id: string;
    status?: string | undefined;
    stepIndex?: number | undefined;
    submittalId: number;
    submittalNumber?: string | undefined;
    submittedOn?: Date | undefined;
    title?: string | undefined;
    type?: string | undefined;
    intentOfReview?: string | undefined;
    externalSubmittalNumber?: string | undefined;
    company?: string | undefined;
    workflowId?: number | undefined;
    reporterUserId?: number | undefined;
    assigneeUserId?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    milestonePhaseItemId?: string | undefined;
    externalAccessToken?: string | undefined;
    submittedToContactId?: string | undefined;
    submittedToContact?: Contact | undefined;
    assigneeUser?: User | undefined;
    attachment: Attachment[];
    history: History[];
    job?: Job | undefined;
    milestonePhaseItem?: MilestonePhaseItem | undefined;
    reporterUser?: User | undefined;
    workflow?: Workflow | undefined;
}

export interface OrganizationOfficeDivision {
    id: number;
    organizationOfficeId?: number | undefined;
    divisionId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    division?: Division | undefined;
    organizationOffice?: OrganizationOffice | undefined;
}

export interface Division {
    id: number;
    name: string;
    officeCode?: string | undefined;
    workTypeCode?: string | undefined;
    tradeCode?: string | undefined;
    suffixCode?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    job: Job[];
    organizationOfficeDivision: OrganizationOfficeDivision[];
    userDivision: UserDivision[];
}

export interface UserDivision {
    id: number;
    userId?: number | undefined;
    divisionId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    division?: Division | undefined;
    user?: User | undefined;
}

export interface UserOrganizationOffice {
    id: number;
    userId?: number | undefined;
    organizationOfficeId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    organizationOffice?: OrganizationOffice | undefined;
    user?: User | undefined;
}

export interface TimesheetRow {
    id: string;
    timesheetId: string;
    wbsAccountId: string;
    sun?: number | undefined;
    mon?: number | undefined;
    tue?: number | undefined;
    wed?: number | undefined;
    thu?: number | undefined;
    fri?: number | undefined;
    sat?: number | undefined;
    total?: number | undefined;
    startAt?: Date | undefined;
    endAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    wbsAccountAdjustmentId?: string | undefined;
    payCodeId?: string | undefined;
    baseRate?: number | undefined;
    fringeRate?: number | undefined;
    payCodeRateModifierMultiplier?: number | undefined;
    levelRateModifierPercent?: number | undefined;
    effectiveRate?: number | undefined;
    isScalePay?: boolean | undefined;
    scaleBaseRate?: number | undefined;
    scaleFringeRate?: number | undefined;
    effectiveScaleBaseRate?: number | undefined;
    effectiveScaleFringeRate?: number | undefined;
    scalePayAdjustmentAmount?: number | undefined;
    bypassScalePay?: boolean | undefined;
    serviceDescription?: string | undefined;
    serviceLocation?: string | undefined;
    serviceCallId?: string | undefined;
    payCodeColor?: string | undefined;
    payCode?: PayCode | undefined;
    timesheet: Timesheet;
    wbsAccount: WbsAccount;
    wbsAccountAdjustment?: WbsAccountAdjustment | undefined;
}

export interface PayCode {
    id: string;
    name: string;
    rateModifierMultiplier: number;
    bypassScalePay: boolean;
    isDirect: boolean;
    isOvertime: boolean;
    color?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    jobPayCode: JobPayCode[];
    timesheetRow: TimesheetRow[];
}

export interface JobPayCode {
    id: string;
    jobId: number;
    payCodeId: string;
    rateModifierMultiplier: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    job: Job;
    payCode: PayCode;
}

export interface Timesheet {
    resourceType: WorkflowResourceType;
    resourceNumber: string;
    id: string;
    archived?: boolean | undefined;
    rowsJson?: string | undefined;
    status?: string | undefined;
    jobNumber?: string | undefined;
    weekId?: number | undefined;
    year?: number | undefined;
    userId?: number | undefined;
    createdById?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    workflowId?: number | undefined;
    stepIndex?: number | undefined;
    isRejected?: boolean | undefined;
    rejectJustification?: string | undefined;
    signature?: string | undefined;
    signedBy?: string | undefined;
    signatureString?: string | undefined;
    signedOn?: Date | undefined;
    externalAccessToken?: string | undefined;
    isComplete: boolean;
    createdBy?: User | undefined;
    job?: Job | undefined;
    timesheetHistory: TimesheetHistory[];
    timesheetRow: TimesheetRow[];
    user?: User | undefined;
    workflow?: Workflow | undefined;
}

export interface TimesheetHistory {
    id: string;
    timesheetId?: string | undefined;
    oldStatus?: string | undefined;
    newStatus?: string | undefined;
    message?: string | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    createdBy?: User | undefined;
    timesheet?: Timesheet | undefined;
}

export interface WbsAccountAdjustment {
    id: string;
    wbsAccountId?: string | undefined;
    adjustmentTypeId?: string | undefined;
    amount: number;
    description?: string | undefined;
    createdById?: number | undefined;
    archived?: boolean | undefined;
    adjustmentDate: Date;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isSystemGenerated: boolean;
    target: string;
    adjustmentType?: WbsAccountAdjustmentType | undefined;
    createdBy?: User | undefined;
    dailyProgressItem: DailyProgressItem[];
    timesheetRow: TimesheetRow[];
    wbsAccount?: WbsAccount | undefined;
}

export interface WbsAccountAdjustmentType {
    id: string;
    name: string;
    description?: string | undefined;
    archived?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    wbsAccountAdjustment: WbsAccountAdjustment[];
}

export interface Wbs {
    id: string;
    jobId?: number | undefined;
    bookedDate?: Date | undefined;
    projectFinalDate?: Date | undefined;
    designStartDate?: Date | undefined;
    submittalDueDate?: Date | undefined;
    materialOnJobDate?: Date | undefined;
    installStartDate?: Date | undefined;
    installCompleteDate?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    job?: Job | undefined;
    wbsAccount: WbsAccount[];
}

export interface DesignModel {
    id: string;
    name: string;
    description?: string | undefined;
    fileSize: number;
    jobId: number;
    createdByUserId: number;
    updatedByUserId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    wbsAccountId?: string | undefined;
    conversionStatus?: string | undefined;
    conversionError?: string | undefined;
    attachment: Attachment[];
    createdByUser: User;
    ifcData: IfcData[];
    job: Job;
    progressItem: ProgressItem[];
    fabData?: FabData | undefined;
    cadData?: CadData | undefined;
    updatedByUser?: User | undefined;
    wbsAccount?: WbsAccount | undefined;
}

export interface IfcData {
    id: string;
    glbPath?: string | undefined;
    metadataPath?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    designModelId?: string | undefined;
    parserVersion: string;
    ifcOpenShellVersion?: string | undefined;
    sourceFileSha256: string;
    designModel?: DesignModel | undefined;
}

export interface ProgressItem {
    firetrolId: number;
    id?: string | undefined;
    jobId?: number | undefined;
    status?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    expressId?: number | undefined;
    properties: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    designModelId?: string | undefined;
    wbsLeafAccountId?: string | undefined;
    groupId?: string | undefined;
    unitContribution?: number | undefined;
    dailyId?: string | undefined;
    designModel?: DesignModel | undefined;
    job?: Job | undefined;
    wbsLeafAccount?: WbsAccount | undefined;
    daily?: Daily | undefined;
}

export interface FabData {
    id: string;
    dataPath?: string | undefined;
    designModelId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    parserVersion: string;
    sourceFileSha256: string;
    designModel?: DesignModel | undefined;
}

export interface CadData {
    id: string;
    dataPath?: string | undefined;
    designModelId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    parserVersion: string;
    sourceFileSha256: string;
    designModel?: DesignModel | undefined;
}

export interface WorkTicket {
    id: string;
    date?: Date | undefined;
    workPerformedDate?: Date | undefined;
    status?: string | undefined;
    requester?: string | undefined;
    signature?: string | undefined;
    useSignaturePad?: boolean | undefined;
    signatureString?: string | undefined;
    summary?: string | undefined;
    archived?: boolean | undefined;
    createdById?: number | undefined;
    recipientId?: number | undefined;
    requestedById?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    dailyId?: string | undefined;
    ticketNumber?: string | undefined;
    attachment: Attachment[];
    createdBy?: User | undefined;
    daily?: Daily | undefined;
    job?: Job | undefined;
    rate: Rate[];
    recipient?: User | undefined;
    requestedBy?: User | undefined;
}

export interface Rate {
    id: number;
    category?: string | undefined;
    label?: string | undefined;
    rate1?: string | undefined;
    rateMeasurement?: string | undefined;
    jobId?: number | undefined;
    archived?: boolean | undefined;
    isTemplate?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    workTicketId?: string | undefined;
    quantity?: string | undefined;
    job?: Job | undefined;
    workTicket?: WorkTicket | undefined;
}

export interface PostMention {
    id: number;
    postId?: string | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    post?: Post | undefined;
    user?: User | undefined;
}

export interface UserNotification {
    id: string;
    message?: string | undefined;
    action?: string | undefined;
    read?: boolean | undefined;
    jobId?: number | undefined;
    userId?: number | undefined;
    personId?: number | undefined;
    postId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    job?: Job | undefined;
    person?: User | undefined;
    post?: Post | undefined;
    user?: User | undefined;
}

export interface CtcJob {
    wsJobNumber: string;
    wsJobName?: string | undefined;
    customer?: string | undefined;
    contractAmount?: number | undefined;
    estimatedCosts?: number | undefined;
    jtdCosts?: number | undefined;
    costAtCompletion?: number | undefined;
    percentComplete?: number | undefined;
    gmPercent?: number | undefined;
    revenueEarned?: number | undefined;
    costs?: number | undefined;
    margin?: number | undefined;
    billed?: number | undefined;
    overUnder?: number | undefined;
    revenueBacklog?: number | undefined;
    revenueAdjustments?: number | undefined;
    originalCostAtCompletion?: number | undefined;
    variance?: number | undefined;
    salesperson?: string | undefined;
    division?: string | undefined;
    office?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    certifiedPayroll?: string | undefined;
    ocip?: string | undefined;
    bonded?: string | undefined;
    lds?: string | undefined;
    ctcLastUpdated?: Date | undefined;
    adjustmentsTotal?: number | undefined;
    costToDate?: string | undefined;
    mtdCost?: string | undefined;
    priorEarnedTotal?: string | undefined;
    taxExempt?: string | undefined;
    vendorDiscounts?: string | undefined;
    jobAddressCode?: string | undefined;
    jobType?: string | undefined;
    employeeName?: string | undefined;
    csv?: string | undefined;
    mtdRevenueEarned?: number | undefined;
    job?: Job | undefined;
}

export interface DailyQuestion {
    id: number;
    isTemplate?: boolean | undefined;
    question?: string | undefined;
    order?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    job?: Job | undefined;
}

export interface Hyperlink {
    id: string;
    title?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    jobNumber?: string | undefined;
    archived?: boolean | undefined;
    jobId: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    job: Job;
}

export interface JobClassificationRate {
    id: string;
    jobId: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    classificationId: string;
    scaleRate: number;
    fringeRate: number;
    classification: Classification;
    job: Job;
}

export interface Classification {
    id: string;
    name: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    classificationLevel: ClassificationLevel[];
    jobClassificationRate: JobClassificationRate[];
    user: User[];
}

export interface ClassificationLevel {
    id: string;
    classificationId: string;
    name: string;
    rateModifierPercent: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    classification: Classification;
    user: User[];
}

export interface JobDateSetting {
    id: string;
    jobNumber?: string | undefined;
    jobId?: number | undefined;
    values?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    job?: Job | undefined;
}

export interface CcAdjustment {
    id: string;
    wsJobNumber?: string | undefined;
    adjustments?: string | undefined;
    archived?: boolean | undefined;
    createdById?: number | undefined;
    updatedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    adjustedRev?: number | undefined;
    createdBy?: User | undefined;
    updatedBy?: User | undefined;
}

export interface CcAdjustmentsHistory {
    id: string;
    wsJobNumber?: string | undefined;
    adjustments?: string | undefined;
    archived?: boolean | undefined;
    createdById?: number | undefined;
    updatedById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    adjustedRev?: number | undefined;
    previousAdjustedRev?: number | undefined;
    revChanged?: boolean | undefined;
    createdBy?: User | undefined;
    updatedBy?: User | undefined;
}

export interface CtcFile {
    id: number;
    active?: boolean | undefined;
    processed?: boolean | undefined;
    files?: string | undefined;
    uploadedById?: number | undefined;
    processedById?: number | undefined;
    processedAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    processedBy?: User | undefined;
    uploadedBy?: User | undefined;
}

export interface CtcJobGrant {
    id: number;
    userId?: number | undefined;
    wsJobNumber: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    user?: User | undefined;
}

export interface Piece {
    id: number;
    description?: string | undefined;
    fitting?: string | undefined;
    length?: string | undefined;
    line?: string | undefined;
    pieceNumber?: number | undefined;
    quantity?: string | undefined;
    diameter?: number | undefined;
    units?: number | undefined;
    displayFeet?: string | undefined;
    displayDiameter?: string | undefined;
    totalUnits?: number | undefined;
    status?: string | undefined;
    systemId?: string | undefined;
    item?: string | undefined;
    pieceType?: string | undefined;
    installedOn?: Date | undefined;
    installedOnWeek?: string | undefined;
    userId?: number | undefined;
    projectId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    project?: Project | undefined;
    user?: User | undefined;
}

export interface Project {
    id: number;
    clientId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    client?: Client | undefined;
    piece: Piece[];
    systemEntity: SystemEntity[];
}

export interface Client {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    project: Project[];
}

export interface SystemEntity {
    id: number;
    name?: string | undefined;
    systemId?: string | undefined;
    projectId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    plan: Plan[];
    project?: Project | undefined;
}

export interface Plan {
    id: number;
    systemName?: string | undefined;
    systemId?: number | undefined;
    items?: string | undefined;
    pStart?: Date | undefined;
    pFinish?: Date | undefined;
    pHours?: number | undefined;
    pWeekStart?: number | undefined;
    pWeekFinish?: number | undefined;
    pUnits?: number | undefined;
    status?: string | undefined;
    pStartKey?: string | undefined;
    pFinishKey?: string | undefined;
    aStart?: Date | undefined;
    aFinish?: Date | undefined;
    aHours?: number | undefined;
    aWeekStart?: number | undefined;
    aWeekFinish?: number | undefined;
    aStartKey?: string | undefined;
    aFinishKey?: string | undefined;
    aUnits?: number | undefined;
    history?: string | undefined;
    seedId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    hoursAtRisk: boolean;
    unitsAtRisk: boolean;
    system?: SystemEntity | undefined;
}

export interface UserAlert {
    id: number;
    userId: number;
    facilityIds: string;
    excludedTeeTimes: string;
    formData: string;
    provider: string;
    query: string;
    searchParams: string;
    isActive: boolean;
    userNotifiedCount: number;
    userNotified: boolean;
    lastNotifiedAt?: Date | undefined;
    checkedAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    user: User;
}

export interface UserLogin {
    id: number;
    userId?: number | undefined;
    ip?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    user?: User | undefined;
}

export interface UserAssumptionLog {
    id: number;
    adminUserId: number;
    assumedUserId: number;
    createdAt: Date;
    adminUser: User;
    assumedUser: User;
}

/** What you were putting into ctx.access in Adonis. */
export interface AccessInfo {
    userId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    scopes: string[];
    isAdmin: boolean;
    isCTCAllowed: boolean;
    isAdminRatesAllowed: boolean;
    isUserHistoryAllowed: boolean;
    divisions?: UserDivision[] | undefined;
    officeIds?: number[] | undefined;
    officeNames?: string[] | undefined;
    primaryOfficeId?: number | undefined;
    roles?: OrganizationRole[] | undefined;
    roleIds?: number[] | undefined;
    disableDivisionAccess?: boolean | undefined;
    /** Firetrol job IDs granted to this user via job_users. Used for Firetrol job filtering. */
    allowedJobIds?: number[] | undefined;
    /** Job numbers for granted jobs. Used for Great Plains CTC filtering (no Firetrol id available there). */
    allowedJobs?: string[] | undefined;
}

export interface CtcSnapshotStatusResponse {
    lastSnapshotUtc?: Date | undefined;
    ageDays?: number | undefined;
}

export interface HyperlinkRequest {
    id?: string | undefined;
    title: string;
    description: string;
    url: string;
    jobId: number;
}

export interface InspectionsOverviewDto {
    linked: boolean;
    inspections: InspectionOverviewDto[];
    sourceUnavailable: boolean;
}

export interface InspectionOverviewDto {
    id: string;
    siteName: string;
    siteNumber?: string | undefined;
    siteAddress?: string | undefined;
    clientName?: string | undefined;
    inspectionTypeName: string;
    state: InspectionState;
    scheduledStartAt?: Date | undefined;
    dueAt?: Date | undefined;
    completedAt?: Date | undefined;
    scopedDeviceCount: number;
    terminalDeviceCount: number;
    performUrl: string;
}

export enum InspectionState {
    Draft = 0,
    Scheduled = 1,
    InProgress = 2,
    Completed = 3,
}

/** Job DTO extended with posts and notifications for the Activity Feed page */
export interface ActivityJobDto extends JobDto {
    /** All visible posts for this job */
    posts: PostDto[];
    /** Unresolved posts assigned to the current user (alerts) */
    notifications: PostDto[];
}

/** Full Post response DTO */
export interface PostDto {
    id: string;
    subject?: string | undefined;
    content?: string | undefined;
    plainTextContent?: string | undefined;
    visibility?: string | undefined;
    status?: string | undefined;
    postType?: string | undefined;
    archived?: boolean | undefined;
    critical?: boolean | undefined;
    constraint?: boolean | undefined;
    cost?: boolean | undefined;
    ctc?: boolean | undefined;
    resolved?: boolean | undefined;
    date?: Date | undefined;
    jobId?: number | undefined;
    job?: PostJobDto | undefined;
    createdById?: number | undefined;
    createdBy?: UserCoreDto | undefined;
    assignedToId?: number | undefined;
    assignedTo?: UserCoreDto | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    comments?: PostCommentDto[] | undefined;
    mentions?: UserCoreDto[] | undefined;
    groups?: OrganizationRoleDto[] | undefined;
    files?: ResourceAttachmentDto[] | undefined;
    documents?: PostDocumentDto[] | undefined;
    meetings?: PostLinkItemDto[] | undefined;
    rfis?: PostLinkItemDto[] | undefined;
    changes?: PostLinkItemDto[] | undefined;
    transmittals?: PostLinkItemDto[] | undefined;
    dailys?: PostLinkItemDto[] | undefined;
}

/** Simplified job info for post responses */
export interface PostJobDto {
    id: number;
    name?: string | undefined;
    jobNumber?: string | undefined;
}

export interface PostCommentDto {
    id: string;
    comment?: string | undefined;
    authorId?: number | undefined;
    author?: UserCoreDto | undefined;
    postId?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

/** Document reference for posts */
export interface PostDocumentDto {
    id: string;
    name?: string | undefined;
    type?: string | undefined;
    jobId?: number | undefined;
    size?: number | undefined;
}

/** Represents a linkable item (Meeting, RFI, Change, Daily) for post associations */
export interface PostLinkItemDto {
    id: string;
    label?: string | undefined;
    resource: string;
    jobId?: number | undefined;
}

/** Summary information for a job including constraints, milestones, and CTC data */
export interface JobSummaryDto2 {
    due: PostDto[];
    constraints: PostDto[];
    milestones: MilestonePhaseDto[];
    ctcJob?: CtcJobSummaryDto | undefined;
}

/** CTC job summary data from Great Plains */
export interface CtcJobSummaryDto {
    wsJobNumber?: string | undefined;
    wsJobName?: string | undefined;
    customer?: string | undefined;
    division?: string | undefined;
    office?: string | undefined;
    salesperson?: string | undefined;
    contractAmount?: number | undefined;
    estimatedCosts?: number | undefined;
    jtdCosts?: number | undefined;
    costAtCompletion?: number | undefined;
    percentComplete?: number | undefined;
    gmPercent?: number | undefined;
    revenueEarned?: number | undefined;
    costs?: number | undefined;
    margin?: number | undefined;
    billed?: number | undefined;
    overUnder?: number | undefined;
    revenueBacklog?: number | undefined;
    ctcLastUpdated?: Date | undefined;
    certifiedPayroll?: string | undefined;
    ocip?: string | undefined;
    bonded?: string | undefined;
    lds?: string | undefined;
}

/** Request DTO for creating or updating a job */
export interface JobRequestDto {
    name?: string | undefined;
    description?: string | undefined;
    jobNumber?: string | undefined;
    customerNumber?: string | undefined;
    customerName?: string | undefined;
    location?: any | undefined;
    divisionId?: number | undefined;
    taxExempt?: boolean | undefined;
    vendorDiscounts?: boolean | undefined;
    perDiemEnabled?: boolean | undefined;
    perDiemAmount?: number | undefined;
    scalePayEnabled?: boolean | undefined;
    documentTemplateId?: string | undefined;
    milestoneTemplateId?: string | undefined;
    changeTemplateId?: string | undefined;
    payCodeOverrides?: JobPayCodeOverrideRequestDto[] | undefined;
    classificationRates?: JobClassificationRateRequestDto2[] | undefined;
}

export interface JobPayCodeOverrideRequestDto {
    payCodeId: string;
    rateModifierMultiplier: number;
}

export interface JobClassificationRateRequestDto2 {
    classificationId: string;
    scaleRate: number;
    fringeRate: number;
}

/** Request DTO for updating job workflow settings */
export interface JobWorkflowSettingsDto {
    rfiWorkflowId?: number | undefined;
    submittalWorkflowId?: number | undefined;
    drawingWorkflowId?: number | undefined;
    transmittalWorkflowId?: number | undefined;
    changeOrderWorkflowId?: number | undefined;
}

/** Request DTO for updating job template settings */
export interface JobTemplateSettingsDto {
    documentTemplateId?: string | undefined;
    milestoneTemplateId?: string | undefined;
    changeTemplateId?: string | undefined;
}

export interface JobOptionDto {
    id: number;
    jobNumber?: string | undefined;
    name?: string | undefined;
    division?: string | undefined;
    /** Firetrol for synced jobs; Ctc for unsynced Great Plains jobs. */
    source: string;
    /** The WS job number (matches JobNumber for Firetrol; the GP key for Ctc). */
    wsJobNumber?: string | undefined;
}

/** Request DTO for bulk archiving jobs */
export interface BulkArchiveJobsRequestDto {
    jobIds: number[];
}

/** Request DTO for getting team by roles */
export interface JobTeamByRolesRequestDto {
    roles?: number[] | undefined;
}

/** Request DTO for adding a team member */
export interface JobTeamMemberRequestDto {
    userId: number;
}

/** A generic wrapper for paginated API responses. */
export interface PagedResultOfKnowledgeArticleListItemDto {
    /** The items for the current page. */
    items: KnowledgeArticleListItemDto[];
    /** The total number of items across all pages. */
    totalCount: number;
    /** The current page number (1-based). */
    page: number;
    /** The number of items per page. */
    pageSize: number;
    /** The total number of pages. */
    totalPages: number;
    /** Whether there is a previous page. */
    hasPreviousPage: boolean;
    /** Whether there is a next page. */
    hasNextPage: boolean;
}

/** List-row shape — deliberately omits Body, which can be up to 20 KB. */
export interface KnowledgeArticleListItemDto {
    id: number;
    title: string;
    summary: string;
    isPublished: boolean;
    archivedAt?: Date | undefined;
    /** "draft" | "published" | "archived", derived from IsPublished/ArchivedAt. */
    status: string;
    /** Empty means the article is global (visible in every office's prompt index). */
    offices: KnowledgeArticleOfficeDto[];
    createdById: number;
    createdByName?: string | undefined;
    updatedById: number;
    updatedByName?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
}

export interface KnowledgeArticleOfficeDto {
    id: number;
    name: string;
}

export interface KnowledgeArticleDto extends KnowledgeArticleListItemDto {
    body: string;
}

/** Shared create/update payload — office links are replaced as a full set on every write. */
export interface KnowledgeArticleUpsertRequestDto {
    title: string;
    summary: string;
    body: string;
    isPublished: boolean;
    officeIds: number[];
}

export interface CostCodeOptionDto {
    id: string;
    label: string;
}

export interface JobManhoursFilterDto {
    division: string;
    baseCostCode: string;
    costCode: string;
}

export interface ListJobManhoursResponse {
    weeks: ManhoursWeekDto[];
    rows: JobManhoursRowDto[];
    totalCtcHours: number;
}

export interface ManhoursWeekDto {
    /** The Saturday that starts the work week. */
    weekStart: Date;
    /** The Friday that ends the work week. */
    weekEnding: Date;
    weekNumber: number;
    /** The year of the week-ending Friday. */
    year: number;
    totalFte: number;
}

export interface JobManhoursRowDto {
    wsJobNumber: string;
    wsJobName: string;
    costCode: string;
    ctcHours: number;
    /** Null when the Great Plains job has no linked Firetrol job. */
    jobId?: number | undefined;
    liquidatedDamages: boolean;
    /** The first day of the spread, whether or not it falls inside the weeks. */
    startDate?: Date | undefined;
    /** The last day of the spread, whether or not it falls inside the weeks. */
    endDate?: Date | undefined;
    /** One value per entry of Weeks, in the same order. */
    weeklyFtes: number[];
    /** Set when the CTC hours cannot be spread over any day. */
    missingSpreadReason?: ManhoursMissingSpreadReason | undefined;
}

export enum ManhoursMissingSpreadReason {
    NoFiretrolJob = 0,
    NoWbsAccount = 1,
    NoWbsDates = 2,
}

export interface ListJobManhoursRequest {
    /** Each value matches as a substring of the Great Plains division string. */
    divisions: string[];
    /** Each value matches as a substring of the cost code. Empty means every cost code. */
    costCodes: string[];
    showClosed: boolean;
    ldOnly: boolean;
    weekCount: number;
}

export interface IssueCommentRequestDto {
    comment?: string | undefined;
}

export interface IssueCommentDto extends IssueCommentRequestDto {
    id: string;
    authorId?: number | undefined;
    author?: UserCoreDto | undefined;
    meetingId?: string | undefined;
    topicId?: string | undefined;
    issueId?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface MeetingDto {
    id: string;
    title?: string | undefined;
    status?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    meetingTypeId?: string | undefined;
    meetingType?: MeetingTypeDto | undefined;
    jobId?: number | undefined;
    exportId?: string | undefined;
    createdById?: number | undefined;
    createdBy?: UserCoreDto | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    topics?: MeetingTopicDto[] | undefined;
    leads?: UserCoreDto[] | undefined;
    admins?: UserCoreDto[] | undefined;
    attendees?: UserCoreDto[] | undefined;
    invitees?: UserCoreDto[] | undefined;
    customLeads?: UserCoreDto[] | undefined;
    customAdmins?: UserCoreDto[] | undefined;
    customAttendees?: UserCoreDto[] | undefined;
    customInvitees?: UserCoreDto[] | undefined;
}

export interface MeetingTypeRequestDto {
    name?: string | undefined;
}

export interface MeetingTypeDto extends MeetingTypeRequestDto {
    id: string;
    jobId?: number | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    folderId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    meetings?: MeetingListDto[] | undefined;
}

export interface MeetingListDto {
    id: string;
    title?: string | undefined;
    status?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    jobId?: number | undefined;
    exportId?: string | undefined;
    createdById?: number | undefined;
    createdBy?: UserCoreDto | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    meetingTypeId?: string | undefined;
    meetingType?: MeetingTypeDto | undefined;
}

export interface MeetingTopicRequestDto {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    notepad?: string | undefined;
    attachmentsToAdd?: AttachmentDto[] | undefined;
    attachmentsToRemove?: AttachmentDto[] | undefined;
}

export interface MeetingTopicDto extends MeetingTopicRequestDto {
    id: string;
    meetingId?: string | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    issues?: TopicIssueDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export interface TopicIssueRequestDto {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    priority?: string | undefined;
    dueDate?: Date | undefined;
    complete?: boolean | undefined;
    assignee?: UserCoreDto | undefined;
}

export interface TopicIssueDto extends TopicIssueRequestDto {
    id: string;
    meetingId?: string | undefined;
    topicId?: string | undefined;
    jobId?: number | undefined;
    assigneeId?: number | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    comments?: IssueCommentDto[] | undefined;
    topics?: TopicIssueTopicDto[] | undefined;
}

export interface TopicIssueTopicDto {
    topic?: TopicSummaryDto | undefined;
}

export interface TopicSummaryDto {
    title?: string | undefined;
    jobId?: number | undefined;
    meeting?: MeetingSummaryDto | undefined;
}

export interface MeetingSummaryDto {
    id: string;
    title?: string | undefined;
    meetingType?: MeetingTypeDto | undefined;
}

export interface MeetingRequestDto {
    id?: string | undefined;
    title?: string | undefined;
    status?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    meetingTypeId?: string | undefined;
    meetingType?: MeetingTypeDto | undefined;
    leads?: UserReferenceDto[] | undefined;
    admins?: UserReferenceDto[] | undefined;
    attendees?: UserReferenceDto[] | undefined;
    invitees?: UserReferenceDto[] | undefined;
    customLeads?: UserCoreDto[] | undefined;
    customAdmins?: UserCoreDto[] | undefined;
    customAttendees?: UserCoreDto[] | undefined;
    customInvitees?: UserCoreDto[] | undefined;
}

/** Lightweight DTO for referencing a user by ID only. Used in request DTOs where only the user ID is needed. */
export interface UserReferenceDto {
    id: number;
}

export interface DocumentPublishDto {
    id: string;
    name?: string | undefined;
}

export interface TopicIssueWithStatsDto {
    issues: TopicIssueDto[];
    pastDue: number;
    priority: number;
    open: number;
    myItems: number;
}

export interface MilestonePhaseItemListRequest {
    phase?: string | undefined;
    default?: boolean | undefined;
    milestoneTemplateId?: string | undefined;
}

export interface MilestonePhaseItemMoveRequestDto {
    direction: MilestoneMoveDirection;
}

export enum MilestoneMoveDirection {
    Up = 0,
    Down = 1,
}

export interface MilestoneLinkDto {
    id: string;
    resource: string;
    itemNumber?: string | undefined;
    title?: string | undefined;
    status?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface MilestoneTemplateRequestDto {
    id?: string | undefined;
    name?: string | undefined;
    active?: boolean | undefined;
    offices?: OfficeReferenceDto[] | undefined;
}

export interface MilestoneTemplateDto extends MilestoneTemplateRequestDto {
    id: string;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: UserCoreDto | undefined;
    offices?: OrganizationOfficeDto[] | undefined;
}

export interface OfficeReferenceDto {
    id: number;
}

export interface MilestoneTemplateWithPhasesDto {
    template: MilestoneTemplateDto;
    phases: MilestonePhaseDto[];
}

/** Composer defaults for an event type (GET /preview). */
export interface NotificationPreviewDto {
    eventType: string;
    subject?: string | undefined;
    bodyHtml?: string | undefined;
    to: RecipientDto[];
    cc: RecipientDto[];
    attachPdf: boolean;
}

/** One row in the notification history for a resource (GET /). */
export interface NotificationHistoryDto {
    id: string;
    eventType: string;
    subject?: string | undefined;
    status: string;
    skipReason?: string | undefined;
    attachPdf: boolean;
    sentByUserId?: number | undefined;
    sentAt?: Date | undefined;
    createdAt: Date;
    to: RecipientDto[];
    cc: RecipientDto[];
    bcc: RecipientDto[];
}

export interface PayCodeListRequest {
    name?: string | undefined;
}

/** Paginated response wrapper */
export interface PaginatedPostResponse {
    data: PostDto[];
    meta: PostPaginationMeta;
}

export interface PostPaginationMeta {
    currentPage: number;
    firstPage: number;
    lastPage: number;
    perPage: number;
    total: number;
}

/** Request DTO for search/filter endpoint */
export interface PostSearchRequestDto {
    filters?: PostFilterDto | undefined;
}

export interface PostFilterDto {
    visibility: string;
    critical: boolean;
    constraint: boolean;
    cost: boolean;
    ctc: boolean;
    assigned: boolean;
    assignedToMe: boolean;
    createdByMe: boolean;
    resolved: string;
    changeId?: string | undefined;
    transmittalId?: string | undefined;
}

/** Request DTO for creating/updating posts */
export interface PostRequestDto {
    subject?: string | undefined;
    content: string;
    plainTextContent: string;
    visibility?: string | undefined;
    cost?: boolean | undefined;
    critical?: boolean | undefined;
    constraint?: boolean | undefined;
    ctc?: boolean | undefined;
    resolved?: boolean | undefined;
    date?: Date | undefined;
    assignedTo?: UserReferenceDto | undefined;
    mentions?: UserReferenceDto[] | undefined;
    groups?: OrganizationRoleReferenceDto[] | undefined;
    documents?: DocumentReferenceDto[] | undefined;
    files?: AttachmentIdDto[] | undefined;
    filesToRemove?: string[] | undefined;
    links?: PostLinkItemDto[] | undefined;
}

/** Reference DTO for organization roles in requests */
export interface OrganizationRoleReferenceDto {
    id: number;
}

/** Reference DTO for documents in requests */
export interface DocumentReferenceDto {
    id: string;
}

/** Request DTO for resolve endpoint */
export interface PostResolveRequestDto {
    resolved: boolean;
}

export interface PostCommentRequestDto {
    comment: string;
}

/** Request DTO for link/document search */
export interface PostSearchQueryDto {
    query?: string | undefined;
}

export interface ProactSettingDto {
    apiConnectionId?: string | undefined;
    apiConnectionName?: string | undefined;
    inspectionsPath: string;
    isEnabled: boolean;
    updatedAt: Date;
}

export interface UpdateProactSettingRequest {
    apiConnectionId?: string | undefined;
    inspectionsPath: string;
    isEnabled: boolean;
}

export interface RateRequest {
    rate1?: string | undefined;
    rateMeasurement?: string | undefined;
    label?: string | undefined;
    category?: string | undefined;
    quantity?: string | undefined;
}

/** DTO for RFI responses */
export interface RfiDto {
    id: string;
    rfiId: number;
    rfiNumber?: string | undefined;
    uid?: string | undefined;
    costDays?: string | undefined;
    costDollars?: string | undefined;
    externalRfiNumber?: string | undefined;
    from?: string | undefined;
    fromCompany?: string | undefined;
    impact?: string | undefined;
    impactNotes?: string | undefined;
    question?: string | undefined;
    recommendation?: string | undefined;
    responseToImpacts?: string | undefined;
    responseToQuestions?: string | undefined;
    responseFrom?: string | undefined;
    responseDate?: Date | undefined;
    slug?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    submittedOn?: Date | undefined;
    workflowId?: number | undefined;
    fromUserId?: number | undefined;
    reporterUserId?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    needDate?: Date | undefined;
    externalContact?: string | undefined;
    submittedToContactId?: string | undefined;
    attentionContactId?: string | undefined;
    /** Whole days from creation until the response date, or until now while still open. */
    daysOpen?: number | undefined;
    fromUser?: UserCoreDto | undefined;
    reporter?: UserCoreDto | undefined;
    job?: RfiJobDto | undefined;
    workflow?: WorkflowDto | undefined;
    submittedToContact?: WorkflowContactDto | undefined;
    attentionContact?: WorkflowContactDto | undefined;
    attachments?: ResourceAttachmentDto[] | undefined;
    responseAttachments?: ResourceAttachmentDto[] | undefined;
    history?: RfiHistoryDto[] | undefined;
}

/** Minimal job info for RFI */
export interface RfiJobDto {
    id: number;
    jobNumber?: string | undefined;
    name?: string | undefined;
    rfiWorkflowId?: number | undefined;
    rfiWorkflow?: WorkflowDto | undefined;
}

/** History entry DTO for RFI */
export interface RfiHistoryDto {
    id: number;
    resource?: string | undefined;
    resourceTitle?: string | undefined;
    action?: string | undefined;
    fields?: string | undefined;
    person?: string | undefined;
    statusChange?: boolean | undefined;
    previousStatus?: string | undefined;
    updatedStatus?: string | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
}

/** A job document offered as an attach-from-system option for an RFI. */
export interface RfiDocumentOptionDto {
    id: string;
    name?: string | undefined;
    path?: string | undefined;
    type?: string | undefined;
}

/** Request DTO for creating or updating an RFI */
export interface RfiRequestDto {
    id?: string | undefined;
    costDays?: string | undefined;
    costDollars?: string | undefined;
    externalRfiNumber?: string | undefined;
    from?: string | undefined;
    fromCompany?: string | undefined;
    impact?: string | undefined;
    impactNotes?: string | undefined;
    question?: string | undefined;
    recommendation?: string | undefined;
    responseToImpacts?: string | undefined;
    responseToQuestions?: string | undefined;
    responseFrom?: string | undefined;
    responseDate?: Date | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    workflowId?: number | undefined;
    fromUserId?: number | undefined;
    reporterUserId?: number | undefined;
    needDate?: Date | undefined;
    externalContact?: any | undefined;
    submittedToContactId?: string | undefined;
    attentionContactId?: string | undefined;
    filesToAdd?: AttachmentIdDto[] | undefined;
    filesToRemove?: AttachmentIdDto[] | undefined;
    responsesToAdd?: AttachmentIdDto[] | undefined;
    responsesToRemove?: AttachmentIdDto[] | undefined;
    saveOnly: boolean;
    notification?: NotificationCompositionRequest | undefined;
}

/** Request DTO for external RFI updates (from external users) */
export interface RfiExternalUpdateDto {
    responseToImpacts?: string | undefined;
    responseToQuestions?: string | undefined;
    responseFrom?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    filesToAdd?: AttachmentIdDto[] | undefined;
    filesToRemove?: AttachmentIdDto[] | undefined;
    responsesToAdd?: AttachmentIdDto[] | undefined;
    responsesToRemove?: AttachmentIdDto[] | undefined;
}

/** Request to attach an existing job document to an RFI. */
export interface RfiAttachFromDocumentRequest {
    documentId: string;
}

/** Response for PDF links */
export interface RfiPdfLinkDto {
    documentId?: string | undefined;
    name?: string | undefined;
    path?: string | undefined;
}

/** Slim RFI row for the cross-job overview list. Carries only the fields the overview table renders plus its owning job, and a status-color-only workflow (no user/role graph). */
export interface RfiOverviewDto {
    id: string;
    rfiNumber?: string | undefined;
    question?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    needDate?: Date | undefined;
    createdAt?: Date | undefined;
    responseDate?: Date | undefined;
    /** Whole days from creation until the response date, or until now while still open. */
    daysOpen?: number | undefined;
    contractorName?: string | undefined;
    reporterName?: string | undefined;
    assigneeName?: string | undefined;
    jobId: number;
    jobNumber?: string | undefined;
    jobName?: string | undefined;
    workflowId?: number | undefined;
    workflow?: OverviewWorkflowDto | undefined;
}

export interface ScimIntegrationDto {
    id: string;
    name: string;
    apiConnectionId: string;
    apiConnectionName: string;
    scimPath: string;
    isEnabled: boolean;
    deleteBehavior: string;
    createdAt: Date;
    updatedAt: Date;
    userMappingCount: number;
    lastSyncedAt?: Date | undefined;
}

export interface CreateScimIntegrationRequest {
    name: string;
    apiConnectionId: string;
    scimPath: string;
    deleteBehavior: string;
}

export interface UpdateScimIntegrationRequest {
    name: string;
    apiConnectionId: string;
    scimPath: string;
    deleteBehavior: string;
    isEnabled: boolean;
}

export interface ScimTestResult {
    success: boolean;
    error?: string | undefined;
}

export interface ScimUserMappingDto {
    id: string;
    userId: number;
    userName?: string | undefined;
    userEmail?: string | undefined;
    remoteScimId?: string | undefined;
    syncStatus: string;
    lastSyncedAt?: Date | undefined;
    lastError?: string | undefined;
}

export interface ScimSyncLogResponse {
    logs: ScimSyncLogDto[];
    retentionDays: number;
    totalCount: number;
}

export interface ScimSyncLogDto {
    id: string;
    userId: number;
    userEmail?: string | undefined;
    operation: string;
    httpMethod: string;
    requestUrl: string;
    responseStatus?: number | undefined;
    succeeded: boolean;
    errorMessage?: string | undefined;
    createdAt: Date;
}

export interface ScimSyncLogDetailDto extends ScimSyncLogDto {
    requestBody?: string | undefined;
    responseBody?: string | undefined;
}

export interface ServiceJobListRequest {
    userId?: number | undefined;
    officeId?: number | undefined;
    includeArchived?: boolean | undefined;
}

export interface ServiceWorkOrderSearchResultDto {
    items: ServiceWorkOrderDto[];
    /** True when more matches exist beyond the returned page, signalling the user to refine the search. */
    hasMore: boolean;
}

export interface ServiceWorkOrderDto {
    serviceCallId: string;
    serviceDescription?: string | undefined;
    statusOfCall?: string | undefined;
    custnmbr?: string | undefined;
    adrscode?: string | undefined;
}

/** DTO for Submittal responses */
export interface SubmittalDto {
    id: string;
    submittalId: number;
    submittalNumber?: string | undefined;
    jobNumber?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    title?: string | undefined;
    type?: string | undefined;
    intentOfReview?: string | undefined;
    externalSubmittalNumber?: string | undefined;
    company?: string | undefined;
    submittedOn?: Date | undefined;
    workflowId?: number | undefined;
    reporterUserId?: number | undefined;
    assigneeUserId?: number | undefined;
    jobId?: number | undefined;
    milestonePhaseItemId?: string | undefined;
    submittedToContactId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    daysOpen?: number | undefined;
    reporter?: UserCoreDto | undefined;
    assignee?: UserCoreDto | undefined;
    job?: SubmittalJobDto | undefined;
    workflow?: WorkflowDto | undefined;
    submittedToContact?: WorkflowContactDto | undefined;
    attachments?: ResourceAttachmentDto[] | undefined;
    revisions?: ResourceAttachmentDto[] | undefined;
    history?: SubmittalHistoryDto[] | undefined;
}

/** Minimal job info for Submittal */
export interface SubmittalJobDto {
    id: number;
    jobNumber?: string | undefined;
    name?: string | undefined;
    submittalWorkflowId?: number | undefined;
    submittalWorkflow?: WorkflowDto | undefined;
}

/** History entry DTO for Submittal */
export interface SubmittalHistoryDto {
    id: number;
    resource?: string | undefined;
    resourceTitle?: string | undefined;
    action?: string | undefined;
    fields?: string | undefined;
    person?: string | undefined;
    statusChange?: boolean | undefined;
    previousStatus?: string | undefined;
    updatedStatus?: string | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
}

/** A job document offered as an attach-from-system option for a Submittal. */
export interface SubmittalDocumentOptionDto {
    id: string;
    name?: string | undefined;
    path?: string | undefined;
    type?: string | undefined;
}

/** Request DTO for creating or updating a Submittal */
export interface SubmittalRequestDto {
    id?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    intentOfReview?: string | undefined;
    externalSubmittalNumber?: string | undefined;
    company?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    workflowId?: number | undefined;
    assigneeUserId?: number | undefined;
    reporterUserId?: number | undefined;
    milestonePhaseItemId?: string | undefined;
    submittedToContactId?: string | undefined;
    filesToAdd?: AttachmentIdDto[] | undefined;
    filesToRemove?: AttachmentIdDto[] | undefined;
    saveOnly: boolean;
    notification?: NotificationCompositionRequest | undefined;
}

/** Request to attach an existing job document to a Submittal. */
export interface SubmittalAttachFromDocumentRequest {
    documentId: string;
}

export interface GetTimesheetReportRequest {
    officeId: number;
    week: number;
    year: number;
    userId?: number | undefined;
    onlyMyTeam?: boolean | undefined;
    /** The viewer's IANA time zone id for the generated-at time; UTC when absent or unknown. */
    timeZone?: string | undefined;
}

/** TimeZone is the viewer's IANA time zone id, used for the generated-at, signature and history times; UTC when absent or unknown. */
export interface GetAuditReportRequest {
    officeId: number;
    userId: number;
    jobId?: number | undefined;
    startDate: Date;
    endDate: Date;
    timeZone?: string | undefined;
}

export interface GetTimesheetExcelExportRequest {
    officeId: number;
    weekId: number;
    year: number;
    weekEndDisplayDate: Date;
    userId?: number | undefined;
    onlyMyTeam?: boolean | undefined;
}

export interface TimesheetWeekHoursDto {
    userId: number;
    year: number;
    weekId: number;
    timesheets: TimesheetWeekHoursItemDto[];
}

export interface TimesheetWeekHoursItemDto {
    timesheetId: string;
    jobId?: number | undefined;
    jobName?: string | undefined;
    hoursByPayCode: TimesheetPayCodeHoursDto[];
}

export interface TimesheetPayCodeHoursDto {
    payCodeName: string;
    hours: number;
    sat: number;
    sun: number;
    mon: number;
    tue: number;
    wed: number;
    thu: number;
    fri: number;
}

export interface TimesheetRequestDto {
    id: string;
    archived?: boolean | undefined;
    status?: string | undefined;
    jobNumber?: string | undefined;
    weekId?: number | undefined;
    year?: number | undefined;
    userId?: number | undefined;
    createdById: number;
    jobId: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    workflowId?: number | undefined;
    stepIndex?: number | undefined;
    isRejected?: boolean | undefined;
    rejectJustification?: string | undefined;
    signature?: any | undefined;
    signedBy?: string | undefined;
    signatureString?: string | undefined;
    signedOn?: Date | undefined;
    isComplete: boolean;
    updateReason?: string | undefined;
    requestedRows: TimesheetRowRequestDto[];
}

export interface TimesheetDto extends TimesheetRequestDto {
    createdBy?: UserCoreDto | undefined;
    job?: JobDto | undefined;
    user?: UserCoreDto | undefined;
    workflow?: WorkflowDto | undefined;
    rows: TimesheetRowDto[];
    timesheetHistory: TimesheetHistoryDto[];
    payCodes?: PayCodeDto[] | undefined;
}

export interface HoursByDay {
    sun: number;
    mon: number;
    tue: number;
    wed: number;
    thu: number;
    fri: number;
    sat: number;
    total: number;
}

export interface TimesheetRowRequestDto extends HoursByDay {
    id?: string | undefined;
    timesheetId: string;
    startAt?: Date | undefined;
    endAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    wbsAccountId?: string | undefined;
    wbsAccountAdjustmentId?: string | undefined;
    payCodeId?: string | undefined;
    serviceDescription?: string | undefined;
    serviceLocation?: string | undefined;
    serviceCallId?: string | undefined;
}

export interface TimesheetRowDto extends TimesheetRowRequestDto {
    wbsAccount?: WbsAccountDto | undefined;
    wbsAccountAdjustment?: WbsAdjustmentDto | undefined;
    payCode?: PayCodeDto | undefined;
    baseRate?: number | undefined;
    fringeRate?: number | undefined;
    payCodeRateModifierMultiplier?: number | undefined;
    levelRateModifierPercent?: number | undefined;
    effectiveRate?: number | undefined;
    isScalePay?: boolean | undefined;
    scaleBaseRate?: number | undefined;
    scaleFringeRate?: number | undefined;
    effectiveScaleBaseRate?: number | undefined;
    effectiveScaleFringeRate?: number | undefined;
    scalePayAdjustmentAmount?: number | undefined;
    bypassScalePay?: boolean | undefined;
    payCodeColor?: string | undefined;
    breakdownInstructions?: RateBreakdownInstructions | undefined;
}

/** Full render-instruction payload for the EffectiveRateBreakdown UI. The frontend renders directly from this without re-deriving any scenario decisions. */
export interface RateBreakdownInstructions {
    scenario: RateBreakdownScenario;
    isOvertime: boolean;
    badge?: RateBreakdownBadge | undefined;
    formulaTitle: string;
    formulaSteps: RateFormulaStep[];
    scaleDerivation?: RateScaleDerivation | undefined;
    scaleOvertimeDerivation?: RateScaleOvertimeDerivation | undefined;
    scaleNotAppliedDerivation?: RateScaleNotAppliedDerivation | undefined;
}

/** Which rate-calculation scenario the breakdown is describing. Determines badges, formula structure, and whether scale derivation lines are shown. */
export enum RateBreakdownScenario {
    NonScale = 0,
    ScaleBypassed = 1,
    ScaleNotApplied = 2,
    ScaleApplied = 3,
    ScaleOvertime = 4,
}

export interface RateBreakdownBadge {
    label: string;
    color: string;
}

export interface RateFormulaStep {
    kind: RateFormulaStepKind;
    label: string;
    value: number;
    format: RateFormulaValueFormat;
    operatorAfter?: string | undefined;
    highlight: boolean;
    span: number;
}

/** Identifies the semantic role of a step in the rendered formula. Frontend may key off this for testing or styling without parsing labels. */
export enum RateFormulaStepKind {
    BaseRate = 0,
    PayCodeMultiplier = 1,
    ScaleAdjustment = 2,
    EffectiveRate = 3,
    EffectiveScaleBaseRate = 4,
    FringeDelta = 5,
}

/** How the frontend should format the numeric Value of a formula step. */
export enum RateFormulaValueFormat {
    Currency = 0,
    Multiplier = 1,
}

/** Numbers required to render the multi-line "scale adjustment" derivation block shown above the formula in the ScaleApplied scenario. */
export interface RateScaleDerivation {
    scaleBaseRate?: number | undefined;
    effectiveScaleBaseRate?: number | undefined;
    scaleFringeRate?: number | undefined;
    effectiveScaleFringeRate?: number | undefined;
    levelRateModifierPercent?: number | undefined;
    baseRate: number;
    baseBenefitRate: number;
    actualTotalComp: number;
    scaleTotalComp: number;
    scalePayAdjustmentAmount: number;
}

/** Numbers required to render the derivation block for the ScaleOvertime scenario. The scale OT formula layers the scale-fringe-minus-benefit delta on top of the scale base × multiplier — a fundamentally different derivation than ScaleApplied. BaseBenefitRate is nullable because rows reconstructed from persisted fields don't have it; in that case the frontend falls back to showing fringeDelta alone. */
export interface RateScaleOvertimeDerivation {
    scaleBaseRate?: number | undefined;
    effectiveScaleBaseRate?: number | undefined;
    scaleFringeRate?: number | undefined;
    effectiveScaleFringeRate?: number | undefined;
    levelRateModifierPercent?: number | undefined;
    baseBenefitRate?: number | undefined;
    fringeDelta: number;
}

/** Diagnostic info for the ScaleNotApplied scenario. JobClassificationLevelRateFound is null for legacy persisted rows (FE treats null as the gray "base higher" case). Name fields are null on the persisted-row path; only populated by the live-preview controller. */
export interface RateScaleNotAppliedDerivation {
    jobClassificationLevelRateFound?: boolean | undefined;
    scaleBaseRate?: number | undefined;
    effectiveScaleBaseRate?: number | undefined;
    scaleFringeRate?: number | undefined;
    effectiveScaleFringeRate?: number | undefined;
    levelRateModifierPercent?: number | undefined;
    baseRate: number;
    baseBenefitRate?: number | undefined;
    userClassificationName?: string | undefined;
    jobConfiguredClassificationNames?: string[] | undefined;
}

export interface TimesheetHistoryDto {
    id: string;
    timesheetId?: string | undefined;
    oldStatus?: string | undefined;
    newStatus?: string | undefined;
    message?: string | undefined;
    createdById?: number | undefined;
    createdAt?: Date | undefined;
    createdBy?: UserCoreDto | undefined;
}

export interface GetTimesheetRequest {
    timesheetId?: string | undefined;
    jobId?: number | undefined;
    weekId?: number | undefined;
    year?: number | undefined;
    userId?: number | undefined;
}

export interface GetTimesheetsRequest {
    jobId?: number | undefined;
    weekId?: number | undefined;
    year?: number | undefined;
    officeId?: number | undefined;
    userId?: number | undefined;
    supervisorId?: number | undefined;
    status?: string | undefined;
    includeJob?: boolean | undefined;
    includeWorkflows?: boolean | undefined;
    dailyContext?: boolean | undefined;
}

export interface MissingTimesheetUserRow {
    id: number;
    firstName: string;
    lastName: string;
    employeeId?: string | undefined;
    email: string;
    totals: HoursByDay;
}

export interface GetMissingTimesheetsRequest {
    showMyTeam?: boolean | undefined;
}

export interface BulkTransitionTimesheetsRequest {
    timesheets: BulkTransitionItem[];
}

export interface BulkTransitionItem {
    id: string;
    status: string;
    stepIndex: number;
    isComplete: boolean;
}

export interface UpdateExternalTimesheetRequest {
    status: string;
    justification?: string | undefined;
    signature?: string | undefined;
    signedBy?: string | undefined;
}

export interface CombinedTimesheetReviewDto {
    batchId: string;
    token: string;
    userId: number;
    user: UserCoreDto;
    weekId: number;
    year: number;
    weekEnding: string;
    totalHours: number;
    notificationType: string;
    actionRequiredTimesheets: BatchTimesheetItemDto[];
    referenceTimesheets: BatchTimesheetItemDto[];
    expiresAt: Date;
    payCodes: PayCodeDto[];
}

export interface BatchTimesheetItemDto {
    id: string;
    jobNumber?: string | undefined;
    jobName?: string | undefined;
    jobType?: string | undefined;
    totalHours: number;
    status?: string | undefined;
    currentStepLabel?: string | undefined;
    requiresAction: boolean;
    fullTimesheet?: TimesheetDto | undefined;
}

export interface BulkBatchApprovalRequest {
    action: string;
    signature?: string | undefined;
    signedBy?: string | undefined;
    justification?: string | undefined;
    rejectTimesheetIds?: string[] | undefined;
}

/** Wraps an EffectiveRateCalculation alongside its render instructions so the PreviewEffectiveRate endpoint can return both in a single call. */
export interface EffectiveRateCalculationResponse {
    calculation: EffectiveRateCalculation;
    instructions: RateBreakdownInstructions;
}

export interface EffectiveRateCalculation {
    effectiveRate: number;
    baseRate: number;
    fringeRate: number;
    payCodeMultiplier: number;
    isScalePay: boolean;
    scaleBaseRate?: number | undefined;
    scaleFringeRate?: number | undefined;
    effectiveScaleBaseRate?: number | undefined;
    effectiveScaleFringeRate?: number | undefined;
    levelRateModifierPercent?: number | undefined;
    scalePayAdjustmentAmount?: number | undefined;
    bypassScalePay: boolean;
    baseBenefitRate?: number | undefined;
    jobClassificationLevelRateFound?: boolean | undefined;
}

export interface PreviewEffectiveRateRequest {
    userId: number;
    jobId: number;
    payCodeId: string;
    wbsAccountId?: string | undefined;
}

/** DTO for Transmittal responses */
export interface TransmittalDto {
    id: string;
    transmittalNumber?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    title?: string | undefined;
    notes?: string | undefined;
    externalContact?: any | undefined;
    submittedToContactId?: string | undefined;
    dateSent?: Date | undefined;
    workflowId?: number | undefined;
    fromUserId?: number | undefined;
    assigneeUserId?: number | undefined;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    fromUser?: UserCoreDto | undefined;
    assignee?: UserCoreDto | undefined;
    job?: TransmittalJobDto | undefined;
    workflow?: WorkflowDto | undefined;
    submittedToContact?: WorkflowContactDto | undefined;
    documents?: ResourceAttachmentDto[] | undefined;
    history?: TransmittalHistoryDto[] | undefined;
}

/** Minimal job info for Transmittal */
export interface TransmittalJobDto {
    id: number;
    jobNumber?: string | undefined;
    name?: string | undefined;
    transmittalWorkflowId?: number | undefined;
    transmittalWorkflow?: WorkflowDto | undefined;
}

/** History entry DTO for Transmittal */
export interface TransmittalHistoryDto {
    id: number;
    resource?: string | undefined;
    resourceTitle?: string | undefined;
    action?: string | undefined;
    fields?: string | undefined;
    person?: string | undefined;
    statusChange?: boolean | undefined;
    previousStatus?: string | undefined;
    updatedStatus?: string | undefined;
    userId?: number | undefined;
    createdAt?: Date | undefined;
}

/** Response for PDF links */
export interface TransmittalPdfLinkDto {
    documentId?: string | undefined;
    name?: string | undefined;
    path?: string | undefined;
}

/** Response for PDF options (available PDFs to attach) */
export interface TransmittalPdfOptionDto {
    id: string;
    name?: string | undefined;
    path?: string | undefined;
    type?: string | undefined;
}

/** Request DTO for creating or updating a Transmittal */
export interface TransmittalRequestDto {
    id?: string | undefined;
    title?: string | undefined;
    status?: string | undefined;
    stepIndex?: number | undefined;
    notes?: string | undefined;
    dateSent?: Date | undefined;
    externalContact?: any | undefined;
    submittedToContactId?: string | undefined;
    workflowId?: number | undefined;
    assigneeUserId?: number | undefined;
    filesToAdd?: AttachmentIdDto[] | undefined;
    filesToRemove?: AttachmentIdDto[] | undefined;
    saveOnly: boolean;
    notification?: NotificationCompositionRequest | undefined;
}

/** Request DTO for external transmittal updates */
export interface TransmittalExternalUpdateDto {
    status?: string | undefined;
    stepIndex?: number | undefined;
}

/** Request to attach an existing job document to a Transmittal. */
export interface TransmittalAttachFromDocumentRequest {
    documentId: string;
}

export interface UnitPricing {
    id: string;
    description?: string | undefined;
    grouping?: string | undefined;
    pricing?: number | undefined;
    bulkRate?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

/** Minimal user record for name-search pickers. */
export interface UserSearchDto {
    id: number;
    displayName: string;
    primaryOfficeName?: string | undefined;
}

export interface UserLoginDto {
    id: number;
    userId?: number | undefined;
    ip?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    user?: UserDto | undefined;
}

/** A generic wrapper for paginated API responses. */
export interface PagedResultOfUserLoginDto {
    /** The items for the current page. */
    items: UserLoginDto[];
    /** The total number of items across all pages. */
    totalCount: number;
    /** The current page number (1-based). */
    page: number;
    /** The number of items per page. */
    pageSize: number;
    /** The total number of pages. */
    totalPages: number;
    /** Whether there is a previous page. */
    hasPreviousPage: boolean;
    /** Whether there is a next page. */
    hasNextPage: boolean;
}

/** Request DTO for inviting/creating a new user. */
export interface InviteUserRequest {
    firstName: string;
    lastName: string;
    email: string;
    employeeId?: string | undefined;
    supervisorId?: number | undefined;
    disableDivisionAccess?: boolean | undefined;
    restrictDivisionAccess?: boolean | undefined;
    divisionIds?: number[] | undefined;
    allowedJobIds: number[];
    allowedCtcJobNumbers: string[];
    roleIds: number[];
    officeIds: number[];
    primaryOfficeId?: number | undefined;
}

/** Request DTO for updating an existing user. */
export interface UpdateUserRequest extends InviteUserRequest {
}

/** Request DTO for updating user status only. */
export interface UpdateUserStatusRequest {
    status: string;
}

export interface UserNotificationDto {
    id: string;
    message?: string | undefined;
    action?: string | undefined;
    read?: boolean | undefined;
    jobId?: number | undefined;
    userId?: number | undefined;
    personId?: number | undefined;
    postId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    user?: UserCoreDto | undefined;
    person?: UserCoreDto | undefined;
    job?: NotificationJobDto | undefined;
}

/** Lightweight Job DTO for notifications (avoids complex nested mappings) */
export interface NotificationJobDto {
    id: number;
    name?: string | undefined;
    jobNumber?: string | undefined;
}

export interface UserNotificationListRequest {
    unread?: boolean | undefined;
}

export interface UserNotificationMarkReadRequest {
    postId?: string | undefined;
}

/** Request body for PUT user/me/notification-channels. The authenticated user is authoritative — no user id is carried on the request. */
export interface UpdateNotificationChannelsRequest {
    channels: string[];
}

/** Request body for POST user/me/sms-consent. Consent acceptance happens implicitly via the phone verify flow — the only decision this endpoint accepts today is "declined". */
export interface SmsConsentDecisionRequest {
    decision: string;
}

/** Request body for POST user/me/phone/request-verification. */
export interface RequestPhoneVerificationRequest {
    phoneNumber: string;
}

/** Request body for POST user/me/phone/verify. */
export interface VerifyPhoneRequest {
    code: string;
}

export interface UserRateDto extends UserCoreDto {
    hourlyRate?: number | undefined;
    healthInsurance?: number | undefined;
    basicLife?: number | undefined;
    accidentalDeath?: number | undefined;
    holiday?: number | undefined;
    _401k?: number | undefined;
    vac?: number | undefined;
    hireDate?: Date | undefined;
    rateImportKey?: string | undefined;
    userOrganizationOffice?: UserOrganizationOfficeDto[] | undefined;
}

export interface UserListRequest {
    userId?: number | undefined;
    classificationLevelId?: string | undefined;
}

export interface UserRateRequestDto {
    id: number;
    hourlyRate?: number | undefined;
    healthInsurance?: number | undefined;
    basicLife?: number | undefined;
    accidentalDeath?: number | undefined;
    holiday?: number | undefined;
    _401k?: number | undefined;
    vac?: number | undefined;
    hireDate?: Date | undefined;
    classificationId?: string | undefined;
    classificationLevelId?: string | undefined;
    rateImportKey?: string | undefined;
}

export interface UserRateImportResult {
    successfulRows: SuccessfulImportRow[];
    failedRows: FailedImportRow[];
    totalRowsProcessed: number;
}

export interface SuccessfulImportRow {
    rowNumber: number;
    userId: number;
    name: string;
}

export interface FailedImportRow {
    rowNumber: number;
    name: string;
    errors: string[];
}

export interface CostCodeDto {
    id: string;
    code: string;
    name: string;
    isServiceCode: boolean;
    usage: number;
    offices?: OrganizationOfficeDto[] | undefined;
}

export interface WbsCostCodeDetailsResponse {
    id: string;
    code: string;
    name: string;
    usage: number;
    offices: OrganizationOfficeDto[];
}

export interface CostCodeRequestDto {
    code?: string | undefined;
    name?: string | undefined;
    offices?: OfficeRef[] | undefined;
}

export interface OfficeRef {
    organizationOfficeId: number;
}

export interface WbsTreeResponse {
    id: string;
    jobId?: number | undefined;
    bookedDate?: Date | undefined;
    projectFinalDate?: Date | undefined;
    designStartDate?: Date | undefined;
    submittalDueDate?: Date | undefined;
    materialOnJobDate?: Date | undefined;
    installStartDate?: Date | undefined;
    installCompleteDate?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    wbsAccount: WbsAccountResponse[];
}

export interface WbsAccountResponse {
    id: string;
    wbsId?: string | undefined;
    parentId?: string | undefined;
    externalWbsId?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    apply?: boolean | undefined;
    active?: boolean | undefined;
    archived?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isLeaf?: boolean | undefined;
    startDate?: Date | undefined;
    finishDate?: Date | undefined;
    costCodeId?: string | undefined;
    initialQuantityEstimate: number;
    currentQuantityEstimate?: number | undefined;
    currentQuantityActual?: number | undefined;
    initialHoursEstimate?: number | undefined;
    currentHoursEstimate?: number | undefined;
    currentHoursActual?: number | undefined;
    accountType?: string | undefined;
    unitOfMeasure?: string | undefined;
    isCtcConnected: boolean;
    timesheetsOnly?: boolean | undefined;
    progressManaged: boolean;
    perDiemEligible: boolean;
    scalePayEnabled: boolean;
    costCode?: WbsCostCodeSimpleResponse | undefined;
    effectiveCostCode?: string | undefined;
    inverseParent: WbsAccountResponse[];
    parent?: WbsAccountResponse | undefined;
}

export interface WbsRequestDto {
    bookedDate?: Date | undefined;
    projectFinalDate?: Date | undefined;
    designStartDate?: Date | undefined;
    submittalDueDate?: Date | undefined;
    materialOnJobDate?: Date | undefined;
    installStartDate?: Date | undefined;
    installCompleteDate?: Date | undefined;
}

export interface WbsDto extends WbsRequestDto {
    id: string;
    jobId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface WbsAccountRequestDto {
    parentId?: string | undefined;
    externalWbsId?: string | undefined;
    costCodeId?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    accountType?: string | undefined;
    initialQuantityEstimate?: number | undefined;
    currentQuantityEstimate?: number | undefined;
    currentQuantityActual?: number | undefined;
    initialHoursEstimate?: number | undefined;
    currentHoursEstimate?: number | undefined;
    currentHoursActual?: number | undefined;
    unitOfMeasure?: string | undefined;
    apply?: boolean | undefined;
    active?: boolean | undefined;
    timesheetsOnly?: boolean | undefined;
    perDiemEligible?: boolean | undefined;
    scalePayEnabled?: boolean | undefined;
    startDate?: Date | undefined;
    finishDate?: Date | undefined;
}

export interface WbsTimesheetAccountDto {
    id: string;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    accountType?: string | undefined;
    unitOfMeasure?: string | undefined;
    costCodeId?: string | undefined;
    perDiemEligible: boolean;
    scalePayEnabled: boolean;
    costCode?: WbsCostCodeSimpleResponse | undefined;
}

export interface CtcRefreshResponseDto {
    addedCodes: string[];
    updatedCount: number;
    notInGpCodes: string[];
}

export interface Headers {

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}